// https://minify-js.com/
import {
  $4,
  $$4,
  $id4,
  isRTL,
  formatMoney,
  debounce,
  getterAdd,
  getterGet,
  getterRunFn,
  btnTooltip,
  Drawer,
  VariantChangeBase,
} from "global";

// WISHLIST
var $wishlist_list = $id4("hdt_wishlist_list"),
  $compare_list = $id4("hdt_compare_list"),
  nameCachedWishlist = "theme4:wishlist:id",
  nameCachedCompare = "theme4:compare:id";
// if exit $wishlist_list is use app wishlist the4
if ($wishlist_list) {
  var arr_wishlist_list = $wishlist_list.textContent
    ? $wishlist_list.textContent.split(" ")
    : [];
} else {
  var arr_wishlist_list = !localStorage.getItem(nameCachedWishlist)
    ? []
    : localStorage.getItem(nameCachedWishlist).split(","); // remove id: and conver array
}
if ($compare_list) {
  var arr_compare_list = $compare_list.textContent
    ? $compare_list.textContent.split(" ")
    : [];
} else {
  var arr_compare_list = !localStorage.getItem(nameCachedCompare)
    ? []
    : localStorage.getItem(nameCachedCompare).split(","); // remove id: and conver array
}
// arr_wishlist_list = [1234, 5678, 9011]
// arr_compare_list = [1234, 5678, 9011]

var linkWishlistApp = "/apps/ecomrise/wishlist",
  linkCompareApp = "/apps/ecomrise/compare",
  actionAfterWishlistAdded = themeHDN.extras.AddedWishlistRemove
    ? "remove"
    : "added",
  actionAfterCompareAdded = themeHDN.extras.AddedCompareRemove
    ? "remove"
    : "added",
  limitWishlist = $wishlist_list ? 100 : 50,
  limitCompare = 6,
  conver_to_link_fn = function (prefix = this.textFn, array = this.array) {
    const x = themeHDN.routes.search_url + `/?view=${prefix}`,
      y = x + "&type=product&options[unavailable_products]=last&q=";
    return array.length ? y + encodeURI(`id:${array.join(" OR id:")}`) : x;
  };
// Reset if limit change
if (arr_wishlist_list.length > limitWishlist) {
  arr_wishlist_list.splice(limitWishlist - 1, arr_wishlist_list.length - 1);
  localStorage.setItem(nameCachedWishlist, arr_wishlist_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageWishlist) {
  if (arr_wishlist_list.length && !window.isWishlistPerformed) {
    window.location.href = conver_to_link_fn("wishlist", arr_wishlist_list);
  } else {
    window.history.replaceState(
      {},
      document.title,
      conver_to_link_fn("wishlist", []),
    );
  }
  themeHDN.wisHref = conver_to_link_fn("wishlist", arr_wishlist_list);
}

// Reset if limit change
if (arr_compare_list.length > limitCompare) {
  arr_compare_list.splice(limitCompare - 1, arr_compare_list.length - 1);
  localStorage.setItem(nameCachedCompare, arr_compare_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageCompare) {
  if (arr_compare_list.length && !window.isComparePerformed) {
    window.location.href = conver_to_link_fn("compare", arr_compare_list);
  } else {
    window.history.replaceState(
      {},
      document.title,
      conver_to_link_fn("compare", []),
    );
  }
}
var _wishlist_id,
  _wishlist_handle,
  _update_wis_text,
  update_wis_text_fn,
  _update_wis_btns,
  update_wis_btns_fn,
  _click_wis,
  click_wis_fn,
  _add_wis,
  add_wis_fn,
  _remove_wis,
  remove_wis_fn,
  _action_after_remove_add,
  action_after_remove_add_fn,
  _show_popup_compare,
  show_popup_compare_fn,
  _conver_to_link;
class Wishlist extends btnTooltip {
  constructor() {
    super();
    getterAdd(_wishlist_id, this, this.dataset.id);
    getterAdd(_wishlist_handle, this, this.dataset.handle);
    getterAdd(_update_wis_text, this);
    getterAdd(_update_wis_btns, this);
    getterAdd(_click_wis, this);
    getterAdd(_add_wis, this);
    getterAdd(_remove_wis, this);
    getterAdd(_action_after_remove_add, this);
    getterAdd(_show_popup_compare, this);
    getterAdd(_conver_to_link, this);
    this.tabIndex = 0;
    this.addEventListener("click", () =>
      getterRunFn(_click_wis, this, click_wis_fn).call(this),
    );
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter")
        getterRunFn(_click_wis, this, click_wis_fn).call(this);
    });
  }
  static get observedAttributes() {
    return ["action"];
  }
  get isFnWishlist() {
    return true;
  }
  get textFn() {
    return "wishlist";
  }
  get isPageWishlistorCompare() {
    //add code check page
    return this.isFnWishlist ? window.isPageWishlist : window.isPageCompare;
  }
  get limit() {
    return this.isFnWishlist ? limitWishlist : limitCompare;
  }
  get nameCached() {
    return this.isFnWishlist ? nameCachedWishlist : nameCachedCompare;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get actionAfterAdded() {
    return this.isFnWishlist
      ? actionAfterWishlistAdded
      : actionAfterCompareAdded;
  }
  get action() {
    return this.getAttribute("action");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || (oldValue === null && newValue === "add"))
      return;
    getterRunFn(_update_wis_text, this, update_wis_text_fn).call(
      this,
      newValue,
    );
    super.attributeChangedCallback(name, oldValue, newValue);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.array.indexOf(getterGet(_wishlist_id, this)) > -1) {
      if (this.hasAttribute("remove-on-page")) {
        return;
      }
      this.setAttribute("action", this.actionAfterAdded);
    }
  }
}
_wishlist_id = new WeakMap();
_wishlist_handle = new WeakMap();
_update_wis_text = new WeakSet();
_update_wis_btns = new WeakSet();
_click_wis = new WeakSet();
_add_wis = new WeakSet();
_remove_wis = new WeakSet();
_action_after_remove_add = new WeakSet();
_conver_to_link = new WeakSet();
_show_popup_compare = new WeakSet();
update_wis_text_fn = function (value) {
  if (this.hasAttribute("remove-on-page")) return;
  const text =
      themeHDN.extras[`text_${this.isFnWishlist ? "wis" : "cp"}_${value}`],
    icon = themeHDN.extras[`icon_${this.isFnWishlist ? "wis" : "cp"}_${value}`];
  if (icon)
    this.firstElementChild.replaceWith(
      document.createRange().createContextualFragment(icon),
    );
  if (text) {
    this.lastElementChild.textContent = text;
    this.setAttribute("data-txt-tt", text);
  }
};
update_wis_btns_fn = function (_action) {
  // Update Button
  $$4(`hdt-${this.textFn}[data-id="${getterGet(_wishlist_id, this)}"]`).forEach(
    (btn) => {
      btn.setAttribute("action", _action);
    },
  );
  // Update Count and link
  document.dispatchEvent(
    new CustomEvent(`theme4:${this.textFn}:update`, {
      bubbles: true,
      detail: "the4", // arr_wishlist_list
    }),
  );
  if (window.isPageWishlist)
    themeHDN.wisHref = conver_to_link_fn("wishlist", arr_wishlist_list);
};
click_wis_fn = function (e) {
  if (this.action == "add") {
    // ADD
    getterRunFn(_add_wis, this, add_wis_fn).call(this);
  } else if (this.action === "added") {
    // ADDED: go to page wishlist
    if (!this.isFnWishlist && themeHDN.extras.enableComparePopup) {
      getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    } else {
      window.location.href = getterRunFn(
        _conver_to_link,
        this,
        conver_to_link_fn,
      ).call(this);
    }
  } else {
    // REMOVE
    getterRunFn(_remove_wis, this, remove_wis_fn).call(this);
  }
};
add_wis_fn = function (e) {
  if (
    ($wishlist_list && this.isFnWishlist) ||
    ($compare_list && !this.isFnWishlist)
  ) {
    // app wishlist
    this.setAttribute("aria-busy", true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: "add",
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.status != "success") {
          console.error(data.message || "Unknow error");
          return;
        }
        if (this.isFnWishlist) {
          arr_wishlist_list = JSON.parse(
            data.response.metafield.value,
          ).ecomrise_ids;
          if (!Array.isArray(arr_wishlist_list)) {
            arr_wishlist_list = arr_wishlist_list.split(",");
          }
        }
        if (!this.isFnWishlist) {
          arr_compare_list = JSON.parse(
            data.response.metafield.value,
          ).ecomrise_ids;
          if (!Array.isArray(arr_compare_list)) {
            arr_compare_list = arr_compare_list.split(",");
          }
          getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(
            this,
          );
        }
        getterRunFn(
          _action_after_remove_add,
          this,
          action_after_remove_add_fn,
        ).call(this, this.actionAfterAdded);
      })
      .catch(function (error) {
        console.log("Error: " + error);
      })
      .finally(() => {
        this.setAttribute("aria-busy", false);
      });
  } else {
    // local wishlist
    // adds the specified elements to the beginning of an array
    this.array.unshift(getterGet(_wishlist_id, this));
    if (this.array.length > this.limit) {
      // if over limit remove element on last array
      let arraySplice = this.array.splice(this.limit, 1);
      // arraySplice: allway has 1 element
      $$4(`hdt-${this.textFn}[data-id="${arraySplice[0]}"]`).forEach((btn) => {
        btn.setAttribute("action", "add");
      });
    }
    if (!this.isFnWishlist)
      getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    getterRunFn(
      _action_after_remove_add,
      this,
      action_after_remove_add_fn,
    ).call(this, this.actionAfterAdded);
    localStorage.setItem(this.nameCached, this.array.toString());
  }
};
remove_wis_fn = function (e) {
  // REMOVE
  if (
    ($wishlist_list && this.isFnWishlist) ||
    ($compare_list && !this.isFnWishlist)
  ) {
    // app wishlist
    this.setAttribute("aria-busy", true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: "add",
        _method: "DELETE",
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.status != "success") {
          console.error(data.message || "Unknow error");
          return;
        }
        arr_wishlist_list = JSON.parse(
          data.response.metafield.value,
        ).ecomrise_ids;
        if (!Array.isArray(arr_wishlist_list)) {
          arr_wishlist_list = arr_wishlist_list.split(",");
        }
        getterRunFn(
          _action_after_remove_add,
          this,
          action_after_remove_add_fn,
        ).call(this, "add");
      })
      .catch(function (error) {
        console.log("Error: " + error);
      })
      .finally(() => {
        this.setAttribute("aria-busy", false);
      });
  } else {
    // local wishlist
    this.array.splice(this.array.indexOf(getterGet(_wishlist_id, this)), 1);
    localStorage.setItem(this.nameCached, this.array.toString());

    getterRunFn(
      _action_after_remove_add,
      this,
      action_after_remove_add_fn,
    ).call(this, "add");
  }
};
action_after_remove_add_fn = function (action) {
  if (
    this.getAttribute("action") == "remove" &&
    this.hasAttribute("remove-on-page")
  ) {
    if (this.isFnWishlist) {
      this.closest(".hdt-card-product").remove();
    } else {
      $$4(`.hdt-compare-item-${getterGet(_wishlist_id, this)}`).forEach(
        (item) => {
          item.remove();
        },
      );
    }
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    if (this.array.length == 0) {
      $id4(`drawerCompare`)?.removeAttribute("open");
      if (this.isPageWishlistorCompare)
        window.location.href = getterRunFn(
          _conver_to_link,
          this,
          conver_to_link_fn,
        ).call(this);
    }
    //this.setAttribute('action', action);
  } else {
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    // is page wishlist or compare reload page
    if (this.isPageWishlistorCompare)
      window.location.href = getterRunFn(
        _conver_to_link,
        this,
        conver_to_link_fn,
      ).call(this);
  }
};
show_popup_compare_fn = function (event) {
  if (!themeHDN.extras.enableComparePopup || this.isPageWishlistorCompare)
    return;
  // add code if want show popup compare
  $id4(`drawerCompare`).setAttribute("open", "");
  fetch(
    conver_to_link_fn("compare", arr_compare_list) +
      "&section_id=compare-offcanvas",
  )
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const prds = html.querySelector("offcanvas-compare");

      if (prds && prds.innerHTML.trim().length) {
        $4("offcanvas-compare").innerHTML = prds.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    });
};
var _clear_all, clear_all_fn;
class ClearAll extends HTMLElement {
  constructor() {
    super();
    getterAdd(_clear_all, this);
    this.tabIndex = 0;
    this.addEventListener("click", getterRunFn(_clear_all, this, clear_all_fn));
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter")
        getterRunFn(_clear_all, this, clear_all_fn).call(this);
    });
  }
  get ofFn() {
    return this.getAttribute("of-fn"); //'compare', 'wishlist'
  }
  get nameCached() {
    return this.ofFn == "compare" ? nameCachedCompare : nameCachedWishlist;
  }
  set array(value) {
    this.ofFn == "compare"
      ? (arr_compare_list = value)
      : (arr_wishlist_list = value);
  }
}
_clear_all = new WeakSet();
clear_all_fn = function () {
  localStorage.removeItem(this.nameCached);
  // Update Buttons
  $$4(`hdt-${this.ofFn}[action="added"]`).forEach((btn) => {
    btn.setAttribute("action", "add");
  });
  // Update Count and link
  document.dispatchEvent(
    new CustomEvent(`theme4:${this.ofFn}:update`, {
      bubbles: true,
      detail: "the4",
    }),
  );
  this.array = [];
  $id4(`drawerCompare`)?.removeAttribute("open");
  if ($4(`#drawerCompare offcanvas-compare`)) {
    $4(`#drawerCompare offcanvas-compare`).innerHTML = "";
  }
};
customElements.define("hdt-clear-all", ClearAll);
// eg: <hdt-clear-all role="button" of-fn="compare">Clear All </hdt-clear-all>

// Update count
class WishlistCount extends HTMLElement {
  constructor() {
    super();
    this.textContent = this.array.length;
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      this.textContent = this.array.length;
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? "wishlist" : "compare";
  }
}
// Update link page
class WishlistLink extends HTMLElement {
  constructor() {
    super();
    $4("a", this).href = conver_to_link_fn(this.prefix, this.array);
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      $4("a", this).href = conver_to_link_fn(this.prefix, this.array);
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? "wishlist" : "compare";
  }
}
customElements.define("hdt-wishlist", Wishlist);
customElements.define("hdt-wishlist-count", WishlistCount);
customElements.define("hdt-wishlist-a", WishlistLink);

// COMPARE
class Compare extends Wishlist {
  get isFnWishlist() {
    return false;
  }
  get textFn() {
    return "compare";
  }
}
// Update count
class CompareCount extends WishlistCount {
  get isFnWishlist() {
    return false;
  }
}
// Update link page
class CompareLink extends WishlistLink {
  get isFnWishlist() {
    return false;
  }
}
customElements.define("hdt-compare", Compare);
customElements.define("hdt-compare-count", CompareCount);
customElements.define("hdt-compare-a", CompareLink);

// --------------------------
// Product Recommendations
// --------------------------
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          document.dispatchEvent(new CustomEvent("currency:update"));
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// --------------------------
// Product Recently
// --------------------------
class ProductRecently extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      let handleProducts = localStorage.getItem("theme4:recently:id");
      let prdId = this.dataset.id;

      if (handleProducts !== null) {
        let products = handleProducts.split(",");
        let url = this.dataset.url.replace(
          "q=",
          "q=id:" + products.join("%20OR%20id:"),
        );
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recently = html.querySelector("product-recently");

            if (recently && recently.innerHTML.trim().length) {
              this.innerHTML = recently.innerHTML;
            }
            document.dispatchEvent(new CustomEvent("currency:update"));
          })
          .catch((e) => {
            console.error(e);
          });
      }
      let arrayProducts =
        handleProducts !== null ? handleProducts.split(",") : new Array();
      if (!arrayProducts.includes(prdId + "")) {
        if (arrayProducts.length >= 10) {
          arrayProducts.pop();
        }
        function prepend(value, array) {
          var newArray = array.slice();
          newArray.unshift(value);
          return newArray;
        }
        arrayProducts = prepend(prdId, arrayProducts);
        arrayProducts = arrayProducts.toString();
        localStorage.setItem("theme4:recently:id", arrayProducts);
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recently", ProductRecently);

// --------------------------
// Predictive Search
// --------------------------
class PredictiveSearch extends Drawer {
  constructor() {
    super();
    if (!this.hasAttribute("enabled")) return;
    this.cachedResults = {};
    this.predictiveSearchResults = $4("[data-results-search]", this);
    this.input = $4('input[type="search"]', this);
    this.sectionIdResults =
      this.getAttribute("data-section-id-results") || "hdt_predictive-search";
    this.allPredictiveSearchInstances = $$4("predictive-search");
    this.skeleton = $4("[data-skeleton-search]", this);
    this.noResults = $4(".hdt-cart-no-results", this);
    this.hideWrapper = $4(".hdt-cart-hide-has-results", this);
    this.showWrapper = $4(".hdt-cart-show-has-results", this);
    this.btn_viewall = $4(".hdt-view_all", this);
    this.href = this.btn_viewall?.getAttribute("href");
    this.isOpen = false;
    this.abortController2 = new AbortController();
    this.searchTerm = "";
    if (this.input) {
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }

    const formData = new FormData(this.input.form);
    this.params = "";
    for (const [key, value] of formData) {
      if (key === "q") break;
      this.params += `${key}=${value}&`;
    }

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    //this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      // this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;
    this.btn_viewall?.setAttribute(
      "href",
      this.href.replace(/\/search\?q=.*/g, "/search?q=" + this.searchTerm),
    );

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) return;
    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.openSearch();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    // switch (event.code) {
    //   case 'ArrowUp':
    //     this.switchOption('up');
    //     break;
    //   case 'ArrowDown':
    //     this.switchOption('down');
    //     break;
    //   case 'Enter':
    //     this.selectOption();
    //     break;
    // }
  }

  // onKeydown(event) {
  //   // Prevent the cursor from moving in the input when using the up and down arrow keys
  //   if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
  //     event.preventDefault();
  //   }
  // }
  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]",
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${themeHDN.routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm,
      )}&${this.params}section_id=${this.sectionIdResults}`,
      {
        signal: this.abortController2.signal,
      },
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-" + this.sectionIdResults).innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            this.cachedResults[queryKey] = resultsMarkup;
          },
        );
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.hideWrapper.style.cssText = "display: none;";
    this.showWrapper.style.cssText = "display: block;";
    this.skeleton.classList.remove("hdt-hidden");

    this.setAttribute("loading", true);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();
    this.openSearch();
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
  }

  openSearch() {
    //this.setAttribute('open', true);
    this.input.setAttribute("aria-expanded", true);
    this.skeleton.classList.add("hdt-hidden");
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
      this.hideWrapper.style.cssText = "display: block;";
      this.showWrapper.style.cssText = "display: none;";
      this.predictiveSearchResults.innerHTML = "";
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    //this.removeAttribute('open');
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}

customElements.define("hdt-predictive-search", PredictiveSearch);
// bundle product

const bundleProduct = () => {
  if (window.innerWidth < 768) {
    return;
  }
  let arrBundle = $$4("[data-bundle-pin]");
  if (!arrBundle) {
    return;
  }
  arrBundle.forEach((el) => {
    if (!el.dataset.trigger) {
      return;
    } else {
      el.onmouseover = () => {
        $4(el.dataset.trigger).classList.add("is--hover");
        $4(el.dataset.trigger)
          .closest("[data-bundle-parent]")
          .classList.add("has--hover");
      };
      el.onmouseleave = () => {
        $4(el.dataset.trigger).classList.remove("is--hover");
        $4(el.dataset.trigger)
          .closest("[data-bundle-parent]")
          .classList.remove("has--hover");
      };
    }
  });
};
bundleProduct();

// --------------------------
// Back to top
// --------------------------
class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute("config"));
    if (window.innerWidth < 768 && this.config.hiddenMobile) return;
    this.debounce_timer = 0;
    this.debounce_timer2 = 0;
    this.circlechart = this.querySelector(".hdt-circle-css");
    this.addEventListener("click", this.goTop.bind(this));
    window.addEventListener("scroll", this.backToTop.bind(this));
  }
  goTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  backToTop() {
    let self = this;
    if (this.debounce_timer) {
      clearTimeout(this.debounce_timer);
    }
    this.debounce_timer = setTimeout(function () {
      if (window.scrollY > self.config.scrollTop) {
        self.classList.add("is--show");
      } else {
        self.classList.remove("is--show");
      }
    }, 40);

    if (!this.circlechart) return;

    if (this.debounce_timer2) {
      clearTimeout(this.debounce_timer2);
    }

    this.debounce_timer2 = setTimeout(function () {
      let scrollTop2 = window.scrollY,
        docHeight = document.body.offsetHeight,
        winHeight = window.innerHeight,
        scrollPercent = scrollTop2 / (docHeight - winHeight),
        degrees = scrollPercent * 360;
      self.circlechart.style.setProperty("--cricle-degrees", degrees + "deg");
    }, 6);
  }
}

customElements.define("back-to-top", BackToTop);

// --------------------------
// numberRandom
// --------------------------
class numberRandom extends HTMLElement {
  constructor() {
    super();
    let config = JSON.parse(this.getAttribute("config"));
    this.min = config.min;
    this.max = config.max;
    this.interval = config.interval;
    this.number =
      Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    this.ofset = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"];
    this.prioritize = ["10", "20", "15"];
    this.h = "";
    this.e = "";
    this.M = "";
    this.liveViewInt();
    setInterval(this.liveViewInt.bind(this), this.interval);
  }

  liveViewInt() {
    if (
      ((this.h = Math.floor(Math.random() * this.ofset.length)),
      (this.e = this.ofset[this.h]),
      (this.number = parseInt(this.number) + parseInt(this.e)),
      this.min >= this.number)
    ) {
      this.M = Math.floor(Math.random() * this.prioritize.length);
      var a = this.prioritize[this.M];
      this.number += a;
    }
    if (this.number < this.min || this.number > this.max) {
      this.number =
        Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    }
    this.innerHTML = parseInt(this.number);
  }
}

customElements.define("number-random", numberRandom);

// --------------------------
// Lookbook product carousel
// --------------------------

class LookbookProductCarousel extends HTMLElement {
  constructor() {
    super();
    if (window.innerWidth > 767) {
      return;
    }
    this.lookbookMobile();
  }
  lookbookMobile() {
    let self = this;
    const el = self.querySelector("[lookbook-product-wrap]");
    const controls = self.querySelector("[hdt-slider-controls]");
    const btn_close = self.querySelector("button.hdt-close");
    const isToolBar = document.querySelector(".hdt-toolbar-mobile");
    let toolBarH = 0;
    if (!el | !controls | !btn_close) return;
    if (isToolBar) {
      toolBarH += isToolBar.offsetHeight;
    }

    self.querySelector("[lookbook-product-wrap]").style.bottom = `${
      toolBarH / 10
    }rem`;
    controls.addEventListener("click", () => {
      el.classList.add("hdt-open");
    });
    btn_close.addEventListener("click", () => {
      el.classList.remove("hdt-open");
    });
  }
}
customElements.define("lookbook-product-carousel", LookbookProductCarousel);

/**
 * Cookies
 * https://help.shopify.com/en/manual/your-account/privacy/cookies
 * https://shopify.dev/themes/trust-security/cookie-banner#create-a-snippet-to-host-the-banner
 * https://help.shopify.com/en/manual/your-account/privacy/privacy-preferences-manager?shpxid=965d0d2a-08E2-4654-4A13-D3F38646AC5D
 * https://shopify.dev/api/consent-tracking
 */

function convertNameCookies(name) {
  return name.replace(/=/g, "_");
}
function setCookie(name, value, days, hours) {
  var expires = "";
  if (days || hours) {
    var date = new Date();
    date.setTime(
      date.getTime() +
        (days ? days * 24 * 60 * 60 * 1000 : hours * 60 * 60 * 1000),
    );
    expires = "; expires=" + date.toString();
  }
  document.cookie =
    convertNameCookies(name) + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = convertNameCookies(name) + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = convertNameCookies(name) + "=; Max-Age=-99999999;";
}

class cookiesBar extends HTMLElement {
  constructor() {
    super();
    this.cookies = JSON.parse(this.getAttribute("configs"));
    this.cookies.cookiesName = "theme4:cookies";
    this.cookies.drawer = this.querySelector("#drawerCookies");
    this.isShowCookiesAll = this.cookies.show == "1";
    this.acceptBtn = this.cookies.drawer.querySelector(
      ".hdt-pp_cookies__accept-btn",
    );
    this.declineBtn = this.cookies.drawer.querySelector(
      ".hdt-pp_cookies__decline-btn",
    );
    this.loadCookieBanner(this);
    let self = this;
    this.acceptBtn?.addEventListener("click", this.handleAccept.bind(this));
    this.declineBtn?.addEventListener("click", this.handleDecline.bind(this));
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        const cookiesSelect = event.target.classList.contains("sys-cookies");
        if (!cookiesSelect) return;
        self.showCookiesBanner();
      });
      document.addEventListener("shopify:section:deselect", (event) => {
        const cookiesSelect = event.target.classList.contains("sys-cookies");
        if (!cookiesSelect) return;
        self.hideCookiesBanner();
      });
    }
  }
  handleAccept() {
    if (this.isShowCookiesAll) {
      setCookie(
        this.cookies.cookiesName,
        "accepted",
        parseInt(this.cookies.day_next),
      );
    }
    const self = this;
    window.Shopify.customerPrivacy.setTrackingConsent(true, function () {
      if (window.__meFbqConsent) window.__meFbqConsent();
      if (typeof fbq === "function") {
        fbq("track", "PageView");
      }
      self.hideCookiesBanner();
    });
  }

  handleDecline() {
    if (this.isShowCookiesAll) {
      setCookie(
        this.cookies.cookiesName,
        "accepted",
        parseInt(this.cookies.day_next),
      );
    }
    window.Shopify.customerPrivacy.setTrackingConsent(
      false,
      this.hideCookiesBanner.bind(this),
    );
  }

  showCookiesBanner() {
    this.cookies.drawer.setAttribute("open", "");
    $4("html").classList.remove("no-scroll");
  }

  hideCookiesBanner() {
    this.cookies.drawer.removeAttribute("open");
  }

  initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent =
      window.Shopify.customerPrivacy.getTrackingConsent();

    if (
      (!userCanBeTracked && userTrackingConsent === "no_interaction") ||
      this.isShowCookiesAll
    ) {
      if (!Shopify.designMode) {
        this.showCookiesBanner();
      }
    }
  }

  loadCookieBanner() {
    let self = this;
    if (this.cookies.drawer.length == 0) return;
    this.cookies.day_next = this.cookies.day_next || 60;
    this.isShowCookiesAll = this.cookies.show == "1";
    if (
      getCookie(this.cookies.cookiesName) == "accepted" ||
      this.cookies.drawer.getAttribute("open") !== null
    )
      return;

    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      function (error) {
        if (error) {
          throw error;
        }
        self.initCookieBanner();
      },
    );
  }
}

customElements.define("sys-cookies", cookiesBar);

// --------------------------
// Newsletter
// --------------------------

class newsletterModal extends HTMLElement {
  constructor() {
    super();
    this.configs = JSON.parse(this.getAttribute("configs"));
    if (
      !Shopify.designMode &&
      getCookie("theme4:newsletter:" + this.configs.id) == "shown"
    )
      return;
    this.modal = this.querySelector("#modalNewsletter-" + this.configs.id);
    this.action_close = this.querySelector("[action-close]");
    this.time_delay = this.configs.time_delay;
    this.day_next = this.configs.day_next;
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        const newsletterSelect =
          event.target.classList.contains("sys-newsletter");
        if (!newsletterSelect) return;
        this.modal.setAttribute("open", "");
      });
      document.addEventListener("shopify:section:deselect", (event) => {
        const newsletterSelect =
          event.target.classList.contains("sys-newsletter");
        if (!newsletterSelect) return;
        this.modal.removeAttribute("open");
      });
    } else {
      const fnShow = this.showModal.bind(this);
      const fnShowScroll = this.showModalScroll.bind(this);
      if (this.configs.after === "time") {
        let tm = setTimeout(fnShow, this.configs.time_delay * 1000);
        this.modal.addEventListener("dialog:afterClose", () => {
          clearTimeout(tm);
          this.hideModal(false, true);
        });
      } else {
        window.addEventListener("scroll", fnShowScroll);
        this.modal.addEventListener("dialog:afterClose", () => {
          window.removeEventListener("scroll", fnShowScroll);
          this.hideModal(false, true);
        });
      }
      this.actionClose();
    }
  }

  showModal() {
    this.modal.setAttribute("open", "");
  }
  showModalScroll() {
    if (window.scrollY > this.configs.scroll_delay) {
      this.modal.setAttribute("open", "");
    }
  }
  hideModal(pause, off) {
    if (pause) {
    }
    if (off) {
      setCookie("theme4:newsletter:" + this.configs.id, "shown", this.day_next);
    }
  }
  actionClose() {
    let self = this;
    if (self.action_close) {
      self.action_close.addEventListener("click", function () {
        self.modal.removeAttribute("open", "");
        self.hideModal(false, true);
      });
    }
  }
}
customElements.define("sys-newsletter", newsletterModal);

// --------------------------
// Exit
// --------------------------

class exitModal extends HTMLElement {
  constructor() {
    super();
    this.configs = JSON.parse(this.getAttribute("configs"));
    if (
      !Shopify.designMode &&
      getCookie("theme4:exit:" + this.configs.id) == "shown"
    )
      return;
    this.modal = this.querySelector("#modalExit-" + this.configs.id);
    this.day_next = this.configs.day_next;
    this.btn_copy = this.querySelector('button[is="discount_copy"]');
    this.discount = this.querySelector('[is="discount"]');
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        const exitSelect = event.target.classList.contains("sys-exit");
        if (!exitSelect) return;
        this.showModal();
      });
      document.addEventListener("shopify:section:deselect", (event) => {
        const exitSelect = event.target.classList.contains("sys-exit");
        if (!exitSelect) return;
        this.modal.removeAttribute("open");
      });
    } else {
      if (this.configs.after === "move_cursor") {
        if (window.innerWidth > 1150) {
          this.moveCursor();
        } else {
          this.scrollPage();
        }
      } else if (this.configs.after === "scroll") {
        this.scrollPage();
      } else {
        this.amountTime();
      }
    }
  }
  // Move cursor out screen
  moveCursor() {
    const fnShow = this.showModal.bind(this);
    document.querySelector("body").addEventListener("mouseleave", fnShow);
    this.modal.addEventListener("dialog:afterClose", () => {
      document.querySelector("body").removeEventListener("mouseleave", fnShow);
      this.hideModal(false, true);
    });
  }
  //  scroll page
  scrollPage() {
    const fnShow = this.showModal.bind(this);
    let docHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight -
      500;
    let scroll = () => {
      if (window.scrollY >= docHeight) {
        fnShow();
      }
    };
    window.addEventListener("scroll", scroll);
    this.modal.addEventListener("dialog:afterClose", () => {
      window.removeEventListener("scroll", scroll);
      this.hideModal(false, true);
    });
  }
  // countdown time to show exit popup
  amountTime() {
    const fnShow = this.showModal.bind(this);
    let tm = setTimeout(fnShow, this.configs.time_delay * 1000);
    this.modal.addEventListener("dialog:afterClose", () => {
      clearTimeout(tm);
      this.hideModal(false, true);
    });
  }
  showModal() {
    let self = this;
    this.modal.setAttribute("open", "");
    if (self.btn_copy && self.discount) {
      self.btn_copy.addEventListener("click", function () {
        self.discount.select();
        self.discount.setSelectionRange(0, 99999);
        document.execCommand("copy");
        self.btn_copy.querySelector(".hdt-tooltip-text").innerText =
          `${themeHDN.extras.exit_popup.copied}: ${self.discount.value}`;
      });
      self.btn_copy.addEventListener("mouseleave", function () {
        self.btn_copy.querySelector(".hdt-tooltip-text").innerText =
          themeHDN.extras.exit_popup.copy;
      });
    }
  }
  hideModal(pause, off) {
    if (pause) {
    }
    if (off) {
      setCookie("theme4:exit:" + this.configs.id, "shown", this.day_next);
    }
  }
}
customElements.define("sys-exit", exitModal);

// --------------------------
// Countdown Cart
// --------------------------

class cartCountdown extends HTMLElement {
  constructor() {
    super();
    let settMinutes = 60 * this.getAttribute("time"),
      time = parseInt(sessionStorage.getItem("cartTime")),
      display = this.querySelector("#timer_count");
    this.config = JSON.parse(this.getAttribute("config"));
    var self = this;
    function startTimer(duration, display) {
      let timer = duration,
        minutes,
        seconds;
      let countdown = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
        minutes = minutes < 10 ? minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        display.textContent =
          minutes + self.config.labelm + " : " + seconds + self.config.labels;
        let calc = 60 * parseInt(timer / 60, 10) + parseInt(timer % 60, 10);
        if (!Shopify.designMode) {
          sessionStorage.setItem("cartTime", calc);
        }
        if (--timer < 0) {
          window.clearInterval(countdown);
          display.textContent =
            0 + self.config.labelm + " : " + 0 + self.config.labels;
          fetch(Shopify.routes.root + "cart/clear.js")
            .then((response) => response.text())
            .then((text) => {
              window.location.href = `${Shopify.routes.root}cart`;
            })
            .catch((e) => {
              console.error(e);
            });
        }
      }, 1000);
    }
    if (time > 0) {
      startTimer(time, display);
    } else {
      startTimer(settMinutes, display);
    }
  }
}
customElements.define("cart-countdown", cartCountdown);

// --------------------------
// Form status
// --------------------------

const contactForm = $$4('form[action^="/contact"]');
contactForm.forEach(function (form) {
  form.addEventListener("submit", function (event) {
    sessionStorage.setItem("the4:recentform", this.getAttribute("id"));
  });
});
var recentform = sessionStorage.getItem("the4:recentform") || "";

if (location.href.indexOf("contact_posted=true") > 0 && recentform !== "") {
  document.dispatchEvent(
    new CustomEvent("the4:recentform", {
      detail: { recentform: recentform },
      bubbles: true,
      cancelable: true,
    }),
  );
  $id4(recentform)?.classList.add("on-live");
  if ($4(".form-status-mirror-" + recentform)) {
    $4(".form-status-mirror-" + recentform).style.cssText = "display: block;";
  }
} else if (
  location.href.indexOf("customer_posted=true") > 0 &&
  recentform !== ""
) {
  document.addEventListener("the4:recentform", (event) => {
    let modal_id = document
      .getElementById(event.detail.recentform)
      .getAttribute("data-id");
    document.getElementById(modal_id).setAttribute("open", "");
  });
  document.dispatchEvent(
    new CustomEvent("the4:recentform", {
      detail: { recentform: recentform },
      bubbles: true,
      cancelable: true,
    }),
  );
  $id4(recentform)?.classList.add("on-live");
} else if (
  location.href.indexOf("contact_posted=true") > 0 &&
  location.href.indexOf("#") > 0
) {
  var recentform = location.href.split("#")[1];
  if ($id4(recentform).length > 0) {
    sessionStorage.setItem("the4:recentform", recentform);
    $id4(recentform).classList.add("on-live");
    if ($4(".form-status-mirror-" + recentform)) {
      $4(".form-status-mirror-" + recentform).style.cssText = "display: block;";
    }
  }
}

// --------------------------
// Total sold flash
// --------------------------
class flashSold extends VariantChangeBase {
  constructor() {
    super();
    var self = this;
    this.time = this.getAttribute("time");
    this.config = JSON.parse(this.getAttribute("flash-sold"));
    this.mins = this.config.mins;
    this.maxs = this.config.maxs;
    this.mint = this.config.mint;
    this.maxt = this.config.maxt;
    this.dataID = this.config.id;
    this.getS =
      sessionStorage.getItem("soldS" + this.dataID) ||
      this.getRandomInt(this.mins, this.maxs);
    this.getT =
      sessionStorage.getItem("soldT" + this.dataID) ||
      this.getRandomInt(this.mint, this.maxt);
    this.numS = parseInt(this.getS);
    this.numT = parseInt(this.getT);
    this.intervalTime = parseInt(this.config.time);
    this.$sold = this.querySelector("[data-sold]");
    this.$hour = this.querySelector("[data-hour]");
    this.limitMinMax();
    this.updateSold(this.numS, this.numT);
    setInterval(function () {
      this.numS = this.numS + self.getRandomInt(1, 4);
      this.numT =
        this.numT + (Math.random() * (0.8 - 0.1) + 0.1).toFixed(1) * 1;
      self.limitMinMax();
      self.updateSold(self.numS, self.numT);
    }, this.intervalTime);
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  updateSold(num1, num2) {
    this.$sold.innerHTML = num1;
    this.$hour.innerHTML = Math.floor(this.numT);
    sessionStorage.setItem("soldS" + this.dataID, num1);
    sessionStorage.setItem("soldT" + this.dataID, num2);
  }
  limitMinMax() {
    if (this.numS > this.maxs)
      this.numS = self.getRandomInt(this.mins, this.maxs);
    if (this.numT > this.maxt)
      this.numT = self.getRandomInt(this.mins, this.maxt);
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if (variant.available) {
        this.closest(".hdt-product-info__item").style.display = "";
      } else {
        this.closest(".hdt-product-info__item").style.display = "none";
      }
    }
  }
}
customElements.define("flash-sold", flashSold);

// --------------------------
// Multi brands
// --------------------------
var hdtNavLoading = true;
class multiBrands extends HTMLElement {
  constructor() {
    super();
    if ($id4("hdt-nav-ul").classList.value.includes("hdt-nav-loading") < 0) {
      return false;
    }
    this.item = $$4("[item-brand]", this);
    // this.section_id = this.getAttribute("s_id");
    // this.url = "";
    if (this.item.length) {
      // for(var i=0; i < this.item.length; i++) {
      //   if (this.item[i].parentElement.classList.value.includes("is--active")) {
      //     this.url = this.item[i].getAttribute("href");
      //     const lazyMb = $4('hdt-lazy-submenu#sub-hdt-nav-mb');
      //     if (lazyMb) {
      //       lazyMb.addEventListener('lazyhtml:added', () => $4(`#hdt-nav-ul-mb summary[data-url="${this.url}"]`)?.parentElement.setAttribute("open",""));
      //     } else {
      //       $4(`#hdt-nav-ul-mb summary[data-url="${this.url}"]`)?.parentElement.setAttribute("open","");
      //     }
      //     // localStorage.setItem("the4:brand:url", this.url);
      //     break;
      //   }
      // }
      // if(this.url === "") {
      //   this.url = localStorage.getItem("the4:brand:url") || Shopify.routes.root;
      //   for(var i=0; i < this.item.length; i++) {
      //     if (this.item[i].getAttribute("href") === this.url) {
      //       this.item[i].parentElement.classList.add("is--active");
      //       $4("#hdt-nav-ul-mb summary[data-url=\""+ this.url +"\"]").parentElement.setAttribute("open","");
      //       if (i > 0) {
      //         this._init();
      //       }
      //       break;
      //     }
      //   }
      // }
    }
  }
  // _init(){
  //   var nameStorage = "the4:brand:nav" + this.url.replace(/\//g,'-');
  //   if(!Shopify.designMode && sessionStorage.getItem(nameStorage) !== null){
  //     $id4("hdt-nav-ul").innerHTML = sessionStorage.getItem(nameStorage);
  //     $id4("hdt-nav-ul").classList.remove("hdt-nav-loading");
  //     return;
  //   }
  //   if (!hdtNavLoading) {
  //     return;
  //   }
  //   fetch(this.url + "?section_id=" + this.section_id)
  //     .then((response) => response.text())
  //     .then((text) => {
  //       const html = document.createElement('div');
  //       html.innerHTML = text;
  //       const nav = html.querySelector('#hdt-nav-ul');
  //       if (nav && nav.innerHTML.trim().length) {
  //         $id4("hdt-nav-ul").innerHTML = nav.innerHTML;
  //         $id4("hdt-nav-ul").classList.remove("hdt-nav-loading");
  //         sessionStorage.setItem(nameStorage, nav.innerHTML.trim().replace(/^\s+|\s+$|\n/gm,''));
  //       }
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //     });
  //   hdtNavLoading = false;
  // }
}

customElements.define("multi-brands", multiBrands);

// Footer accordion is handled in sections/footer.liquid

// --------------------------
// Delivery Time
// --------------------------
// https://unpkg.com/dayjs@1.11.10/dayjs.min.js
import dayjs from "dayjs";
dayjs.locale("en"); // use locale globally
class orderDelivery extends VariantChangeBase {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute("config"));
    this.offDays = this.config.off_day.replace(/ /g, "").split(",");
    this.nowDay = dayjs();
    var format_day = this.config.format_day,
      time = this.config.time.replace("24:00:00", "23:59:59"),
      arrDayWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      dateStart = this.config.estimateStartDate || 0,
      dateEnd = this.config.estimateEndDate || 0,
      excludeDays = this.config.cut_day.replace(/ /g, "").split(","),
      startDay = dayjs(),
      i = 0,
      endDay = dayjs(),
      j = 0,
      nowTime = this.nowDay.format("HHmmss"),
      timeint = time.replace(/ /g, "").replace(/:/g, ""),
      arrDay = themeHDN.extras.order.dayNames.replace(/ /g, "").split(","),
      arrMth = themeHDN.extras.order.monthNames.replace(/ /g, "").split(",");

    /**
     * Check Time, if nowTime >=  timeint +1 day
     */
    if (parseInt(nowTime) >= parseInt(timeint)) {
      this.nowDay = this.nowDay.add(1, "day");
      startDay = startDay.add(1, "day");
      endDay = endDay.add(1, "day");
    }

    /**
     * Mode: 2 - Shipping + delivery
     * Mode: 1 - Only delivery
     */

    if (this.config.mode == "2") {
      // START DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (
        excludeDays.indexOf(arrDayWeek[startDay.format("d")]) > -1 ||
        this.offDays.indexOf(startDay.format("DD/MM/****")) > -1 ||
        this.offDays.indexOf(startDay.format("DD/MM/YYYY")) > -1
      ) {
        startDay = startDay.add(1, "day");
      }
      while (i < dateStart) {
        i++;
        startDay = startDay.add(1, "day");
        if (
          excludeDays.indexOf(arrDayWeek[startDay.format("d")]) > -1 ||
          this.offDays.indexOf(startDay.format("DD/MM/****")) > -1 ||
          this.offDays.indexOf(startDay.format("DD/MM/YYYY")) > -1
        ) {
          i--;
        }
      }

      // END DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (
        excludeDays.indexOf(arrDayWeek[endDay.format("d")]) > -1 ||
        this.offDays.indexOf(endDay.format("DD/MM/****")) > -1 ||
        this.offDays.indexOf(endDay.format("DD/MM/YYYY")) > -1
      ) {
        endDay = endDay.add(1, "day");
      }

      while (j < dateEnd) {
        j++;
        endDay = endDay.add(1, "day");
        if (
          excludeDays.indexOf(arrDayWeek[endDay.format("d")]) > -1 ||
          this.offDays.indexOf(endDay.format("DD/MM/****")) > -1 ||
          this.offDays.indexOf(endDay.format("DD/MM/YYYY")) > -1
        ) {
          j--;
        }
      }
    } else {
      // START DATE
      startDay = startDay.add(dateStart, "day");
      while (
        excludeDays.indexOf(arrDayWeek[startDay.format("d")]) > -1 ||
        this.offDays.indexOf(startDay.format("DD/MM/****")) > -1 ||
        this.offDays.indexOf(startDay.format("DD/MM/YYYY")) > -1
      ) {
        startDay = startDay.add(1, "day");
      }

      // END DATE
      endDay = endDay.add(dateEnd, "day");
      while (
        excludeDays.indexOf(arrDayWeek[endDay.format("d")]) > -1 ||
        this.offDays.indexOf(endDay.format("DD/MM/****")) > -1 ||
        this.offDays.indexOf(endDay.format("DD/MM/YYYY")) > -1
      ) {
        endDay = endDay.add(1, "day");
      }
      // endDay = endDay.add(this.offDaysf(endDay), 'day');
    }

    /**
     * Translate day, month
     * https://day.js.org/docs/en/display/format
     */
    arrDay = this.ArrUnique(arrDay);
    arrMth = this.ArrUnique(arrMth);

    var startDayDInt = parseInt(startDay.format("D")),
      daystStart = startDayDInt + this.nth(startDayDInt),
      MntStart = arrMth[parseInt(startDay.format("M")) - 1],
      dayStart = arrDay[parseInt(startDay.format("d"))],
      EndDayDInt = parseInt(endDay.format("D")),
      daystEnd = EndDayDInt + this.nth(EndDayDInt),
      MntEnd = arrMth[parseInt(endDay.format("M")) - 1],
      dayEnd = arrDay[parseInt(endDay.format("d"))];
    if ($4("[data-start-delivery]", this))
      $4("[data-start-delivery]", this).innerHTML = startDay
        .format(format_day)
        .replace("t44", dayStart)
        .replace("t45", daystStart)
        .replace("t46", MntStart);
    if ($4("[data-end-delivery]", this))
      $4("[data-end-delivery]", this).innerHTML = endDay
        .format(format_day)
        .replace("t44", dayEnd)
        .replace("t45", daystEnd)
        .replace("t46", MntEnd);
  }

  ArrUnique(arr) {
    var onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };
    return arr.filter(onlyUnique);
  }

  nth(d) {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if (variant.available) {
        this.closest(".hdt-product-info__item").style.display = "";
        if (variant.variant_state.pre_order) {
          this.closest(".hdt-product-info__item").style.display = "none";
        }
      } else {
        this.closest(".hdt-product-info__item").style.display = "none";
      }
    }
  }
}
customElements.define("order-delivery", orderDelivery);
class countdownSimple extends HTMLElement {
  x = 0;
  constructor() {
    super();

    /** Countdown
     * [days] [hours] [mins] [secs]
     */

    this.config = JSON.parse(this.getAttribute("config"));
    const time = this.config.time.replace("24:00:00", "23:59:59");

    if (time == "19041994") return;
    this.textTemp = $4("template", this).innerHTML;
    this.notHasDay = !this.textTemp.includes("[days]");
    let today = dayjs();

    const nowTime = today.format("HHmmss"),
      configTime = time.replace(/ /g, "").replace(/:/g, "");

    if (parseInt(nowTime) >= parseInt(configTime)) {
      today = today.add(1, "day");
    }
    // Set the date we're counting down to
    // "2030-01-05 15:37:25"
    this.countDownDate = new Date(
      `${today.format("YYYY-MM-DD")} ${time}`,
    ).getTime();

    // Update the count down every 1 second
    this.#update();
    this.x = setInterval(
      this.#update.bind(this),
      this.textTemp.includes("[secs]") ? 1000 : 60000,
    );
  }
  #update() {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = this.countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (this.notHasDay) hours = days * 24 + hours;

    // Display the result in the element
    this.innerHTML = this.textTemp
      .replace("[days]", String(days).padStart(2, "0"))
      .replace("[hours]", String(hours).padStart(2, "0"))
      .replace("[mins]", String(minutes).padStart(2, "0"))
      .replace("[secs]", String(seconds).padStart(2, "0"));

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(this.x);
      // EXPIRED
      this.hidden = true;
    }
  }
  disconnectedCallback() {
    clearInterval(this.x);
  }
}
customElements.define("hdt-countdown-simple", countdownSimple);

class countdownTimer extends VariantChangeBase {
  constructor() {
    super();
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if (variant.available) {
        this.style.display = "";
      } else {
        this.style.display = "none";
      }
    }
  }
}
customElements.define("countdown-timer", countdownTimer);

// quick order list

var cartFetchInflight = null;
var createCartPromise = (force = false) => {
  if (typeof window.createCartPromise === "function") {
    return window.createCartPromise(force);
  }
  if (!force && cartFetchInflight) return cartFetchInflight;
  const req = fetch(`${Shopify.routes.root}cart.js`, {
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((response) => response.json())
    .finally(() => {
      if (cartFetchInflight === req) cartFetchInflight = null;
    });
  cartFetchInflight = req;
  return req;
};
var _upate_qty, upate_qty_fn;
class QuickOrderList extends HTMLElement {
  constructor() {
    super();
    const ON_CHANGE_DEBOUNCE_TIMER = 300;
    this.actions = {
      add: "ADD",
      update: "UPDATE",
    };
    this.quickOrderListId = "#" + this.id;
    this.sectionId = this.dataset.sectionId;
    this.updateThink();

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
    getterAdd(_upate_qty, this);
    document.addEventListener("cart:push:section.id", (event) =>
      event.detail.sections.push(this.sectionId),
    );
  }
  onSubmit(event) {
    event.preventDefault();
  }

  connectedCallback() {
    document.addEventListener(
      $4("hdt-cart-drawer") ? "cart:drawer:change" : "variant:add",
      this.fetchQuickOrder.bind(this),
    );
  }
  //disconnectedCallback() {}

  updateThink() {
    this.items_in_cart = $4("[update_items_in_cart]", this);
    this.items_price_in_cart = $4("[update_items_price_in_cart]", this);
    $4("form#QuickOrderList", this).addEventListener(
      "submit",
      this.onSubmit.bind(this),
    );
  }
  fetchQuickOrder(event) {
    const html = new DOMParser().parseFromString(
      event.detail.sections[this.sectionId],
      "text/html",
    );
    const sourceQty = html.querySelector(this.quickOrderListId);
    $4("form#QuickOrderList", this).removeEventListener(
      "submit",
      this.onSubmit.bind(this),
    );
    this.innerHTML = sourceQty.innerHTML;
    document.dispatchEvent(new CustomEvent("currency:update"));
    this.updateThink();
    // fetch(`${window.location.pathname}?section_id=${this.sectionId}`)
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const html = new DOMParser().parseFromString(responseText, 'text/html');
    //     const sourceQty = html.querySelector(this.quickOrderListId);
    //     this.innerHTML = sourceQty.innerHTML;
    //   })
    //   .catch((e) => { console.error(e); });
  }
  onChange(event) {
    const inputValue = parseInt(event.target.value);
    const cartQuantity = parseInt(event.target.dataset.cartQuantity);
    const index = event.target.dataset.index;
    const quantity = inputValue - cartQuantity;

    if (cartQuantity > 0) {
      this.updateQuantity(index, inputValue, this.actions.update);
    } else {
      this.updateQuantity(index, quantity, this.actions.add);
    }
  }
  onLoading(id) {
    $4(`#Variant-${id} [price_loading]`, this)?.setAttribute("aria-busy", true);
    $$4("#hdt-quick-order-list-total .hdt-btn-loading__svg", this).forEach(
      (el) => el.setAttribute("aria-busy", true),
    );
  }
  deLoading(id) {
    $4(`#Variant-${id} [price_loading]`, this)?.setAttribute(
      "aria-busy",
      false,
    );
    $$4("#hdt-quick-order-list-total .hdt-btn-loading__svg", this).forEach(
      (el) => el.setAttribute("aria-busy", false),
    );
  }
  removeButton(id, quantity) {
    quantity !== 0
      ? $4(
          `#Variant-${id} hdt-quick-order-list-remove-button`,
          this,
        ).removeAttribute("hidden")
      : $4(
          `#Variant-${id} hdt-quick-order-list-remove-button`,
          this,
        ).setAttribute("hidden", "");
  }
  updateInCart(id, variant_in_cart) {
    //  label
    $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).removeAttribute(
      "hidden",
    );
    let variant_qty_cart = $4(`#Variant-${id} .hdt-quantity-cart`, this);

    //  totals
    let variant_total = $4(`#Variant-${id} [variant_update_price]`, this);

    // update
    if (variant_in_cart?.length !== 0 && variant_in_cart) {
      let variant_total_price = parseFloat(variant_in_cart.original_line_price);
      variant_qty_cart.innerText = variant_in_cart.quantity;
      variant_total.innerText = formatMoney(
        variant_total_price,
        themeHDN.settings.currencyFormat,
      );
      variant_total.setAttribute("data-variant-price", variant_total_price);
    } else {
      variant_qty_cart.innerText = 0;
      variant_total.innerText = formatMoney(
        0,
        themeHDN.settings.currencyFormat,
      );
      variant_total.setAttribute("data-variant-price", 0);
      $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).setAttribute(
        "hidden",
        "",
      );
    }
    this.removeT4CrurrencyData(variant_total);
  }
  removeT4CrurrencyData(el, dataset = el.dataset) {
    for (const [key, value] of Object.entries(dataset)) {
      if (key.toLowerCase().indexOf("currency") >= 0) delete el.dataset[key];
    }
  }
  updateTotalInCart() {
    let items_total = 0;
    let items_price = 0;

    // update items_total
    let items = $$4("[data-cart-quantity]", this);
    items.forEach((item) => {
      return (items_total += parseInt(item.getAttribute("data-cart-quantity")));
    });
    this.items_in_cart.innerText = items_total;

    // update items_price
    let prices = $$4("[data-variant-price]", this);
    prices.forEach((price) => {
      return (items_price += parseFloat(
        price.getAttribute("data-variant-price"),
      ));
    });
    this.items_price_in_cart.innerText = formatMoney(
      items_price,
      themeHDN.settings.currencyFormat,
    );
    this.removeT4CrurrencyData(this.items_price_in_cart);
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  }
  // update quantity product
  updateQuantity(id, quantity, action) {
    const cartLoaderScope = document.getElementById("hdt-page-cart")
      ? "cart-page"
      : document.getElementById("CartDrawer")?.hasAttribute("open")
        ? "cart-drawer"
        : null;
    document.dispatchEvent(
      new CustomEvent("theme:loading:doing", {
        bubbles: !0,
        detail: { scope: cartLoaderScope },
      }),
    );
    this.removeButton(id, quantity);
    this.onLoading(id);
    let bundleSections = [];
    document.dispatchEvent(
      new CustomEvent("cart:push:section.id", {
        bubbles: true,
        detail: { sections: bundleSections },
      }),
    );
    let routeUrl = `${Shopify.routes.root}cart/change.js`;
    let body = JSON.stringify({
      quantity,
      id,
      sections_url: window.location.pathname,
      sections: bundleSections.join(","),
    });
    let fetchConfigType;

    if (action === this.actions.add) {
      fetchConfigType = "javascript";
      routeUrl = `${Shopify.routes.root}cart/add.js`;
      const addItem = window.buildCartAddItem
        ? window.buildCartAddItem(id, quantity, document.getElementById(`Quantity-${id}`))
        : {
            quantity: parseInt(quantity),
            id: parseInt(id),
          };
      body = JSON.stringify({
        items: [addItem],
        sections_url: window.location.pathname,
        sections: bundleSections.join(","),
      });
    }

    fetch(`${routeUrl}`, { ...this.fetchConfig(fetchConfigType), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let cartContent = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${id}`);

        if (quantity === 0) {
          this.resetQuantityInput(id, quantityElement, true);
        }
        quantityElement.setAttribute("data-cart-quantity", quantity);
        getterRunFn(_upate_qty, this, upate_qty_fn).call(
          this,
          cartContent,
          parseInt(id),
          action,
          bundleSections,
        );
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.updateTotalInCart();
        document.dispatchEvent(new CustomEvent("currency:update"));
        document.dispatchEvent(
          new CustomEvent("theme:loading:done", {
            bubbles: !0,
            detail: { scope: cartLoaderScope },
          }),
        );
        this.deLoading(id);
      });
  }
  resetQuantityInput(id, quantityElement, resetValue) {
    const input = quantityElement ?? document.getElementById(`Quantity-${id}`);
    input.value = input.getAttribute("value");
    resetValue
      ? (input.value = 0)
      : (input.value = input.getAttribute("value"));
  }
  updateError(updatedValue, id) {
    let message = "";
    if (typeof updatedValue === "undefined") {
      message = window.cartStrings.error;
    } else {
      message = window.cartStrings.quantityError.replace(
        "[quantity]",
        updatedValue,
      );
    }
    this.updateLiveRegions(id, message);
  }

  updateLiveRegions(id, message) {
    const variantItemError = this.getElementById("Quick-order-list-item-error");
    if (variantItemError) {
      $4(".hdt-variant-item__error-text", variantItemError).innerHTML = message;
      variantItemError.removeAttribute("hidden");
    }
  }
}
_upate_qty = new WeakSet();
upate_qty_fn = async function (cartContent, id, action) {
  const variant_in_cart = cartContent.items.find(
    (item) => item.variant_id === id,
  );
  this.updateInCart(id, variant_in_cart);
  this.dispatchEvent(new CustomEvent("quickOrder:change", { bubbles: false }));
  //document.dispatchEvent(new CustomEvent("cart:refresh"));
  let cart = cartContent;
  if (action === this.actions.add) {
    try {
      cart = await createCartPromise(true);
      if (cart && cartContent) {
        cart.sections = cartContent.sections;
      }
    } catch (error) {
      console.error("Error fetching cart after add:", error);
      // Fallback to cartContent if fetch fails
      cart = cartContent;
    }
  }
  // Only dispatch cart:change if cart is valid to prevent undefined issues
  if (cart && typeof cart === "object" && cart.item_count !== undefined) {
    document.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart,
          disabledDrawerChange: true,
        },
      }),
    );
  }
};

customElements.define("hdt-quick-order-list", QuickOrderList);

// remove variant in cart
class QuickOrderListRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const quickOrderList = this.closest("hdt-quick-order-list");
      quickOrderList.updateQuantity(this.dataset.index, 0);
      this.setAttribute("hidden", "");
    });
  }
}

customElements.define(
  "hdt-quick-order-list-remove-button",
  QuickOrderListRemoveButton,
);

// remove all variant in cart
class QuickOrderListRemoveAllButton extends HTMLElement {
  constructor() {
    super();
    this.quickOrderList = this.closest("hdt-quick-order-list");
    const allVariants = Array.from(
      this.quickOrderList.querySelectorAll("[data-variant-id]"),
    );
    const items = {};
    const list_variants = [];
    let hasVariantsInCart = false;

    allVariants.forEach((variant) => {
      const cartQty = parseInt(variant.dataset.cartQty);
      if (cartQty > 0) {
        hasVariantsInCart = true;
        items[parseInt(variant.dataset.variantId)] = 0;
        list_variants.push(variant.dataset.variantId);
      }
    });

    if (!hasVariantsInCart) {
      this.setAttribute("hidden", "");
    }

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.quickOrderList.updateMultipleQty(items, list_variants);
      this.setAttribute("hidden", "");
    });
  }
}

customElements.define(
  "hdt-quick-order-list-remove-all-button",
  QuickOrderListRemoveAllButton,
);

// Begin instagram feed api
const dataInstagramCache = {};
class instagramFeedAPI extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute("config"));
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        this.refresh_ins();
      });
      document.addEventListener("shopify:section:deselect", (event) => {
        const { acc, id } = this.config;
        var data = sessionStorage.getItem("hdt_ins" + acc + id);
        if (data != null && data != "") {
          sessionStorage.removeItem("hdt_ins" + acc + id);
        }
      });
    }
  }
  connectedCallback() {
    this.refresh_ins();
  }
  refresh_ins() {
    const { acc, id } = this.config;

    if (acc == "") return;

    var data = sessionStorage.getItem("hdt_ins" + acc + id);

    if (data != null && data != "") {
      // calculate expiration time for content,
      // to force periodic refresh after 30 minutes
      var now = new Date(),
        expiration = new Date(JSON.parse(data).timestamp);

      expiration.setMinutes(expiration.getMinutes() + 30);

      // ditch the content if too old
      if (now.getTime() > expiration.getTime()) {
        data = null;
        sessionStorage.removeItem("hdt_ins" + acc + id);
      }
    }
    if (data != null && data != "") {
      this.instagramHTML(JSON.parse(data).content, false);
    } else {
      if (dataInstagramCache[acc]) {
        $4(".hdt-slider__container", this).innerHTML = dataInstagramCache[acc];
        $4(".hdt-ins-loading", this)?.remove();
        const lazySlider = $4("hdt-slider-lazy", this);
        if (lazySlider) {
          lazySlider.hidden = false;
          lazySlider.InitLazy();
        }
        return;
      }

      fetch(
        "https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token=" +
          atob(acc),
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("not ok");
          }
          return response.json();
        })
        //.then(function(res)
        .then((res) => {
          this.instagramHTML(res.data, true);
        })
        .catch(() => {
          $4(".hdt-ins-loading", this)?.remove();
          console.error("Instagram Feed:error fetch");
        });
    }
  }
  instagramHTML(data, saveSessionStorageIns) {
    const arrIcons = ($4(".hdt-icons-ins-svg", this).innerHTML || "").split(
        "[hdtplit]",
      ),
      icons = {
        image: arrIcons[0],
        video: arrIcons[1],
        carousel_album: arrIcons[2],
      },
      { id, acc, target, limit } = this.config;
    let html = "";

    data.forEach((el, index) => {
      if (index >= limit) return 0;
      const media_type = el.media_type.toLowerCase();
      html += `<div class="hdt-slider__slide hdt-ins-type-${media_type}"><a calc-nav data-no-instant rel="nofollow" class="hdt-ins-inner hdt-block hdt-relative hdt-oh hdt-rounded" href="${
        el.permalink
      }" target="${target}"><div class="hdt-ratio"><img src="${
        el.thumbnail_url || el.media_url
      }" class="hdt-ins-img" loading="lazy"></div><div class="hdt-ins-icon">${
        icons[media_type]
      }</div></a></div>`;
    });
    dataInstagramCache[acc] = html;
    $4(".hdt-slider__container", this).innerHTML = html;
    $4(".hdt-ins-loading", this)?.remove();
    const lazySlider = $4("hdt-slider-lazy", this);
    if (lazySlider) {
      lazySlider.hidden = false;
      lazySlider.InitLazy();
    }

    if (saveSessionStorageIns) {
      sessionStorage.setItem(
        "hdt_ins" + acc + id,
        JSON.stringify({
          timestamp: new Date(),
          content: data,
        }),
      );
    }
  }
}
customElements.define("ins-feed-api", instagramFeedAPI);

// End instagram feed api

// Tab main-brands //
class TabsBrands extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll(".hdt-tab-link");
    this.tabs = this.querySelectorAll(".hdt-tab-content");
    this.addAllListeners();
  }

  addAllListeners() {
    this.links.forEach((link) => {
      link.addEventListener("click", () => {
        const tabName = link.getAttribute("data-filter");
        if (tabName === "all") {
          this.openAllTabs();
        } else {
          this.openTab(tabName);
        }
        this.links.forEach((item) => {
          item.classList.remove("is--active");
        });
        if (!link.classList.contains("is--active")) {
          link.classList.add("is--active");
        }
      });
    });
  }

  openAllTabs() {
    this.tabs.forEach((content) => {
      content.style.display = "block";
      content.style.height = "auto";
    });
    this.querySelector('[data-filter="all"]').classList.add("is--active");
  }

  openTab(tabName) {
    this.tabs.forEach((content) => {
      if (content.id === tabName) {
        content.style.display = "block";
        content.classList.add("slideInRight");
      } else {
        content.style.display = "none";
        content.classList.remove("slideInRight");
      }
    });
  }

  connectedCallback() {
    this.addAllListeners();
  }
  disconnectedCallback() {}
}

customElements.define("tabs-brands", TabsBrands);

//  //

class countryFilter extends HTMLElement {
  constructor() {
    super();
    this.search = $4("[name=country_filter]", this);
    this.reset = $4(".hdt-country_filter__reset", this);
    if (this.search) {
      this.search.addEventListener(
        "input",
        debounce((event) => {
          this.filterCountries();
        }, 200).bind(this),
      );
    }
    this.search.addEventListener("keydown", this.onSearchKeyDown.bind(this));
  }
  filterCountries() {
    const searchValue = this.search.value.toLowerCase();
    const allCountries = this.closest("hdt-popover").querySelectorAll(
      "hdt-richlist button",
    );
    let visibleCountries = allCountries.length;
    allCountries.forEach((item) => {
      const countryName = item.getAttribute("data-name").toLowerCase();
      if (countryName.indexOf(searchValue) > -1) {
        item.classList.remove("hdt-d-none");
        visibleCountries++;
      } else {
        item.classList.add("hdt-d-none");
        visibleCountries--;
      }
    });
    this.closest("hdt-popover").updatePos();
    this.closest("hdt-popover").shadowRoot.querySelector(
      ".hdt-current-scrollbar",
    ).scrollTop = 0;
  }

  onSearchKeyDown(event) {
    if (event.code.toUpperCase() === "ENTER") {
      event.preventDefault();
    }
  }
}

customElements.define("country-filter", countryFilter);

// check purchase code
if (Shopify.designMode) {
  /**
   * If it's a global variable then window[variableName] or in your case window["onlyVideo"] should do the trick.
   * https://stackoverflow.com/questions/5613834/convert-string-to-variable-name-in-javascript
   */

  var ThemeCode = atob(window[atob("Y0hWeVkyaGg=")]),
    ThemeName_base64 = window[atob("VkdobGJXVk9ZVzFsVkRR")],
    ThemeName = atob(ThemeName_base64),
    CookieName = "SXNBY3RpdmVUaGVtZQ==" + ThemeName_base64,
    ShopEmail = atob(window[atob("VTJodmNFMWxiMVEw")]),
    isTrueSet = sessionStorage.getItem(CookieName) === "true",
    str_temp_active = atob("I3Q0cy10ZW1wLWtleS1hY3RpdmU="), // #t4s-temp-key-active
    str_purchase = atob("cHVyY2hhc2VfY29kZXQ0"); // purchase_codet4;

  function alert_active_html() {
    return `<section id="${str_purchase}" style="display: flex !important">${
      $4(str_temp_active).innerHTML
    }</section>`;
  }

  if (ThemeCode == "") {
    let dom1 = new DOMParser().parseFromString(
      alert_active_html(),
      "text/html",
    );
    document.body.append(dom1.body.firstElementChild);
    let dom2 = new DOMParser().parseFromString(
      '<div id="luffyabc194"><style>body>*:not(#purchase_codet4) {opacity: 0;pointer-events: none;</style></div>',
      "text/html",
    );
    document.body.prepend(dom2.body.firstElementChild);
    sessionStorage.removeItem(CookieName);
    localStorage.removeItem(CookieName);
  } else if (!isTrueSet) {

    var domain = window.location.hostname,
      mix = [
        "4",
        "t",
        "h",
        "e",
        "p",
        "l",
        "i",
        "c",
        "o",
        "/",
        ".",
        ":",
        "n",
        "s",
      ],
      mix_domain =
        mix[2] +
        mix[1] +
        mix[1] +
        mix[4] +
        mix[13] +
        mix[11] +
        mix[9] +
        mix[9] +
        mix[5] +
        mix[6] +
        mix[7] +
        mix[10] +
        mix[1] +
        mix[2] +
        mix[3] +
        mix[0] +
        mix[10] +
        mix[7] +
        mix[8] +
        mix[9] +
        mix[5] +
        mix[6] +
        mix[7] +
        mix[3] +
        mix[12] +
        mix[13] +
        mix[3] +
        mix[9] +
        mix[7] +
        mix[2] +
        mix[3] +
        mix[7] +
        "k",
      data = {
        shopify_domain: domain,
        email: ShopEmail,
        theme: ThemeName,
        purchase_code: ThemeCode,
      };

    fetch(mix_domain, {
      headers: {
        accept: "*/*",
        "cache-control": "no-cache",
        "x-requested-with": "XMLHttpRequest",
      },
      body: btoa(encodeURIComponent(JSON.stringify(data))),
      method: "POST",
      mode: "cors",
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        throw "";
      })
      .then(function (response) {
        let dom = new DOMParser().parseFromString(
          alert_active_html(),
          "text/html",
        );

        if (response.status == 1) {
          dom.body.firstElementChild.innerHTML =
            "<p>ACTIVATED SUCCESSFULLY. Thanks for buying my theme!</p>";
          document.body.append(dom.body.firstElementChild);

          // Set a cookie to expire in 1 hour in Javascript
          var isActived = localStorage.getItem(CookieName);
          sessionStorage.setItem(CookieName, "true");

          if (isActived === "true") {
            $4(atob("I3B1cmNoYXNlX2NvZGV0NA==")).remove(); // #purchase_codet4
            // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
          } else {
            localStorage.setItem(CookieName, "true");
            setTimeout(function () {
              $4(atob("I3B1cmNoYXNlX2NvZGV0NA==")).remove(); // #purchase_codet4
              // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
            }, 1000);
          }
        } else {
          var mess = response.message;
          if (
            mess == "No sale belonging to the current user found with that code"
          ) {
            dom.body.firstElementChild.innerHTML =
              "<p>Purchase code error. It is a sales reversal or a refund. :(((</p>";
          } else if (mess.length == 58 || mess.length == 101) {
            dom.body.firstElementChild.innerHTML =
              "<p>That license key doesn't appear to be valid. Please check your purchase code again!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";
          } else if (mess.length == 104) {
            dom.body.firstElementChild.innerHTML =
              "<p>The license not match with current theme.!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";
          } else {
            try {
              var mess = mess.split("active domain `")[1].split("`. ")[0];
            } catch (err) {
              //var mess = mess;
            }
            dom.body.firstElementChild.innerHTML =
              "<p>Your purchase code is invalided since it is being activated at another store " +
              mess +
              ".<br> Please open a ticket at <a class='cg' href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> to get quick assistance.</p>";
          }
          document.body.append(dom.body.firstElementChild);
        }
      })
      .catch(function (e) {
        //}).catch((e)=>{
        console.error(e);
      });
  }
}
// end check purchase code

// readmore collection description
class DescriptionShort extends HTMLElement {
  constructor() {
    super();
    this.button_readmore = $4("[data-read-more]", this);
    this.button_readless = $4("[data-read-less]", this);
    this.short_des = $4(".hdt-collection-description-short", this);
    this.full_des = $4(".hdt-collection-description-full", this);
    if (
      !this.button_readmore ||
      !this.button_readless ||
      !this.short_des ||
      !this.full_des
    ) {
      return;
    }
    this.button_readmore.addEventListener("click", (e) => {
      e.preventDefault();
      this.short_des.classList.add("hdt-hidden");
      this.full_des.classList.remove("hdt-hidden");
    });
    this.button_readless.addEventListener("click", (e) => {
      e.preventDefault();
      this.short_des.classList.remove("hdt-hidden");
      this.full_des.classList.add("hdt-hidden");
    });
  }
}
customElements.define("description-short", DescriptionShort);

// video popup
class popupVideo extends HTMLElement {
  constructor() {
    super();
    this.modal = $4("hdt-modal", this);
    this.video = $4("hdt-video-player", this);
    this.modal.addEventListener("dialog:afterOpen", (e) => {
      this.video.play();
    });
    this.modal.addEventListener("dialog:beforeClose", (e) => {
      this.video.pause();
    });
  }
}
customElements.define("button-popup-video", popupVideo);

// product description - readmore
class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.lm_btn = this.querySelector(".hdt-pr-des-rm");
    if (!this.lm_btn) return;

    this.lm_btn.addEventListener("click", () => {
      this.classList.toggle("is--less");
    });
  }
}
customElements.define("product-description", ProductDescription);

// tabHover
class tabHover extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("mouseenter", (event) => {
      this.closest("hdt-tab")
        .querySelector('button[aria-current="true"]')
        ?.setAttribute("aria-current", false);
      this.parentElement.click();
    });
  }
}
customElements.define("tab-hover", tabHover);

Shopify.getMaxAddToCartQty = function (contextEl = null) {
  const scopedEl =
    contextEl &&
    (contextEl.closest?.("[data-atc-max]") ||
      (contextEl.matches?.("[data-atc-max]") ? contextEl : null));
  const nestedScopedEl =
    !scopedEl && contextEl?.querySelector
      ? contextEl.querySelector("[data-atc-max]")
      : null;
  const scopedMax =
    scopedEl?.getAttribute?.("data-atc-max") ||
    nestedScopedEl?.getAttribute?.("data-atc-max");
  const scopedNum = parseInt(scopedMax, 10);
  if (!isNaN(scopedNum) && scopedNum > 0) return scopedNum;
  return parseInt(window.themeHDN?.extras?.maxAddToCartQty, 10) || 14;
};

Shopify.validateAddToCartQty = async function (variantId, requestQty, contextEl = null) {
  const maxQty = Shopify.getMaxAddToCartQty(contextEl);
  const qty = parseInt(requestQty, 10) || 1;
  const idNum = parseInt(variantId, 10);
  if (isNaN(idNum)) return { allowed: true };
  try {
    let cart = null;
    if (typeof window.createCartPromise === "function") {
      cart = await window.createCartPromise();
    } else {
      const cartRes = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (cartRes.ok) cart = await cartRes.json();
    }
    if (!cart || !Array.isArray(cart.items)) return { allowed: true };
    const cartItem = cart.items.find(
      (item) => parseInt(item.variant_id, 10) === idNum,
    );
    const currentQty = cartItem ? parseInt(cartItem.quantity, 10) || 0 : 0;
    if (currentQty + qty > maxQty) {
      return {
        allowed: false,
        message: `You can't add more than ${maxQty} items`,
      };
    }
    return { allowed: true };
  } catch {
    return { allowed: true };
  }
};

Shopify.cartNotification = function (message, isError) {
  const notification = document.querySelector(".cart-notification-wrapper");
  const fallbackId = "hdt-global-cart-toast";
  const showFallbackToast = () => {
    let toast = document.getElementById(fallbackId);
    if (!toast) {
      toast = document.createElement("div");
      toast.id = fallbackId;
      toast.style.position = "fixed";
      toast.style.top = "16px";
      toast.style.left = "50%";
      toast.style.transform = "translateX(-50%)";
      toast.style.zIndex = "10050";
      toast.style.padding = "10px 14px";
      toast.style.borderRadius = "8px";
      toast.style.color = "#fff";
      toast.style.fontSize = "14px";
      toast.style.fontWeight = "500";
      toast.style.boxShadow = "0 4px 12px rgba(0,0,0,.2)";
      toast.style.maxWidth = "92vw";
      toast.style.textAlign = "center";
      toast.style.pointerEvents = "none";
      document.body.appendChild(toast);
    }
    toast.style.background = isError ? "#d6322c" : "#008001";
    toast.textContent = message || "Item added to your cart";
    toast.hidden = false;
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(() => {
      toast.hidden = true;
    }, 3000);
  };

  if (notification) {
    const textEl = notification.querySelector(".cart-notification__text");
    if (textEl) {
      textEl.textContent = message || "Item added to your cart";
    }
    notification.classList.toggle("is-error", !!isError);
    notification.classList.add("open");
    setTimeout(() => {
      notification.classList.remove("open");
      notification.classList.remove("is-error");
      if (textEl) {
        textEl.textContent = "Item added to your cart";
      }
    }, 3000);
  } else {
    showFallbackToast();
  }
};
document.addEventListener("DOMContentLoaded", () => {
  function syncCartFooterHeight() {
    if (window.location.pathname !== "/cart" || window.innerWidth > 768) return;

    const footer = document.querySelector(".hdt-page-cart__footer");
    if (!footer) return;

    const footerHeight = Math.ceil(footer.getBoundingClientRect().height) || 140;
    document.documentElement.style.setProperty(
      "--hdt-cart-footer-height",
      footerHeight + "px"
    );
  }

  // Function to handle footer and copyCodeDiv logic
  function handleCartPageAdjustments() {
    const isCartPage = window.location.pathname === "/cart";
    const cartWrap = document.querySelector(".hdt-page-cart__wrap");
    const copyCodeDiv = document.querySelector(".hdt-cart-copyCode");

    if (!isCartPage) return;

    // Keep offers above items inside the cart wrap (not outside the container).
    if (copyCodeDiv && cartWrap && copyCodeDiv.parentElement !== cartWrap) {
      const offersAnchor =
        cartWrap.querySelector(".hdt-page-cart__header-saving") ||
        cartWrap.querySelector(".hdt-page-cart__wrap-items");
      if (offersAnchor) {
        cartWrap.insertBefore(copyCodeDiv, offersAnchor);
      } else {
        cartWrap.prepend(copyCodeDiv);
      }
    }

    syncCartFooterHeight();
  }

  // Initial run on page load
  handleCartPageAdjustments();

  // Re-run after cart section AJAX refresh
  document.addEventListener("cart:change", () => {
    if (window.location.pathname === "/cart") {
      requestAnimationFrame(handleCartPageAdjustments);
    }
  });

  // Cart page: "To Pay" scrolls to price summary (drawer opens a sheet)
  document.addEventListener("click", (event) => {
    const payBtn = event.target.closest("[data-scroll-cart-price-summary]");
    if (!payBtn || window.location.pathname !== "/cart") return;
    const summary =
      document.getElementById("cart-page-price-summary-desktop") ||
      document.getElementById("cart-page-price-summary") ||
      document.getElementById("cart-drawer-price-summary");
    if (summary) {
      summary.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });

  // Run the logic on screen resize
  window.addEventListener("resize", handleCartPageAdjustments);
});

let cartContractualAnimationEndHandler = null;
let cartContractualAnimationToken = 0;

// Drives the progress bar fill animation on .next-message-inner-container-animate
Shopify.cartContractualAnimation = function (savePerStart, savePer, options) {
  const next_message = document.querySelector(".cart-progressBar .next-message");
  if (!next_message) return;
  const innerContainer = next_message.querySelector(".next-message-inner-container");
  if (!innerContainer) return;
  const innerContainerAnimate = innerContainer.querySelector(
    ".next-message-inner-container-animate",
  );
  if (!innerContainerAnimate) return;

  if (cartContractualAnimationEndHandler) {
    innerContainerAnimate.removeEventListener(
      "animationend",
      cartContractualAnimationEndHandler,
    );
    cartContractualAnimationEndHandler = null;
  }
  const animationToken = ++cartContractualAnimationToken;

  const toNumber = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  };
  const clamp = (n) => Math.max(0, Math.min(100, n));
  const targetPercent = clamp(
    toNumber(savePer ?? next_message.getAttribute("save_price_percent")),
  );
  const startPercent = clamp(
    toNumber(savePerStart ?? sessionStorage.getItem("save_price_percent")),
  );

  const runPhase = (fromPercent, toPercent, onComplete) => {
    if (animationToken !== cartContractualAnimationToken) return;

    innerContainerAnimate.style.setProperty(
      "--save-price-animate-right",
      fromPercent + "%",
    );
    innerContainerAnimate.style.setProperty(
      "--save-price-percent-start",
      fromPercent + "%",
    );
    innerContainerAnimate.style.setProperty(
      "--save-price-percent",
      toPercent + "%",
    );
    innerContainerAnimate.style.animation = "none";
    // eslint-disable-next-line no-unused-expressions
    innerContainerAnimate.offsetWidth;
    innerContainerAnimate.style.animation =
      "cartFillRight 2s cubic-bezier(0.25, 0.1, 0.9, 1) forwards";

    cartContractualAnimationEndHandler = () => {
      if (animationToken !== cartContractualAnimationToken) return;
      innerContainerAnimate.removeEventListener(
        "animationend",
        cartContractualAnimationEndHandler,
      );
      cartContractualAnimationEndHandler = null;
      sessionStorage.setItem("save_price_percent", String(toPercent));
      if (onComplete) onComplete();
    };
    innerContainerAnimate.addEventListener(
      "animationend",
      cartContractualAnimationEndHandler,
    );
  };

  // Tier-down: fill to complete (0), then animate to the new tier progress —
  // mirrors tier-up congrats (current → full bar → new %).
  if (options?.resetFirst) {
    const fullBarPercent = 0;
    runPhase(startPercent, fullBarPercent, () => {
      runPhase(fullBarPercent, targetPercent);
    });
    return;
  }

  innerContainerAnimate.style.setProperty(
    "--save-price-animate-right",
    startPercent + "%",
  );
  innerContainerAnimate.style.setProperty(
    "--save-price-percent-start",
    startPercent + "%",
  );
  innerContainerAnimate.style.setProperty(
    "--save-price-percent",
    targetPercent + "%",
  );
  innerContainerAnimate.style.animation = "none";
  // eslint-disable-next-line no-unused-expressions
  innerContainerAnimate.offsetWidth;
  innerContainerAnimate.style.animation =
    "cartFillRight 2s cubic-bezier(0.25, 0.1, 0.9, 1) forwards";
  sessionStorage.setItem("save_price_percent", String(targetPercent));
};

Shopify.cartCongrats = function (cart, pageLoad, options) {
  let next_message = document.querySelector(".cart-progressBar .next-message");
  if (!next_message) return;
  const allowCongrats = options?.allowCongrats !== false;
  let offerData = next_message.getAttribute("compare_at_value");
  let final_Offer = next_message.getAttribute("data-final_Offer");
  let oldOfferData = sessionStorage.getItem("offerData");
  const congratsMessage = next_message.getAttribute("data-current-message");
  const tierJumped =
    oldOfferData !== null &&
    parseInt(offerData, 10) > parseInt(oldOfferData, 10);
  if (
    allowCongrats &&
    ((tierJumped && next_message.getAttribute("data-congrats") == "true") ||
      (final_Offer == "true" && sessionStorage.getItem("final_Offer") == null) ||
      (options?.pageLoadCelebration && congratsMessage))
  ) {
    const messageElement = document.querySelector(
      ".sticky-cart-notification .message",
    );
    if (messageElement && congratsMessage) {
      messageElement.textContent = congratsMessage;
    }
    next_message.classList.add("enable-congrats");
    Shopify.cartContractualAnimation(undefined, 0);
    if (cartCongratsRevealTimer) clearTimeout(cartCongratsRevealTimer);
    cartCongratsRevealTimer = setTimeout(function () {
      cartCongratsRevealTimer = null;
      if (final_Offer && final_Offer == "false") {
        let messageElement = document.querySelector(
          ".sticky-cart-notification .message",
        );
        if (messageElement) {
          messageElement.textContent =
            messageElement.getAttribute("data-conditionMessage") || "";
        }
        next_message.classList.remove("enable-congrats");
        Shopify.cartContractualAnimation();
      }
    }, 3000);
  } else if (options?.tierDecreased) {
    Shopify.clearCartContractualCelebration(next_message);
  } else if (!next_message.classList.contains("enable-congrats")) {
    Shopify.cartContractualAnimation();
  }

  if (final_Offer == "true") {
    sessionStorage.setItem("final_Offer", final_Offer);
  } else {
    sessionStorage.removeItem("final_Offer");
  }
  sessionStorage.setItem("offerData", offerData);
};

Shopify.cartContractualProgress = function () {
  let next_message = document.querySelector(".cart-progressBar .next-message");
  if (!next_message) return;
  if (next_message.classList.contains("enable-congrats")) return;
  let offerData = next_message.getAttribute("compare_at_value");
  let oldOfferData = sessionStorage.getItem("offerData");
  let final_Offer = next_message.getAttribute("data-final_Offer");
  if (
    parseInt(offerData) <= parseInt(oldOfferData) &&
    final_Offer &&
    final_Offer == "false"
  ) {
    let messageElement = document.querySelector(".sticky-cart-notification .message");
    if (messageElement) {
      messageElement.textContent =
        messageElement.getAttribute("data-conditionMessage") ||
        Shopify.couponJourney?.getEmptyCartMessage?.() ||
        "";
    }
  }
};

Shopify.ensureCartContractualPlaceholderMessage = function () {
  const messageEl = document.querySelector(".sticky-cart-notification .message");
  if (!messageEl) return;
  const current = (messageEl.textContent || "").trim();
  if (current) return;
  const fallback =
    messageEl.getAttribute("data-conditionMessage") ||
    Shopify.couponJourney?.getEmptyCartMessage?.() ||
    "";
  if (fallback) {
    messageEl.textContent = fallback;
    const progressBar = document.querySelector(".cart-progressBar");
    if (progressBar) {
      progressBar.classList.toggle("char_reach", fallback.length >= 70);
    }
  }
};

Shopify.clearCartContractualCelebration = function (nextMessageEl) {
  if (!nextMessageEl) return;
  if (cartCongratsRevealTimer) {
    clearTimeout(cartCongratsRevealTimer);
    cartCongratsRevealTimer = null;
  }
  nextMessageEl.classList.remove("enable-congrats");
};

Shopify.applyCouponJourneyContractual = function (apiData, options) {
  const progressBar = document.querySelector(".cart-progressBar");
  const nextMessageEl = document.querySelector(".cart-progressBar .next-message");
  const messageEl = document.querySelector(".sticky-cart-notification .message");
  if (!progressBar || !nextMessageEl || !messageEl || !apiData?.success) return;

  const barPercentage = Number(apiData.barPercentage) || 0;
  const cssProgressPercent = Math.max(0, Math.min(100, 100 - barPercentage));
  const currentTier = Number(apiData.currentTier) || 0;
  const finalOffer = !apiData.nextMessage;
  const hasCongrats = Boolean(apiData.currentMessage);
  const displayMessage = apiData.nextMessage || apiData.currentMessage || "";
  const conditionMessage = apiData.nextMessage || "";
  const prevDomTier = parseInt(
    nextMessageEl.getAttribute("data-current-tier") ||
      nextMessageEl.getAttribute("compare_at_value") ||
      "0",
    10,
  );
  const wasFinalOffer = nextMessageEl.getAttribute("data-final_Offer") === "true";
  const tierIncreased = options?.tierIncreased === true || currentTier > prevDomTier;
  const tierDecreased =
    options?.tierDecreased === true || currentTier < prevDomTier;
  const leftFinalOffer = wasFinalOffer && !finalOffer;
  const allowCongrats = options?.allowCongrats === true;
  const deferNextMessage =
    allowCongrats &&
    tierIncreased &&
    hasCongrats &&
    Boolean(apiData.nextMessage);
  const isCelebrating =
    nextMessageEl.classList.contains("enable-congrats") &&
    !tierDecreased &&
    !leftFinalOffer;

  // Keep celebration during rapid tier-up updates, but always reset when the
  // cart drops a tier or leaves the max-tier congrats state.
  if (!isCelebrating) {
    Shopify.clearCartContractualCelebration(nextMessageEl);
  }

  nextMessageEl.setAttribute("save_price_percent", String(cssProgressPercent));
  nextMessageEl.setAttribute("compare_at_value", String(currentTier));
  nextMessageEl.setAttribute("data-current-tier", String(currentTier));
  nextMessageEl.setAttribute("data-final_Offer", String(finalOffer));
  nextMessageEl.setAttribute("data-congrats", String(hasCongrats));
  nextMessageEl.setAttribute(
    "data-current-message",
    apiData.currentMessage || "",
  );
  messageEl.setAttribute("data-conditionMessage", conditionMessage);
  if (isCelebrating) {
    return;
  }
  if (deferNextMessage) {
    messageEl.textContent = apiData.currentMessage || messageEl.textContent;
    progressBar.classList.toggle(
      "char_reach",
      (apiData.currentMessage || "").length >= 70,
    );
    return;
  }
  messageEl.textContent = displayMessage;
  progressBar.classList.toggle(
    "char_reach",
    displayMessage.length >= 70 ||
      (apiData.currentMessage || "").length >= 70,
  );
};

Shopify.applyEmptyCartContractual = function () {
  const progressBar = document.querySelector(".cart-progressBar");
  const nextMessageEl = document.querySelector(".cart-progressBar .next-message");
  const messageEl = document.querySelector(".sticky-cart-notification .message");
  if (!progressBar || !nextMessageEl || !messageEl) return;

  const emptyMessage = Shopify.couponJourney?.getEmptyCartMessage?.() || "";
  nextMessageEl.setAttribute("save_price_percent", "100");
  nextMessageEl.setAttribute("compare_at_value", "0");
  nextMessageEl.setAttribute("data-current-tier", "0");
  nextMessageEl.setAttribute("data-final_Offer", "false");
  nextMessageEl.setAttribute("data-congrats", "false");
  nextMessageEl.setAttribute("data-current-message", "");
  nextMessageEl.classList.remove("enable-congrats");
  messageEl.setAttribute("data-conditionMessage", emptyMessage);
  messageEl.textContent = emptyMessage;
  progressBar.classList.toggle("char_reach", emptyMessage.length >= 70);
};

function onCouponJourneyCartUpdate(cart) {
  if (!document.querySelector(".cart-progressBar")) return;
  if (!cart || typeof cart !== "object") return;
  Shopify.cartContractual(cart);
}

document.addEventListener("cart:change", (event) => {
  onCouponJourneyCartUpdate(event?.detail?.cart);
});

document.addEventListener("cart:refresh", (event) => {
  if (!document.querySelector(".cart-progressBar")) return;
  const cart = event?.detail?.cart;
  if (cart && typeof cart === "object" && Array.isArray(cart.items)) {
    onCouponJourneyCartUpdate(cart);
    return;
  }
  createCartPromise()
    .then((cartData) => onCouponJourneyCartUpdate(cartData))
    .catch((err) => console.error("coupon-journey cart:refresh error:", err));
});

let couponJourneyContractualTimer = null;
let couponJourneyContractualSeq = 0;
let couponJourneyPageLoadPending = true;
let cartCongratsRevealTimer = null;

function runCouponJourneyContractual(cart, couponJourney, isCartAdd) {
  const requestSeq = ++couponJourneyContractualSeq;

  couponJourney
    .fetchCouponJourney(cart, false)
    .then((apiData) => {
      if (requestSeq !== couponJourneyContractualSeq || !apiData?.success) return;

      const prevTier = sessionStorage.getItem("offerData");
      const currentTier = String(apiData.currentTier ?? 0);
      const tierIncreased =
        prevTier !== null && parseInt(currentTier, 10) > parseInt(prevTier, 10);
      const tierDecreased =
        prevTier !== null &&
        parseInt(currentTier, 10) < parseInt(prevTier, 10);
      const finalOffer = !apiData.nextMessage;

      if (
        prevTier !== null &&
        parseInt(currentTier, 10) <= parseInt(prevTier, 10) &&
        !finalOffer
      ) {
        Shopify.cartContractualProgress();
      }

      const prevBarPercent = sessionStorage.getItem("save_price_percent");
      const nextBarPercent = String(
        Math.max(0, Math.min(100, 100 - (Number(apiData.barPercentage) || 0))),
      );

      const isHydrated =
        sessionStorage.getItem("coupon_journey_hydrated") === "true";
      const reachedNewFinalTier =
        finalOffer &&
        isCartAdd &&
        sessionStorage.getItem("final_Offer") == null;
      const pageLoadCelebration =
        couponJourneyPageLoadPending &&
        !isCartAdd &&
        Boolean(apiData.currentMessage) &&
        !apiData.nextMessage;
      couponJourneyPageLoadPending = false;
      const allowCongrats =
        pageLoadCelebration ||
        (isCartAdd &&
          (tierIncreased || reachedNewFinalTier) &&
          (isHydrated || reachedNewFinalTier));

      Shopify.applyCouponJourneyContractual(apiData, {
        tierDecreased,
        tierIncreased,
        allowCongrats,
      });

      if (tierDecreased) {
        Shopify.cartContractualAnimation(prevBarPercent, nextBarPercent, {
          resetFirst: true,
        });
      } else if (!isCartAdd) {
        Shopify.cartContractualAnimation(prevBarPercent, nextBarPercent);
      }

      if (requestSeq !== couponJourneyContractualSeq) return;
      Shopify.cartCongrats(cart, true, {
        allowCongrats,
        tierDecreased,
        pageLoadCelebration,
      });
      sessionStorage.setItem("coupon_journey_hydrated", "true");
    })
    .catch((e) => {
      if (requestSeq === couponJourneyContractualSeq) {
        console.error("coupon-journey contractual error:", e);
      }
    });
}

let couponJourneyLastCompositionKey = null;

function getCouponJourneyCompositionKey(cart) {
  if (!cart || !Array.isArray(cart.items)) return "invalid";

  const itemParts = cart.items
    .map((item) => {
      const variantId = String(item?.variant_id ?? item?.id ?? "");
      const quantity = Number(item?.quantity || 0);
      return `${variantId}:${quantity}`;
    })
    .sort();

  return `${Number(cart.item_count || 0)}|${itemParts.join(",")}`;
}

function shouldRunCouponJourneyForCart(cart) {
  const nextKey = getCouponJourneyCompositionKey(cart);
  if (nextKey === "invalid") return false;

  // Always hydrate once after page load / first valid cart event.
  if (couponJourneyLastCompositionKey === null) {
    couponJourneyLastCompositionKey = nextKey;
    return true;
  }

  const changed = nextKey !== couponJourneyLastCompositionKey;
  couponJourneyLastCompositionKey = nextKey;
  return changed;
}

Shopify.cartContractual = function (cart) {
  if (!Shopify.couponJourney?.isEnabled?.()) return;

  const couponJourney = Shopify.couponJourney;
  const prevQtySum = parseInt(
    sessionStorage.getItem("coupon_journey_qty_sum") || "0",
    10,
  );
  const nextQtySum = couponJourney.getCartLineQtySum(cart);
  const isCartAdd = nextQtySum > prevQtySum;
  sessionStorage.setItem("coupon_journey_qty_sum", String(nextQtySum));

  if (!cart?.items?.length) {
    couponJourneyPageLoadPending = false;
    couponJourneyContractualSeq += 1;
    clearTimeout(couponJourneyContractualTimer);
    sessionStorage.removeItem("offerData");
    sessionStorage.removeItem("final_Offer");
    sessionStorage.removeItem("save_price_percent");
    sessionStorage.removeItem("coupon_journey_hydrated");
    sessionStorage.removeItem("coupon_journey_qty_sum");
    couponJourneyLastCompositionKey = null;
    Shopify.applyEmptyCartContractual();
    Shopify.cartContractualAnimation(100, 100);
    return;
  }

  // Skip API call if cart composition (variant_id + quantity per line) hasn't changed
  if (!shouldRunCouponJourneyForCart(cart)) return;

  Shopify.ensureCartContractualPlaceholderMessage();

  clearTimeout(couponJourneyContractualTimer);
  couponJourneyContractualTimer = setTimeout(function () {
    runCouponJourneyContractual(cart, couponJourney, isCartAdd);
  }, 50);
};

window.addEventListener("message", function (e) {
  if (e.data && e.data.name === "quantity_change") {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        Shopify.cartContractualProgress();
        Shopify.cartContractual(cart);
      });
  }
});

Shopify.cartStickyUpdate = function (cart) {
  // Get the most recent (first) item
  // Check if cart and cart.items exist and have items
  if (
    !cart ||
    !cart.items ||
    !Array.isArray(cart.items) ||
    cart.items.length === 0
  )
    return;

  const recentItem = cart.items[0];
  if (!recentItem || !recentItem.image) return;

  // Create new image element
  const img = document.createElement("img");
  img.src = recentItem.image;
  img.alt = recentItem.title;
  img.classList.add("recent-cart-item-image", "drop-in-image");
  img.style.transition = "transform 0.6s ease, opacity 0.6s ease";
  img.style.transform = "translateY(-40px)";
  img.style.opacity = "0";

  // Helper function to append new image
  function tryAppend() {
    const shadowHost = document.querySelector("shadow-dom-container");
    if (!shadowHost || !shadowHost.shadowRoot) return false;

    const target = shadowHost.shadowRoot.querySelector(".total-price-wrap");

    if (!target) return false;
    // if (cart.items.length >= 2 ) {target.style.width = '60px'; }
    // Remove duplicate of same image (avoid re-adding same)
    const exists = Array.from(
      target.querySelectorAll(".recent-cart-item-image"),
    ).some((el) => el.src === img.src);
    if (exists) return true;

    // Append new image at start
    target.append(img);

    // Keep only max 2 images
    const allImgs = target.querySelectorAll(".recent-cart-item-image");
    if (allImgs.length > 2) {
      allImgs[0].remove();
    }

    // const stickyCart = shadowHost.shadowRoot.querySelector(".sticky-cart");

    // if (stickyCart) {
    //   if (allImgs.length > 1) {
    //     // Apply padding-left ONLY on mobile devices
    //     if (window.innerWidth <= 767) {
    //       stickyCart.style.setProperty("padding", "4px 4px 4px 10px", "important");
    //     }
    //   } else {
    //     // Reset padding when only 1 image remains
    //     stickyCart.style.setProperty("padding-left", "0px", "important");
    //     stickyCart.style.setProperty("padding", "4px", "important");
    //   }
    // }
    if (target) {
      if (allImgs.length === 1) {
        target.style.setProperty("right", "12px", "important");
      } else if (allImgs.length > 1) {
        target.style.setProperty("right", "8px", "important");
      }
    }

    // Trigger animation (drop effect)
    requestAnimationFrame(() => {
      img.style.transform = "translateY(0)";
      img.style.opacity = "1";
    });

    const targetButton = shadowHost.shadowRoot.querySelector("button");

    if (!targetButton) return false;
    const plural = cart.item_count === 1 ? "" : "s";
    const cartCounter = `
        <div class="gk-cart-counter">
          <div class="gk-cart-count-text">View cart</div>
          <div class="gk-cart-count">${cart.item_count} Item${plural}</div>
        </div>
      `;

    // Update button contents
    targetButton.innerHTML = cartCounter;

    return true;
  }

  // Try immediately
  if (tryAppend()) return;

  // If not found yet, observe until element is ready
  const observer = new MutationObserver((mutations, obs) => {
    if (tryAppend()) {
      obs.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
};

Shopify.cartStickyHydrate = function (cart) {
  if (!cart.items?.length) return;

  const itemsToShow = cart.items.slice(0, 2);

  function tryAppend() {
    const shadowHost = document.querySelector("shadow-dom-container");
    if (!shadowHost?.shadowRoot) return false;

    const target = shadowHost.shadowRoot.querySelector(".total-price-wrap");
    if (!target) return false;

    // Clear existing
    target
      .querySelectorAll(".recent-cart-item-image")
      .forEach((el) => el.remove());

    itemsToShow.forEach((item, index) => {
      const img = document.createElement("img");
      img.src = item.image;
      img.classList.add("recent-cart-item-image");
      img.style.transform = `translateX(${index * 10}px)`;
      target.append(img);
    });

    // Update button text with item count
    const targetButton = shadowHost.shadowRoot.querySelector("button");
    if (targetButton) {
      const plural = cart.item_count === 1 ? "" : "s";
      const cartCounter = `
        <div class="gk-cart-counter">
          <div class="gk-cart-count-text">View cart</div>
          <div class="gk-cart-count">${cart.item_count} Item${plural}</div>
        </div>
      `;
      targetButton.innerHTML = cartCounter;
    }

    // Update positioning based on number of images
    if (target) {
      if (itemsToShow.length === 1) {
        target.style.setProperty("right", "12px", "important");
      } else if (itemsToShow.length > 1) {
        target.style.setProperty("right", "8px", "important");
      }
    }

    return true;
  }

  if (tryAppend()) return;

  const observer = new MutationObserver((_, obs) => {
    if (tryAppend()) obs.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
};

// Optional: Add CSS drop animation (if you can inject CSS)
const style = document.createElement("style");
style.textContent = `
  .drop-in-image {
    animation: dropIn 0.6s ease forwards;
  }

  @keyframes dropIn {
    0% {
      transform: translateY(-40px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;
document.head.appendChild(style);

if (document.querySelector(".cart-progressBar") !== null) {
  Shopify.ensureCartContractualPlaceholderMessage();
  Shopify.cartContractualProgress();
  const contractualNextMessage = document.querySelector(
    ".cart-progressBar .next-message",
  );
  const initialProgress = contractualNextMessage?.getAttribute(
    "save_price_percent",
  );
  if (initialProgress != null) {
    Shopify.cartContractualAnimation(initialProgress, initialProgress);
  } else {
    Shopify.cartContractualAnimation(100, 100);
  }
}

/**
 * Keep the contextual cart strip above the floating mobile toolbar / sticky ATC.
 * Toolbar uses env(safe-area-inset-bottom); a hardcoded bottom overlaps on
 * notched phones / top-chrome browsers when the visual viewport changes.
 * On PDP, always-on sticky ATC must lift the strip even without sticky-shown.
 *
 * Important: measure with offsetHeight / CSS bottoms only — never
 * clientHeight - getBoundingClientRect(). On iOS Safari that math desyncs when
 * the bottom address bar collapses, so the strip slides under the ATC and the
 * View cart pill (stacked from this var) overlaps it.
 */
(function initCartProgressBarToolbarOffset() {
  const progressBar = document.querySelector(".cart-progressBar");
  if (!progressBar) return;

  const GAP = 8;
  const mq = window.matchMedia("(max-width: 767px)");
  let ticking = false;

  function measureBottomOffset() {
    if (!mq.matches) return null;

    const toolbar =
      document.querySelector(".hdt-section-toolbar-mobile .hdt-toolbar") ||
      document.querySelector(".hdt-toolbar-mobile .hdt-toolbar");

    let stack = 0;
    let hasAnchor = false;

    if (toolbar) {
      const toolbarStyle = getComputedStyle(toolbar);
      if (
        toolbarStyle.display !== "none" &&
        toolbarStyle.visibility !== "hidden" &&
        toolbar.offsetHeight > 0
      ) {
        const toolbarBottom = parseFloat(toolbarStyle.bottom);
        stack =
          (Number.isFinite(toolbarBottom) ? toolbarBottom : 0) +
          toolbar.offsetHeight +
          (parseFloat(toolbarStyle.marginBottom) || 0);
        hasAnchor = true;
      }
    }

    const stickyAtc = document.querySelector(".hdt-sticky-btn-atc");
    const stickyAlwaysOn =
      stickyAtc &&
      stickyAtc.classList.contains("hdt-always-sticky-btn-atc-on-mobile");
    const stickyVisible =
      stickyAtc &&
      stickyAtc.offsetHeight > 0 &&
      (document.body.classList.contains("sticky-shown") || stickyAlwaysOn);

    if (stickyVisible) {
      // ATC is position:fixed; bottom:0 — its offsetHeight is the CSS bottom
      // the strip must clear. Same coordinate system as bottom: var(--…).
      const atcStyle = getComputedStyle(stickyAtc);
      const atcBottom = parseFloat(atcStyle.bottom);
      stack = Math.max(
        stack,
        (Number.isFinite(atcBottom) ? atcBottom : 0) + stickyAtc.offsetHeight,
      );
      hasAnchor = true;
    }

    if (!hasAnchor) return null;
    return Math.round(stack + GAP);
  }

  function update() {
    const bottom = measureBottomOffset();
    if (bottom == null) {
      document.documentElement.style.removeProperty("--hdt-cart-progress-bottom");
      return;
    }
    document.documentElement.style.setProperty(
      "--hdt-cart-progress-bottom",
      `${bottom}px`,
    );
  }

  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      update();
    });
  }

  update();
  window.addEventListener("resize", scheduleUpdate, { passive: true });
  window.addEventListener("orientationchange", scheduleUpdate, { passive: true });
  window.addEventListener("load", scheduleUpdate, { once: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", scheduleUpdate, {
      passive: true,
    });
    window.visualViewport.addEventListener("scroll", scheduleUpdate, {
      passive: true,
    });
  }

  if (typeof MutationObserver !== "undefined") {
    new MutationObserver(scheduleUpdate).observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  const stickyAtcEl = document.querySelector(".hdt-sticky-btn-atc");
  if (stickyAtcEl && typeof ResizeObserver !== "undefined") {
    new ResizeObserver(scheduleUpdate).observe(stickyAtcEl);
  }

  if (typeof mq.addEventListener === "function") {
    mq.addEventListener("change", scheduleUpdate);
  } else if (typeof mq.addListener === "function") {
    mq.addListener(scheduleUpdate);
  }
})();

function padPlantCounterNumber(value, length) {
  const raw = String(Math.max(0, parseInt(value, 10) || 0));
  return raw.length >= length ? raw.slice(-length) : raw.padStart(length, "0");
}

function animatePlantCounter(wrapper, attempt) {
  if (!wrapper || wrapper.dataset.counterAnimated === "true") return;

  const strips = wrapper.querySelectorAll(".plant-counter-strip");
  if (!strips.length) return;

  const sampleDigit = strips[0].querySelector(".digit");
  if (!sampleDigit) return;

  const column = sampleDigit.closest(".plant-counter-column");
  const digitHeight =
    sampleDigit.offsetHeight || (column && column.offsetHeight) || 0;

  if (!digitHeight) {
    if ((attempt || 0) < 12) {
      requestAnimationFrame(function () {
        animatePlantCounter(wrapper, (attempt || 0) + 1);
      });
    }
    return;
  }

  const digitCount =
    parseInt(wrapper.dataset.counterDigits, 10) || strips.length;
  const targetNumber = padPlantCounterNumber(
    wrapper.dataset.counterTarget || wrapper.dataset.joinedCounterNumber,
    digitCount,
  );
  const extraSpins = 20;

  wrapper.dataset.counterAnimated = "true";

  strips.forEach(function (strip, index) {
    const digit = parseInt(targetNumber[index], 10) || 0;
    const finalPosition = (extraSpins + digit) * digitHeight;

    strip.classList.add("is-animated");

    setTimeout(function () {
      strip.style.transform = "translateY(-" + finalPosition + "px)";
    }, index * 150);
  });
}

function initPlantCounterWrapper(wrapper) {
  if (!wrapper || wrapper.dataset.counterInit === "true") return;
  wrapper.dataset.counterInit = "true";

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animatePlantCounter(wrapper);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: "80px 0px" },
    );
    observer.observe(wrapper);
  } else {
    animatePlantCounter(wrapper);
  }
}

function resetPlantCounterWrapper(wrapper) {
  if (!wrapper) return;

  wrapper.dataset.counterInit = "";
  wrapper.dataset.counterAnimated = "";

  wrapper.querySelectorAll(".plant-counter-strip").forEach(function (strip) {
    strip.classList.remove("is-animated");
    strip.style.transform = "translateY(0)";
  });

  initPlantCounterWrapper(wrapper);
}

function initAllPlantCounters(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const wrappers =
    root && root.matches && root.matches("[data-plant-counter]")
      ? [root]
      : scope.querySelectorAll("[data-plant-counter]");

  wrappers.forEach(initPlantCounterWrapper);
}

function bootPlantCounters() {
  initAllPlantCounters(document);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootPlantCounters);
} else {
  bootPlantCounters();
}

document.addEventListener("lazyload:complete", bootPlantCounters);
document.addEventListener("lazyload:section-loaded", function (event) {
  if (event.detail?.slot) initAllPlantCounters(event.detail.slot);
});

document.addEventListener("shopify:section:load", function (event) {
  const section = event.target;
  if (!section || !section.querySelectorAll) return;
  section.querySelectorAll("[data-plant-counter]").forEach(resetPlantCounterWrapper);
});

// Progressive lazyload is handled by assets/lazyload-sections.js

function isTabsCarouselDataTrue(value) {
  return String(value || "").toLowerCase() === "true";
}

function readTabsCarouselAttr(el, name) {
  if (!el) return "";
  return (el.getAttribute(name) || "").trim();
}

window.applyTabsCarouselHeaderStyles = function (button) {
  var sectionEl = button
    ? button.closest("[data-tabs-carousel-section]")
    : document.querySelector("[data-tabs-carousel-section]");
  if (!sectionEl) return;

  if (!button) {
    button = sectionEl.querySelector(
      '.hdt-tabs-item-title[aria-current="true"]',
    );
    if (!button) {
      button = Array.from(
        sectionEl.querySelectorAll(".hdt-tabs-item-title"),
      ).find(function (btn) {
        var slide = btn.closest(".hdt-slider__slide");
        return !slide || !slide.classList.contains("conditional-tab--hidden");
      });
    }
  }

  var sectionHeaderDataPriority = isTabsCarouselDataTrue(
    sectionEl.getAttribute("data-section-header-data-priority"),
  );
  var sectionBgImagePriority = isTabsCarouselDataTrue(
    sectionEl.getAttribute("data-section-header-bg-image-priority"),
  );
  var defaultHeaderBgImg = readTabsCarouselAttr(
    sectionEl,
    "data-default-header-bg-img",
  );
  var sectionHeaderText1 = readTabsCarouselAttr(
    sectionEl,
    "data-section-header-text-1",
  );
  var sectionHeaderText2 = readTabsCarouselAttr(
    sectionEl,
    "data-section-header-text-2",
  );

  var hdtBrandBox =
    document.querySelector(".hdt-brand-box.header-logo-text-enabled") ||
    document.querySelector(".hdt-brand-box");
  var defaultHeaderText1 = readTabsCarouselAttr(hdtBrandBox, "data-header_text_1");
  var defaultHeaderText2 = readTabsCarouselAttr(hdtBrandBox, "data-header_text_2");

  var tabHeaderText1 = readTabsCarouselAttr(button, "data-header_text_1");
  var tabHeaderText2 = readTabsCarouselAttr(button, "data-header_text_2");
  var tabHeaderBgImg = readTabsCarouselAttr(button, "data-header_bg_img");
  var tabBgImagePriority = isTabsCarouselDataTrue(
    readTabsCarouselAttr(button, "data-header_bg_image_priority"),
  );
  var tabBgColor = button ? button.getAttribute("data-tab_bg_color") : null;

  var useImagePriority;
  var finalHeaderText1;
  var finalHeaderText2;
  var headerBgImg;

  if (sectionHeaderDataPriority) {
    finalHeaderText1 = sectionHeaderText1 || defaultHeaderText1;
    finalHeaderText2 = sectionHeaderText2 || defaultHeaderText2;
    useImagePriority = sectionBgImagePriority;
    headerBgImg = defaultHeaderBgImg;
  } else if (tabBgImagePriority) {
    useImagePriority = true;
    headerBgImg = tabHeaderBgImg || defaultHeaderBgImg;
    finalHeaderText1 = tabHeaderText1 || defaultHeaderText1;
    finalHeaderText2 = tabHeaderText2 || defaultHeaderText2;
  } else if (tabHeaderText1 || tabHeaderText2) {
    useImagePriority = false;
    finalHeaderText1 = tabHeaderText1 || defaultHeaderText1;
    finalHeaderText2 = tabHeaderText2 || defaultHeaderText2;
    headerBgImg = tabHeaderBgImg || defaultHeaderBgImg;
  } else if (sectionBgImagePriority && defaultHeaderBgImg) {
    useImagePriority = true;
    headerBgImg = defaultHeaderBgImg;
    finalHeaderText1 = tabHeaderText1 || defaultHeaderText1;
    finalHeaderText2 = tabHeaderText2 || defaultHeaderText2;
  } else {
    useImagePriority = false;
    finalHeaderText1 = tabHeaderText1 || defaultHeaderText1;
    finalHeaderText2 = tabHeaderText2 || defaultHeaderText2;
    headerBgImg = tabHeaderBgImg || defaultHeaderBgImg;
  }

  var parentSection = sectionEl.closest("section") || sectionEl;
  var tabsContentEl = parentSection.querySelector(".hdt-tabs-content-box");

  if (tabBgColor && tabsContentEl) {
    tabsContentEl.style.setProperty("--carousel_tabs_bg_color", tabBgColor);
  } else if (tabsContentEl) {
    tabsContentEl.style.setProperty("--carousel_tabs_bg_color", "#fff");
  }

  if (!hdtBrandBox) return;

  var dynamicTextBox = hdtBrandBox.querySelector(".hdt-brand-dynamic-text-box");
  var headerInlineEl = document.getElementById("header-inline");
  var showHeaderImage = useImagePriority && !!headerBgImg;

  if (showHeaderImage && headerInlineEl) {
    hdtBrandBox.classList.remove("hdt-logo-flip");
    hdtBrandBox.classList.add(
      "header-dynamic-text-hidden",
      "header-image-priority-active",
    );
    if (dynamicTextBox) dynamicTextBox.style.display = "none";
    headerInlineEl.classList.add("header-tabs-bg-image-active");
    headerInlineEl.style.setProperty(
      "--tabs-header-bg-image",
      "url(" + JSON.stringify(headerBgImg) + ")",
    );
    return;
  }

  hdtBrandBox.classList.remove(
    "header-dynamic-text-hidden",
    "header-image-priority-active",
  );
  hdtBrandBox.classList.add("hdt-logo-flip");
  if (dynamicTextBox) {
    dynamicTextBox.style.display = "";
    dynamicTextBox.style.removeProperty("opacity");
  }
  if (headerInlineEl) {
    headerInlineEl.classList.remove("header-tabs-bg-image-active");
    headerInlineEl.style.removeProperty("--tabs-header-bg-image");
    headerInlineEl.style.removeProperty("background-image");
  }
  var brandLogo = hdtBrandBox.querySelector(".hdt-brand-logo");
  if (brandLogo) brandLogo.style.removeProperty("opacity");

  var cookieEl = hdtBrandBox.querySelector(".hdt-brand-cookie-text");
  var goodnessEl = hdtBrandBox.querySelector(".hdt-brand-goodness-text");
  if (cookieEl) cookieEl.textContent = finalHeaderText1;
  if (goodnessEl) goodnessEl.textContent = finalHeaderText2;
};

document.addEventListener("lazyload:section-loaded", function (event) {
  var slot = event.detail && event.detail.slot;
  if (!slot) return;
  var sectionEl = slot.querySelector("[data-tabs-carousel-section]");
  if (!sectionEl) return;
  var activeBtn = sectionEl.querySelector(
    '.hdt-tabs-item-title[aria-current="true"]',
  );
  window.applyTabsCarouselHeaderStyles(activeBtn || null);
});

/** Product Video Carousel — play/pause videos based on visibility (for lazyload) */
(function() {
  function initProductVideoCarousel(sectionEl) {
    if (!sectionEl || sectionEl.dataset.productVideoInit === 'true') return;
    sectionEl.dataset.productVideoInit = 'true';

    const slider = sectionEl.querySelector('hdt-slider');
    if (!slider) return;

    const VISIBLE_RATIO = 0.4;
    let sectionInView = true;
    let syncRaf = 0;

    const markVideoLoaded = (video) => {
      const wrap = video?.closest('.hdt-ccmp-fetured-video');
      if (wrap) wrap.classList.add('is-video-loaded');
    };

    const isSlideVisible = (slide) => {
      if (!slide) return false;
      if (slide.classList.contains('is-in-view')) return true;

      const viewport = slider.querySelector('.hdt-slider__viewport') || slider;
      const vRect = viewport.getBoundingClientRect();
      const sRect = slide.getBoundingClientRect();
      if (sRect.width <= 0) return false;
      const overlap = Math.min(sRect.right, vRect.right) - Math.max(sRect.left, vRect.left);
      return overlap / sRect.width >= VISIBLE_RATIO;
    };

    const activateVideo = (video) => {
      if (!video) return;

      const playWhenReady = () => {
        markVideoLoaded(video);
        if (video.paused) {
          video.play().catch(() => {});
        }
      };

      if (video.readyState >= 2) {
        playWhenReady();
        return;
      }

      if (video.dataset.productVideoReady !== 'true') {
        video.dataset.productVideoReady = 'true';
        video.addEventListener('canplay', playWhenReady, { once: true });
        video.addEventListener('loadeddata', playWhenReady, { once: true });
        video.addEventListener('playing', () => markVideoLoaded(video));
      }

      if (video.readyState >= 1) {
        video.play().catch(() => {});
      }
    };

    const pauseVideo = (video) => {
      if (video && !video.paused) video.pause();
    };

    const pauseAllVideos = () => {
      sectionEl.querySelectorAll('video.hdt-featured-video').forEach(pauseVideo);
    };

    const syncSliderVideos = () => {
      if (!sectionInView) {
        pauseAllVideos();
        return;
      }

      const api = slider._sliderEmblaApi;
      const slides = api?.slideNodes?.() || sectionEl.querySelectorAll('.hdt-slider__slide');

      slides.forEach((slide) => {
        const video = slide.querySelector('video.hdt-featured-video');
        if (!video) return;
        if (isSlideVisible(slide)) {
          activateVideo(video);
        } else {
          pauseVideo(video);
        }
      });
    };

    const scheduleSync = () => {
      if (syncRaf) cancelAnimationFrame(syncRaf);
      syncRaf = requestAnimationFrame(() => {
        syncRaf = 0;
        syncSliderVideos();
      });
    };

    const bindEmblaEvents = (api) => {
      if (!api || api.__productVideoBound) return;
      api.__productVideoBound = true;
      api.on('scroll', scheduleSync);
      api.on('select', scheduleSync);
      api.on('settle', scheduleSync);
      api.on('reInit', scheduleSync);
      scheduleSync();
    };

    // Preload all videos
    sectionEl.querySelectorAll('video.hdt-featured-video').forEach((video, index) => {
      if (video.readyState === 0) video.load();

      if (index > 0 && video.dataset.frameReadyBound !== 'true') {
        video.dataset.frameReadyBound = 'true';
        const showFirstFrame = () => {
          if (video.paused) {
            try { video.currentTime = 0; } catch (_) {}
          }
        };
        video.addEventListener('loadeddata', showFirstFrame, { once: true });
        if (video.readyState >= 2) showFirstFrame();
      }
    });

    slider.addEventListener('init:slide', () => {
      bindEmblaEvents(slider._sliderEmblaApi);
      scheduleSync();
    });
    slider.addEventListener('select:slide', scheduleSync);

    // Observe section visibility
    if ('IntersectionObserver' in window) {
      const sectionObserver = new IntersectionObserver(
        (entries) => {
          sectionInView = entries.some((entry) => entry.isIntersecting);
          if (sectionInView) scheduleSync();
          else pauseAllVideos();
        },
        { threshold: 0.1 }
      );
      sectionObserver.observe(sectionEl);
    }

    // Wait for slider to init
    customElements.whenDefined('hdt-slider').then(() => {
      const tryBind = () => {
        if (slider._sliderEmblaApi) {
          bindEmblaEvents(slider._sliderEmblaApi);
          return true;
        }
        return false;
      };

      requestAnimationFrame(() => {
        if (!tryBind()) {
          const retry = setInterval(() => {
            if (tryBind()) clearInterval(retry);
          }, 100);
          setTimeout(() => clearInterval(retry), 5000);
        }
      });
    });
  }

  // Init for lazyload sections
  document.addEventListener('lazyload:section-loaded', function(event) {
    const slot = event.detail && event.detail.slot;
    if (!slot) return;
    const productVideoSection = slot.querySelector('.hdt-product-video');
    if (productVideoSection) {
      const innerSection = productVideoSection.querySelector('.hdt-section-inner') || productVideoSection;
      initProductVideoCarousel(innerSection);
    }
  });

  // Init for already-loaded sections (non-lazyload pages)
  function bootProductVideoSections() {
    document.querySelectorAll('.hdt-product-video .hdt-section-inner').forEach(initProductVideoCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootProductVideoSections);
  } else {
    bootProductVideoSections();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target?.querySelector?.('.hdt-product-video')) {
      const section = event.target.querySelector('.hdt-product-video .hdt-section-inner');
      if (section) {
        delete section.dataset.productVideoInit;
        initProductVideoCarousel(section);
      }
    }
  });
})();

function bootTabsCarouselHeaderOnLoad() {
  if (typeof window.applyTabsCarouselHeaderStyles !== "function") return;
  window.applyTabsCarouselHeaderStyles(null);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootTabsCarouselHeaderOnLoad);
} else {
  bootTabsCarouselHeaderOnLoad();
}

window.addEventListener("load", bootTabsCarouselHeaderOnLoad);

document.addEventListener("shopify:section:load", function (event) {
  if (
    event.target &&
    event.target.querySelector &&
    event.target.querySelector("[data-tabs-carousel-section]")
  ) {
    window.applyTabsCarouselHeaderStyles(null);
  }
});

document.addEventListener("shopify:section:select", function (event) {
  if (
    event.target &&
    event.target.querySelector &&
    event.target.querySelector("[data-tabs-carousel-section]")
  ) {
    window.applyTabsCarouselHeaderStyles(null);
  }
});

// Detect customers pages via body classes injected by theme
const isCustomersPage = Array.from(document.body.classList || []).some((c) =>
  c.startsWith("hdt-page-type-customers"),
);
// Detect specific pages by URL path (works even behind password page)
const isOrdersPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/orders") === 0;
const isSkinAssessmentPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/skin-assessment") === 0;
const isSkinAssessmentEboPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/skin-assessment-ebo") === 0;
const isReferPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/refer") === 0;
const isWalletPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/wallet") === 0;

// Hide GoKwik sticky cart globally (replaced by custom-sticky-cart section)
const hideGokwikStickyCart = () => {
  document.querySelectorAll("shadow-dom-container").forEach((container) => {
    if (container.shadowRoot) {
      const stickyCart = container.shadowRoot.querySelector(".sticky-cart");
      if (stickyCart) {
        stickyCart.style.setProperty("display", "none", "important");
      }

      if (!container.dataset.stickyCartObserved) {
        container.dataset.stickyCartObserved = "true";
        const shadowObserver = new MutationObserver(() => {
          const stickyCart = container.shadowRoot.querySelector(".sticky-cart");
          if (stickyCart && stickyCart.style.display !== "none") {
            stickyCart.style.setProperty("display", "none", "important");
          }
        });
        shadowObserver.observe(container.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "class"],
        });
      }
    }
  });
};
hideGokwikStickyCart();
const gokwikStickyBlocker = new MutationObserver(hideGokwikStickyCart);
gokwikStickyBlocker.observe(document.body, { childList: true, subtree: true });

if (isWalletPage) {
  const observer = new MutationObserver(() => {
    const shadowHostNector = document.querySelector(
      "#nector-reward-page-container",
    );
    if (shadowHostNector && shadowHostNector.shadowRoot) {
      const ncInfoBtns = shadowHostNector.shadowRoot.querySelectorAll(
        ".nector-user-info-btns [role='button']",
      );
      ncInfoBtns.forEach((ele) => {
        if (
          ele.textContent.toLowerCase().includes("redeem mamacash") ||
          ele.textContent.toLowerCase().includes("your coupons")
        ) {
          ele.remove();
        }
      });
      const waystoearnSec =
        shadowHostNector.shadowRoot.querySelector("#waystoearn");
      waystoearnSec?.remove();
      const waystoredeemSec =
        shadowHostNector.shadowRoot.querySelector("#waystoredeem");
      waystoredeemSec?.remove();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// kwik cart script

function injectShadowStyles() {
  const shadowHost = document.querySelector("shadow-dom-container");
  if (!shadowHost || !shadowHost.shadowRoot) return;

  const style = document.createElement("style");
  style.textContent = `
    /* Desktop styles */
  @media (min-width: 768px) {


  .sticky-cart {
    width: max-content !important;
    border-radius: 50px !important;
    margin: auto !important;
    padding: 8px !important;
    bottom: 12% !important;
  }

  .sticky-cart .total-price {
    display: none !important;
  }

  .sticky-cart button {
    background-color: transparent !important;
    color: #fff !important;
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  .gokwik-sidecart-container .toast.success {
    top: 4% !important;
    bottom: unset !important;
  }
}

/* Mobile styles */
@media (max-width: 767px) {

  .sticky-cart {
    width: max-content !important;
    border-radius: 50px !important;
    margin: auto !important;
    padding: 4px !important;
    bottom: 125px !important;
  }

  .sticky-cart .total-price {
    display: none !important;
  }

  .sticky-cart button {
    background-color: transparent !important;
    color: #fff !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    position: relative !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    gap: 1rem !important;

  }

  .total-price-wrap{
    right:8px;
  }

  .gk-cart-count {
    font-weight: 400;

  }

  .sticky-cart button::after {
    content: "";
    font-size: 0.9em;
    border-radius: 50%;
    color: white;
    background: rgb(0, 139, 119);
    -webkit-box-align: center;
    align-items: center;
    width: 3.5rem;
    height: 3.5rem;
    background-image: url(https://cdn.shopify.com/s/files/1/0888/8057/8807/files/right-white-arrow.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px;
    display: grid;
    opacity: 0.7;
    visibility: visible;
  }


  .sticky-cart .total-price-wrap {
    border: 0 !important;
    border-radius: 50% !important;
    width: 50px;
    height: 40px;
    padding: 0 !important;
  }

  .sticky-cart .total-price-wrap img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 50%;
    transition: transform 0.6s, opacity 0.6s;
    transform: translateY(0px);
    opacity: 1;
    position: absolute;
    border: 2px solid rgb(33, 122, 110);
  }

  .sticky-cart .total-price-wrap img:last-child {
    transform: translateX(10px) !important;
  }

  .sticky-cart .total-price-wrap img:first-child {
    transform: translateX(0px);
  }

  .sticky-cart .total-price-wrap svg,
  .sticky-cart .total-price-wrap span {
    display: none !important;
  }

  .gokwik-sidecart-container .toast.success {
    top: 10% !important;
    bottom: unset !important;
  }

  .sticky-cart .item-count {
    width: 1.5rem !important;
    height: 1.5rem !important;
    display: flex !important;
    padding: unset !important;
    border-radius: 50px !important;
    justify-content: center !important;
    align-items: center !important;
  }
}
  `;
  shadowHost.shadowRoot.appendChild(style);
}

// Skip shadow styling/observer on customers pages
if (!isCustomersPage) {
  // Wait for the shadow host to be added
  const observer = new MutationObserver((mutations, obs) => {
    const shadowHost = document.querySelector("shadow-dom-container");
    if (shadowHost && shadowHost.shadowRoot) {
      injectShadowStyles();
      obs.disconnect(); // Stop observing once done
      setTimeout(function () {
        fetch("/cart.js")
          .then((response) => response.json())
          .then((cart) => {
            // If cart is empty, exit early
            if (!cart.items || cart.items.length === 0) {
              return;
            }
            Shopify.cartStickyHydrate(cart);
          });
      }, 2000);
    }
  });

  window.addEventListener("message", function (e) {
    // OPTIONAL: lock down origin in production
    // if (e.origin !== window.location.origin) return;
    if (e.data && e.data.name === "close_sc") {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          // If cart is empty, exit early
          if (!cart.items || cart.items.length === 0) {
            return;
          }
          Shopify.cartStickyHydrate(cart);
        });
    }

    // Handle view_cart_clicked - click LimeChat CTA button
    if (e.data && e.data.name === "view_cart_clicked") {
      // Close LimeChat widget if it's open to avoid overlap
      (function closeLimechatIfOpen() {
        if (!window.$chatwoot) return;
        if (typeof window.$chatwoot.hide === "function") {
          window.$chatwoot.hide();
          return;
        }
        var holder = document.querySelector(".woot-widget-holder");
        var isHidden = holder && holder.classList.contains("woot--hide");
        if (!isHidden) {
          window.$chatwoot.toggle();
        }
      })();

      // Attempt to click LimeChat CTA (e.g., "View cart" button inside widget)
      (function clickLimechatCTA() {
        var tries = 0;
        var timer = setInterval(function () {
          var btn = document.querySelector(".action-button.with-text");
          if (btn) {
            btn.click();
            clearInterval(timer);
            return;
          }
          if (tries++ > 10) {
            clearInterval(timer);
          }
        }, 200);
      })();
    }
  });

  // Start observing the document for added nodes
  observer.observe(document.body, { childList: true, subtree: true });
}

// // Get the raw cart cookie
// function getCartCookie() {
//     const name = "cart=";
//     const decodedCookie = decodeURIComponent(document.cookie);
//     const parts = decodedCookie.split('; ').find(c => c.startsWith(name));
//     return parts ? parts.substring(name.length) : null;
// }

// function applyCoupon(coupon) {
//   try {
//     const rawCart = getCartCookie();

//     const response = await fetch("http://localhost:9001/apply-coupon", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ rawCart, coupon }),
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     const data = await response.json();
//     return data; // This contains the cart info and discountCodes
//   } catch (error) {
//     console.error("Error applying coupon:", error);
//     return null;
//   }
// }


document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".how-works-btn");
  const container = document.getElementById("howItWorksContainer");
  const iconContainer = btn?.querySelector(".chevron-icon");
  if (btn) {
    btn.addEventListener("click", () => {
      container.style.display =
        container.style.display === "flex" ? "none" : "flex";
      iconContainer.classList.toggle("expanded");
    });
  }
  createCartPromise().then((cart) => {
    // If cart is empty, exit early
    if (!cart.items || cart.items.length === 0) {
      return;
    }
    Shopify.cartStickyHydrate(cart);
    // Shopify.cartStickyUpdate(cart);
    Shopify.cartContractual(cart);
    // Get the most recent items (up to 2)
    // const itemsToShow = cart.items.slice(0, 2);
    // // Create image elements for each item
    // const imgs = itemsToShow.map((item, index) => {
    //   const img = document.createElement("img");
    //   img.src = item.image;
    //   img.alt = item.title;
    //   img.classList.add("recent-cart-item-image", "drop-in-image");
    //   img.style.transform = `translateY(0px) translateX(${index * 10}px)`;
    //   img.style.opacity = "1";
    //   img.style.width = "40px";
    //   img.style.height = "40px";
    //   img.style.objectFit = "cover";
    //   img.style.borderRadius = "50%";
    //   img.style.position = "absolute";
    //   img.style.border = "2px solid rgb(33, 122, 110)";
    //   return img;
    // });
    // // Helper function to append images
    // function tryAppend() {
    //   const shadowHost = document.querySelector("shadow-dom-container");
    //   if (!shadowHost || !shadowHost.shadowRoot) return false;

    //   const target = shadowHost.shadowRoot.querySelector(".total-price-wrap");

    //   if (!target) return false;

    //   // Remove existing images
    //   target.querySelectorAll(".recent-cart-item-image").forEach(img => img.remove());

    //   // Append new images
    //   imgs.forEach(img => target.append(img));

    //   // Set positioning based on number of images
    //   if (target) {
    //     if (imgs.length === 1) {
    //       target.style.setProperty("right", "12px", "important");
    //     } else if (imgs.length > 1) {
    //       target.style.setProperty("right", "8px", "important");
    //     }
    //   }

    //   const targetButton = shadowHost.shadowRoot.querySelector("button");

    //   if (!targetButton) return false;
    //   const plural = cart.item_count === 1 ? "" : "s";
    //   const cartCounter = `
    //       <div class="gk-cart-counter">
    //         <div class="gk-cart-count-text">View cart</div>
    //         <div class="gk-cart-count">${cart.item_count} Item${plural}</div>
    //       </div>
    //     `;

    //   // Update button contents
    //   targetButton.innerHTML = cartCounter;

    //   return true;
    // }

    // // Try immediately
    // if (tryAppend()) return;

    // // If not found yet, observe until element is ready
    // const observer = new MutationObserver((mutations, obs) => {
    //   if (tryAppend()) {
    //     obs.disconnect();
    //   }
    // });
    // observer.observe(document.body, { childList: true, subtree: true });
  });
});


Shopify.shareReferral = async function () {
  // const customerId = window.NectorService.getCustomerId();
  // const referralCode = await window.NectorService.getReferralCode();
  // let referralLink = referralCode ? `${Shopify.storeDomain}/?referral_code=${window.nector_data.lead.referral_code}`:`${Shopify.storeDomain}/?referral_code=${referralCode}`;
  let referralLink = `${Shopify.storeDomain}/?referral_code=${window.nector_data.lead.referral_code}`;
  let shareText = `👋Hey!!👋 
  🍃Looking for natural and toxin-free products? A world full of goodness is waiting for you at Mamaearth!🍃
  💸I’m gifting you ₹100 that you can use on your first order from Mamaearth - Asia’s 1st Brand with Made Safe Certified Products!
  All you need to do is simply use my referral link to sign up for Mamaearth: ${referralLink} or use my code: ${window.nector_data.lead.referral_code}`;

    const shareButton = event?.currentTarget || null;
    // Moengage.track_event("Refferal_Link_Share", { source: "More" });
    if (navigator.share) {
      try {
        if (shareButton) shareButton.disabled = true;
        // Moengage.track_event("Refferal_Invite_Shared");

        await navigator.share({
          title: "Refer Friends",
          text: shareText,
          url: `/?referral_code=${window.nector_data.lead.referral_code}`,
        });

      } catch (error) {
        if (error.name === "AbortError") {
        } else {
          console.error("Error sharing:", error);
        }
      } finally {
        if (shareButton) shareButton.disabled = false;
      }
    } else {
      alert("Sharing not supported in this browser");
    }
  };

Shopify.shareOnWhatsApp = async function (event) {
  event.preventDefault();
  try {
    // Moengage.track_event("Refferal_Link_Share", { source: "whatsapp" });
  } catch (e) {
    console.warn("MoEngage tracking failed", e);
  }
  const referralLink = `${Shopify.storeDomain}/?referral_code=${window.nector_data.lead.referral_code}`;
  const message = `👋Hey!!👋 🍃Looking for natural and toxin-free products? A world full of goodness is waiting for you at Mamaearth!🍃 💸I’m gifting you ₹100 that you can use on your first order from Mamaearth - Asia’s 1st Brand with Made Safe Certified Products!
  All you need to do is simply use my referral link to sign up for Mamaearth: ${referralLink} or use my code: ${window.nector_data.lead.referral_code}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank");
};

Shopify.copyReferralLink = async function () {
  // Moengage.track_event("Refferal_Link_Copy");
  const link = document.getElementById("referral-link");
  link.select();
  link.setSelectionRange(0, 99999);
  document.execCommand("copy");
};

Shopify.shareReferralLogin = async function (event) {
  window.location = window.origin + "/account/";
};

Shopify.shareOnWhatsAppLogin = async function (event) {
  window.location = window.origin + "/account/";
};

// Track Order Popup Functions
window.openTrackOrderPopup = function () {
  let popup = document.getElementById("trackOrderPopup");

  // Create popup if it doesn't exist
  if (!popup) {
    var popupHTML = `
      <div id="trackOrderPopup" class="hdt-track-order-popup-overlay" style="display: none;">
        <div class="hdt-track-order-popup-backdrop" onclick="window.closeTrackOrderPopup()"></div>
        <div class="hdt-track-order-popup-content">
          <div class="hdt-track-order-popup-close-btn" onclick="window.closeTrackOrderPopup()">
            <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="currentColor"/>
            </svg>
          </div>
          <div class="hdt-track-order-popup-header">
            <h3>Track Order</h3>
          </div>
          <div class="hdt-track-order-popup-body">
            <div class="hdt-track-order-field">
              <label for="awbNumber">AWB Number</label>
              <input
                type="text"
                id="awbNumber"
                name="awbNumber"
                placeholder="Please enter your AWB number here"
                oninput="window.handleTrackOrderInput('awb')"
              >
            </div>
            <button type="button" class="hdt-track-order-submit" id="trackOrderSubmitBtn" onclick="window.handleTrackOrder()" disabled>Track Order</button>
          </div>
        </div>
      </div>
    `;

    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = popupHTML;
    document.body.appendChild(tempDiv.firstElementChild);
    popup = document.getElementById("trackOrderPopup");
  }

  if (popup) {
    // Show popup first
    popup.style.display = "flex";
    document.body.classList.add("track-order-popup-open");

    // Trigger animation on next frame
    requestAnimationFrame(() => {
      popup.classList.add("active");
    });

    // Clear previous values
    const awbInput = document.getElementById("awbNumber");
    if (awbInput) awbInput.value = "";

    // Enable field initially
    if (awbInput) {
      awbInput.disabled = false;
      awbInput.style.opacity = "1";
    }
  } else {
    console.error("Track order popup element could not be created!");
  }
};

window.closeTrackOrderPopup = function () {
  const popup = document.getElementById("trackOrderPopup");

  if (popup) {
    popup.classList.remove("active");
    // Wait for animation to complete before hiding
    setTimeout(() => {
      popup.style.display = "none";
    }, 300);
    document.body.classList.remove("track-order-popup-open");
  }
};

// Validate that only numbers are entered
window.validateNumberInput = function (event) {
  const charCode = event.which ? event.which : event.keyCode;
  // Allow only numbers (0-9)
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
    return false;
  }
  return true;
};

// Update button state based on input
window.updateTrackOrderButton = function () {
  const awbInput = document.getElementById("awbNumber");
  const submitBtn = document.getElementById("trackOrderSubmitBtn");

  const awbValue = awbInput?.value.trim();

  // Enable button only if AWB field has a value
  if (submitBtn) {
    if (awbValue) {
      submitBtn.disabled = false;
    } else {
      submitBtn.disabled = true;
    }
  }
};

// Handle input field
window.handleTrackOrderInput = function (fieldType) {
  const awbInput = document.getElementById("awbNumber");

  // Remove any non-alphanumeric characters (keep only letters and numbers)
  if (fieldType === "awb" && awbInput) {
    awbInput.value = awbInput.value.replace(/[^a-zA-Z0-9]/g, "");
  }

  // Update button state
  window.updateTrackOrderButton();
};

window.handleTrackOrder = function () {

  const submitBtn = document.getElementById("trackOrderSubmitBtn");

  // Don't proceed if button is disabled
  if (submitBtn?.disabled) {
    return;
  }

  const awbInput = document.getElementById("awbNumber");

  const awbNumber = awbInput?.value.trim();

  if (!awbNumber) {
    alert("Please enter AWB Number");
    return;
  }

  // Validate that the input contains only alphanumeric characters
  if (!/^[a-zA-Z0-9]+$/.test(awbNumber)) {
    alert("AWB Number must contain only letters and numbers");
    return;
  }

  // Build the tracking URL with AWB number (alphanumeric only)
  const trackingUrl = `https://shiprocket.co/tracking/${awbNumber}`;

  // Close the popup
  window.closeTrackOrderPopup();

  // Redirect to tracking page
  window.location.href = trackingUrl;
};

// Close popup on Escape key
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    const popup = document.getElementById("trackOrderPopup");
    if (popup && popup.classList.contains("active")) {
      window.closeTrackOrderPopup();
    }
  }
});

// Prevent menu from closing on click when it's already open via hover (desktop only)
(function () {
  // Only run on desktop
  function isDesktop() {
    return window.innerWidth >= 768;
  }

  // Store which menus were open before click
  const openMenusBeforeClick = new WeakSet();

  // Handle clicks on menu items with submenus
  document.addEventListener(
    "click",
    function (e) {
      if (!isDesktop()) return;

      // Find the summary element that was clicked
      const summary = e.target.closest("hdt-header-menu summary");
      if (!summary) return;

      const headerMenu = summary.closest("hdt-header-menu");
      if (!headerMenu) return;

      // Check if menu is in hover mode
      const eventType = headerMenu.getAttribute("event");
      if (eventType !== "hover") return;

      // Check if menu item has children (has submenu)
      const menuItem = summary.closest(".hdt-has-children");
      if (!menuItem) return;

      // Check if menu is already open
      const details = summary.closest("details");
      if (!details) return;

      const isOpen = details.hasAttribute("open");

      // If menu is open and has children, mark it and prevent closing
      if (isOpen) {
        openMenusBeforeClick.add(details);

        // Prevent the default toggle behavior
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        return false;
      }
    },
    true,
  ); // Use capture phase to catch the event early

  // Use MutationObserver to watch for changes to the open attribute
  const observer = new MutationObserver(function (mutations) {
    if (!isDesktop()) return;

    mutations.forEach(function (mutation) {
      if (mutation.type === "attributes" && mutation.attributeName === "open") {
        const details = mutation.target;

        // If this menu was open before click and is being closed, prevent it
        if (
          openMenusBeforeClick.has(details) &&
          !details.hasAttribute("open")
        ) {
          // Reopen the menu
          details.setAttribute("open", "");
          const summary = details.querySelector("summary");
          if (summary) {
            summary.setAttribute("aria-expanded", "true");
          }

          // Remove from set after a short delay
          setTimeout(function () {
            openMenusBeforeClick.delete(details);
          }, 100);
        } else if (details.hasAttribute("open")) {
          // Menu opened, remove from tracking after delay
          setTimeout(function () {
            openMenusBeforeClick.delete(details);
          }, 100);
        }
      }
    });
  });

  // Observe all hdt-header-menu details elements
  function observeMenus() {
    if (!isDesktop()) return;

    const menuDetails = document.querySelectorAll("hdt-header-menu details");
    menuDetails.forEach(function (details) {
      observer.observe(details, {
        attributes: true,
        attributeFilter: ["open"],
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeMenus);
  } else {
    observeMenus();
  }

  // Re-observe when new content is added (for dynamic menus)
  const initObserver = new MutationObserver(function () {
    observeMenus();
  });

  if (document.body) {
    initObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();

// =====================================
// Quantity Controls for Product Cards (ATC Inc/Dec)
// =====================================
(function () {
  // Store initialized wrappers to avoid re-initialization
  const initializedWrappers = new WeakSet();
  // Cache cart data to avoid multiple fetches
  let cachedCart = null;
  let cartFetchPromise = null;
  // Sequence so only the latest cart update wins when multiple removals happen (avoids UI/count mismatch)
  let cartUpdateSequence = 0;

  // Persist variant→qty so sticky/card steppers can paint on reload without waiting for cart.js
  const CART_QTY_CACHE_KEY = "mama_cart_variant_qty_v1";

  function persistCartQtyCache(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    try {
      const map = {};
      cart.items.forEach((item) => {
        const id = String(item.variant_id);
        map[id] = (map[id] || 0) + (parseInt(item.quantity, 10) || 0);
      });
      sessionStorage.setItem(CART_QTY_CACHE_KEY, JSON.stringify(map));
    } catch (_) {
      /* private mode / quota */
    }
  }

  function getCachedVariantQty(variantId) {
    if (!variantId) return 0;
    try {
      const raw = sessionStorage.getItem(CART_QTY_CACHE_KEY);
      if (!raw) return 0;
      const map = JSON.parse(raw);
      return parseInt(map[String(variantId)], 10) || 0;
    } catch (_) {
      return 0;
    }
  }

  function bumpCachedVariantQty(variantId, qty) {
    if (!variantId) return;
    try {
      const map = JSON.parse(sessionStorage.getItem(CART_QTY_CACHE_KEY) || "{}");
      const n = parseInt(qty, 10) || 0;
      if (n > 0) map[String(variantId)] = n;
      else delete map[String(variantId)];
      sessionStorage.setItem(CART_QTY_CACHE_KEY, JSON.stringify(map));
    } catch (_) {
      /* private mode / quota */
    }
  }

  // Get cart data (cached or fetch) — prefer theme's in-flight cart.js to avoid duplicate waits
  function getCart(forceRefresh) {
    if (!forceRefresh && cachedCart) {
      return Promise.resolve(cachedCart);
    }
    if (!forceRefresh && cartFetchPromise) {
      return cartFetchPromise;
    }

    // Reuse theme createCartPromise / fetchCart when available (same cart.js request)
    if (
      !forceRefresh &&
      typeof window.createCartPromise === "function"
    ) {
      cartFetchPromise = Promise.resolve(window.createCartPromise(false))
        .then((cart) => {
          if (cart && typeof cart === "object" && Array.isArray(cart.items)) {
            cachedCart = cart;
            persistCartQtyCache(cart);
          }
          cartFetchPromise = null;
          return cachedCart || cart;
        })
        .catch((err) => {
          cartFetchPromise = null;
          throw err;
        });
      return cartFetchPromise;
    }

    if (!forceRefresh && window.fetchCart) {
      cartFetchPromise = Promise.resolve(window.fetchCart)
        .then((cart) => {
          if (cart && typeof cart === "object" && Array.isArray(cart.items)) {
            cachedCart = cart;
            persistCartQtyCache(cart);
          }
          cartFetchPromise = null;
          return cachedCart || cart;
        })
        .catch((err) => {
          cartFetchPromise = null;
          throw err;
        });
      return cartFetchPromise;
    }

    cartFetchPromise = fetch(`${window.Shopify.routes.root}cart.js`)
      .then((res) => res.json())
      .then((cart) => {
        cachedCart = cart;
        persistCartQtyCache(cart);
        cartFetchPromise = null;
        return cart;
      })
      .catch((err) => {
        cartFetchPromise = null;
        throw err;
      });
    return cartFetchPromise;
  }

  // Max add-to-cart quantity with per-product override from data-atc-max
  const getMaxAddToCartQty = (contextEl = null) =>
    Shopify.getMaxAddToCartQty(contextEl);

  // Debounce function for cart updates (reuse if available globally, otherwise define)
  const debounceCartUpdate =
    (typeof debounce !== "undefined" && debounce) ||
    function (func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };

  // Invalidate cache on cart changes (immediate for cache, debounced for UI updates)
  document.addEventListener("cart:change", function (event) {
    if (event.detail && event.detail.cart) {
      cachedCart = event.detail.cart; // Update cache immediately
      persistCartQtyCache(event.detail.cart);
    }
  });

  document.addEventListener("variant:add", function (event) {
    if (event.detail && event.detail.cart) {
      persistCartQtyCache(event.detail.cart);
    }
  });

  // Collect bundled section IDs (cart drawer, cart page, etc.) for Shopify section rendering API
  function collectCartSectionIds() {
    const sections = [];
    document.dispatchEvent(
      new CustomEvent("cart:push:section.id", {
        bubbles: true,
        detail: { sections },
      }),
    );
    return sections;
  }

  function getCartItemQuantity(cart, variantId) {
    if (!cart || !cart.items || !Array.isArray(cart.items)) return 0;
    const numericVariantId = parseInt(variantId, 10);
    const cartItem = cart.items.find((item) => {
      const itemVariantId = parseInt(item.variant_id, 10);
      return (
        itemVariantId === numericVariantId ||
        String(item.variant_id) === String(variantId)
      );
    });
    return cartItem ? parseInt(cartItem.quantity, 10) || 0 : 0;
  }

  function applyWrapperQtyUi(wrapper, qty) {
    if (!wrapper) return;

    const qtyDisplay = wrapper.querySelector(".hdt-quantity-control-qty");
    const addToCartBtn =
      wrapper.querySelector(".hdt-add-to-cart-btn") ||
      wrapper.querySelector(".hdt-sticky-atc__submit:not(.hdt-sticky-atc__submit--notifyme)");
    const tooltipWrapper = addToCartBtn
      ? addToCartBtn.closest("hdt-tooltip")
      : null;
    const quantityControls = wrapper.querySelector(
      ".hdt-card-product__quantity-controls",
    );
    const minusBtn = wrapper.querySelector(
      ".hdt-quantity-control-btn--minus",
    );
    const plusBtn = wrapper.querySelector(".hdt-quantity-control-btn--plus");

    if (!qtyDisplay || !quantityControls || !minusBtn || !plusBtn) {
      return;
    }

    const numericQty = parseInt(qty, 10) || 0;
    const updatingAction = wrapper.dataset.qtyUpdating; // "plus" | "minus" | undefined
    const isSoldOut = wrapper.dataset.soldOut === "true";

    // Sold-out / notify-me: always show CTA, never the cart qty stepper
    if (isSoldOut || !addToCartBtn) {
      wrapper.dataset.currentQuantity = "0";
      if (tooltipWrapper) tooltipWrapper.style.display = "";
      if (addToCartBtn) addToCartBtn.style.display = "";
      quantityControls.style.display = "none";
      return;
    }

    if (numericQty > 0) {
      const maxQty = getMaxAddToCartQty(wrapper);
      const displayQty = Math.min(numericQty, maxQty);
      wrapper.dataset.currentQuantity = String(displayQty);
      bumpCachedVariantQty(wrapper.dataset.variantId, displayQty);
      if (tooltipWrapper) tooltipWrapper.style.display = "none";
      addToCartBtn.style.display = "none";
      quantityControls.style.display = "flex";
      qtyDisplay.textContent = displayQty;
      // Only the clicked control stays locked while its request is in flight
      minusBtn.disabled = displayQty <= 0 || updatingAction === "minus";
      minusBtn.classList.toggle(
        "disabled",
        displayQty <= 0 || updatingAction === "minus",
      );
      plusBtn.disabled = updatingAction === "plus" || displayQty >= maxQty;
      plusBtn.classList.toggle(
        "disabled",
        updatingAction === "plus" || displayQty >= maxQty,
      );
      return;
    }

    wrapper.dataset.currentQuantity = "0";
    bumpCachedVariantQty(wrapper.dataset.variantId, 0);
    if (tooltipWrapper) tooltipWrapper.style.display = "";
    addToCartBtn.style.display = "";
    quantityControls.style.display = "none";
    qtyDisplay.textContent = "1";
    minusBtn.disabled = true;
    minusBtn.classList.add("disabled");
    plusBtn.disabled = updatingAction === "plus";
    plusBtn.classList.toggle("disabled", updatingAction === "plus");
  }

  /** Instant paint from SSR / sessionStorage — do not wait for cart.js */
  function paintWrapperFromLocalQty(wrapper) {
    if (!wrapper || wrapper.dataset.soldOut === "true") return;
    const ssrQty = parseInt(wrapper.dataset.currentQuantity, 10) || 0;
    const cachedQty = getCachedVariantQty(wrapper.dataset.variantId);
    const qty = Math.max(ssrQty, cachedQty);
    if (qty > 0) {
      applyWrapperQtyUi(wrapper, qty);
    }
  }

  /** Sync one wrapper from cart (or cached cart) using live data-variant-id */
  function syncQtyControlsWrapper(wrapper, cart) {
    if (!wrapper) return;
    if (!initializedWrappers.has(wrapper)) {
      initQuantityControls(wrapper, cart || cachedCart);
      return;
    }
    const variantId = wrapper.dataset.variantId;
    if (!variantId) return;
    const applyFromCart = (cartData) => {
      applyWrapperQtyUi(wrapper, getCartItemQuantity(cartData, variantId));
    };
    if (cart && cart.items) {
      applyFromCart(cart);
      return;
    }
    getCart()
      .then(applyFromCart)
      .catch(() => {});
  }

  window.syncQtyControlsWrapper = syncQtyControlsWrapper;

  function updateAllQuantityControls(cart) {
    if (!cart || !cart.items || !Array.isArray(cart.items)) return;
    persistCartQtyCache(cart);

    document.querySelectorAll(".hdt-qty-controls-wrapper").forEach((wrapper) => {
      if (!initializedWrappers.has(wrapper)) return;

      const variantId = wrapper.dataset.variantId;
      if (!variantId) return;

      applyWrapperQtyUi(wrapper, getCartItemQuantity(cart, variantId));
    });
  }

  function showProductCardQtyStepper(wrapper, qty) {
    if (!wrapper) return;
    if (!initializedWrappers.has(wrapper)) {
      initQuantityControls(wrapper, cachedCart);
    }
    applyWrapperQtyUi(wrapper, qty);
  }

  window.showProductCardQtyStepper = showProductCardQtyStepper;
  window.updateProductCardQtyControlsFromCart = updateAllQuantityControls;

  // Debounced refresh for noisy cart updates (kwikcart sync, section re-renders)
  const debouncedUpdateAllQuantityControls = debounceCartUpdate(
    updateAllQuantityControls,
    200,
  );

  // Single shared event listener for all quantity controls
  let cartChangeListenerAttached = false;
  if (!cartChangeListenerAttached) {
    cartChangeListenerAttached = true;
    document.addEventListener("variant:add", function (event) {
      const cart = event.detail && event.detail.cart;
      if (cart) {
        cachedCart = cart;
        updateAllQuantityControls(cart);
      }
    });
    document.addEventListener("cart:change", function (event) {
      if (event.detail && event.detail.cart) {
        cachedCart = event.detail.cart;
        const baseEvent = event.detail.baseEvent;
        if (
          baseEvent === "variant:add" ||
          baseEvent === "line-item:change" ||
          baseEvent === "kwikcart-sync"
        ) {
          updateAllQuantityControls(event.detail.cart);
        } else {
          debouncedUpdateAllQuantityControls(event.detail.cart);
        }
      }
    });
    document.addEventListener("cart:refresh", function (event) {
      const cart = event?.detail?.cart;
      if (cart && typeof cart === "object" && Array.isArray(cart.items)) {
        cachedCart = cart;
        debouncedUpdateAllQuantityControls(cart);
      }
    });
  }

  // Initialize quantity controls for a single wrapper
  function initQuantityControls(wrapper, cartData) {
    if (initializedWrappers.has(wrapper)) return;
    initializedWrappers.add(wrapper);

    const getVariantId = () => wrapper.dataset.variantId;
    const productId = wrapper.dataset.productId;
    if (!getVariantId()) return;

    const addToCartBtn =
      wrapper.querySelector(".hdt-add-to-cart-btn") ||
      wrapper.querySelector(
        ".hdt-sticky-atc__submit:not(.hdt-sticky-atc__submit--notifyme)",
      );
    const tooltipWrapper = addToCartBtn
      ? addToCartBtn.closest("hdt-tooltip")
      : null;
    const quantityControls = wrapper.querySelector(
      ".hdt-card-product__quantity-controls",
    );
    const qtyDisplay = wrapper.querySelector(".hdt-quantity-control-qty");
    const minusBtn = wrapper.querySelector(".hdt-quantity-control-btn--minus");
    const plusBtn = wrapper.querySelector(".hdt-quantity-control-btn--plus");
    const form = wrapper.querySelector("form");
    const quantityInput = wrapper.querySelector('input[name="quantity"]');

    if (!quantityControls || !qtyDisplay || !minusBtn || !plusBtn) return;

    let currentQuantity = 1;
    let isUpdating = false;
    let updatingAction = null; // "plus" | "minus" | null

    function showQuantityControls(qty) {
      applyWrapperQtyUi(wrapper, qty);
      currentQuantity = parseInt(wrapper.dataset.currentQuantity, 10) || 1;
      updateButtonStates();
    }

    function hideQuantityControls() {
      applyWrapperQtyUi(wrapper, 0);
      currentQuantity = 1;
      updateButtonStates();
    }

    function updateButtonStates() {
      const maxQty = getMaxAddToCartQty(wrapper);
      const minusLocked = updatingAction === "minus";
      const plusLocked = updatingAction === "plus";
      minusBtn.disabled = currentQuantity <= 0 || minusLocked;
      minusBtn.classList.toggle("disabled", currentQuantity <= 0 || minusLocked);
      plusBtn.disabled = plusLocked || currentQuantity >= maxQty;
      plusBtn.classList.toggle("disabled", plusLocked || currentQuantity >= maxQty);
    }

    function checkCartAndUpdate(cart) {
      if (!cart || !cart.items || !Array.isArray(cart.items)) return;
      const variantId = getVariantId();
      if (!variantId) return;

      const cartQty = getCartItemQuantity(cart, variantId);
      if (cartQty > 0) {
        showQuantityControls(cartQty);
      } else {
        hideQuantityControls();
      }
    }

    function updateQuantity(newQuantity, action) {
      const variantId = getVariantId();
      if (!variantId) return;

      // Block duplicate clicks on the same control; allow the opposite control
      if (isUpdating && updatingAction === action) return;

      const maxQty = getMaxAddToCartQty(wrapper);
      if (newQuantity > maxQty) {
        newQuantity = maxQty;
      }

      const previousQty =
        parseInt(wrapper.dataset.currentQuantity, 10) ||
        getCartItemQuantity(cachedCart, variantId) ||
        0;

      isUpdating = true;
      updatingAction = action;
      wrapper.dataset.qtyUpdating = action;
      updateButtonStates();

      // So only the latest response wins when multiple removals happen (avoids card=0 but View Cart=1)
      const mySeq = ++cartUpdateSequence;

      const cartLoaderScope =
        window.HdtCartLoader && typeof window.HdtCartLoader.getScope === "function"
          ? window.HdtCartLoader.getScope(wrapper)
          : document.getElementById("CartDrawer")?.hasAttribute("open")
            ? "cart-drawer"
            : document.getElementById("hdt-page-cart")
              ? "cart-page"
              : null;

      document.dispatchEvent(
        new CustomEvent("theme:loading:doing", {
          bubbles: true,
          detail: { scope: cartLoaderScope, fromElement: wrapper },
        }),
      );

      const sectionIds = collectCartSectionIds();

      // Use variant id directly — avoids a forced cart.js round-trip before change.js
      fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: newQuantity,
          sections: sectionIds.join(","),
        }),
      })
        .then((res) => {
          if (!res.ok) {
            return res.json().then((errBody) => {
              throw new Error(
                errBody?.description || errBody?.message || "Failed to update cart",
              );
            });
          }
          return res.json();
        })
        .then((cart) => {
          if (!cart || typeof cart !== "object") {
            throw new Error("Invalid cart response");
          }
          if (cart.status && cart.status !== 200) {
            throw new Error(cart.description || cart.message || "Cart update failed");
          }

          document.dispatchEvent(
            new CustomEvent("theme:loading:done", {
              bubbles: true,
              detail: { scope: cartLoaderScope, fromElement: wrapper },
            }),
          );

          // Only apply cart state globally if this response is still the latest (avoids stale overwrite)
          if (mySeq !== cartUpdateSequence) return;

          cachedCart = cart;
          const actualQty = getCartItemQuantity(cart, variantId);

          if (actualQty > 0) {
            showQuantityControls(actualQty);
          } else {
            hideQuantityControls();
          }

          // Sticky / card qty + — same addToCart analytics as ATC button
          if (action === "plus" && actualQty > previousQty) {
            const qtyAdded = actualQty - previousQty;
            const cartLine =
              cart.items &&
              cart.items.find(function (item) {
                return (
                  String(item.variant_id) === String(variantId) ||
                  String(item.id) === String(variantId)
                );
              });
            if (cartLine) {
              document.dispatchEvent(
                new CustomEvent("qty_control:add", {
                  bubbles: true,
                  detail: {
                    cart: cart,
                    items: [
                      Object.assign({}, cartLine, { quantity: qtyAdded }),
                    ],
                    contextEl: plusBtn,
                  },
                }),
              );
            }
          }

          if (cart.item_count !== undefined) {
            document.dispatchEvent(
              new CustomEvent("cart:change", {
                bubbles: true,
                detail: { baseEvent: "line-item:change", cart: cart },
              }),
            );
          }
        })
        .catch((err) => {
          console.error("Error updating quantity:", err);
          document.dispatchEvent(
            new CustomEvent("theme:loading:done", {
              bubbles: true,
              detail: { scope: cartLoaderScope, fromElement: wrapper },
            }),
          );
          if (mySeq !== cartUpdateSequence) return;
          getCart(true)
            .then(checkCartAndUpdate)
            .catch(() => {});
        })
        .finally(() => {
          // Don't clear lock if a newer request superseded this one
          if (mySeq !== cartUpdateSequence) return;
          isUpdating = false;
          updatingAction = null;
          delete wrapper.dataset.qtyUpdating;
          updateButtonStates();
        });
    }

    // Event listeners for +/- buttons
    // Read current quantity from display to stay in sync with external updates
    minusBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isUpdating && updatingAction === "minus") return;

      // Read current quantity from display (handles sync from kwikcart)
      const displayedQty = parseInt(qtyDisplay.textContent, 10) || 1;
      if (displayedQty > 0) {
        currentQuantity = displayedQty; // Update local variable
        updateQuantity(currentQuantity - 1, "minus");
      }
    });

    plusBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isUpdating && updatingAction === "plus") return;

      // Read current quantity from display (handles sync from kwikcart)
      const displayedQty = parseInt(qtyDisplay.textContent, 10) || 1;
      currentQuantity = displayedQty; // Update local variable

      if (currentQuantity >= getMaxAddToCartQty(wrapper)) {
        return;
      }

      updateQuantity(currentQuantity + 1, "plus");
    });

    // Form submission validation - prevent adding more than max
    if (form) {
      form.addEventListener("submit", function (e) {
        const variantId = getVariantId();
        let qtyToAdd = 1;

        // Check if there's a visible quantity input
        if (quantityInput && quantityInput.type === "number") {
          qtyToAdd = parseInt(quantityInput.value, 10) || 1;
        }

        const maxQty = getMaxAddToCartQty(wrapper);
        // First check: validate input quantity immediately (synchronous)
        if (qtyToAdd > maxQty) {
          e.preventDefault();
          e.stopPropagation();
          alert("Maximum quantity allowed is " + maxQty);
          return false;
        }

        // Second check: validate total quantity including cart (using cached cart)
        if (
          variantId &&
          cachedCart &&
          cachedCart.items &&
          Array.isArray(cachedCart.items)
        ) {
          const currentCartQty = getCartItemQuantity(cachedCart, variantId);
          const totalQty = currentCartQty + qtyToAdd;

          if (totalQty > maxQty) {
            e.preventDefault();
            e.stopPropagation();
            alert(
              "Maximum quantity allowed is " +
                maxQty +
                ". You already have " +
                currentCartQty +
                " in your cart.",
            );
            return false;
          }
        }
      });
    }

    // Instant paint from SSR / sessionStorage — remove cart.js wait for UX
    paintWrapperFromLocalQty(wrapper);

    // Reconcile with live cart (cached, theme in-flight, or fetch)
    if (cartData) {
      checkCartAndUpdate(cartData);
    } else {
      getCart()
        .then(checkCartAndUpdate)
        .catch(() => {});
    }
  }

  // Initialize quantity control wrappers (optionally scoped to a lazyload slot)
  function initAllQuantityControls(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const wrappers = scope.querySelectorAll(".hdt-qty-controls-wrapper");
    if (wrappers.length === 0) return;

    // Wire + paint immediately (SSR / sessionStorage); reconcile cart in parallel
    wrappers.forEach((wrapper) => initQuantityControls(wrapper, cachedCart));
    if (!cachedCart) {
      getCart()
        .then((cart) => {
          wrappers.forEach((wrapper) => {
            if (!initializedWrappers.has(wrapper)) {
              initQuantityControls(wrapper, cart);
            } else {
              const variantId = wrapper.dataset.variantId;
              if (!variantId) return;
              applyWrapperQtyUi(wrapper, getCartItemQuantity(cart, variantId));
            }
          });
        })
        .catch(() => {});
    }
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllQuantityControls);
  } else {
    initAllQuantityControls();
  }

  // Re-initialize when lazy content is added - run immediately
  document.addEventListener("lazyhtml:added", initAllQuantityControls);
  document.addEventListener("products:update", initAllQuantityControls);
  document.addEventListener("lazyload:complete", initAllQuantityControls);
  document.addEventListener("lazyload:section-loaded", function (event) {
    if (event.detail && event.detail.slot) {
      initAllQuantityControls(event.detail.slot);
    }
  });

  // Watch for dynamically added content - initialize immediately with cached cart
  const qtyObserver = new MutationObserver(function (mutations) {
    const newWrappers = [];
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (
            node.classList &&
            node.classList.contains("hdt-qty-controls-wrapper")
          ) {
            newWrappers.push(node);
          }
          if (node.querySelectorAll) {
            const nested = node.querySelectorAll(".hdt-qty-controls-wrapper");
            nested.forEach((w) => newWrappers.push(w));
          }
        }
      });
    });

    if (newWrappers.length > 0) {
      // Instant paint; cart reconcile in background
      newWrappers.forEach((wrapper) =>
        initQuantityControls(wrapper, cachedCart),
      );
      if (!cachedCart) {
        getCart()
          .then((cart) => {
            newWrappers.forEach((wrapper) => {
              const variantId = wrapper.dataset.variantId;
              if (!variantId) return;
              applyWrapperQtyUi(wrapper, getCartItemQuantity(cart, variantId));
            });
          })
          .catch(() => {});
      }
    }
  });

  if (document.body) {
    qtyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Listen for kwikcart quantity change events and sync product cards
  function syncCardQuantityFromKwikcart(variantId, newQuantity) {
    // Invalidate cart cache to force refresh
    cachedCart = null;
    cartFetchPromise = null;

    const wrappers = document.querySelectorAll(".hdt-qty-controls-wrapper");
    const numericVariantId = parseInt(variantId, 10);

    wrappers.forEach((wrapper) => {
      const wrapperVariantId = wrapper.dataset.variantId;
      if (!wrapperVariantId) return;

      const wrapperNumericId = parseInt(wrapperVariantId, 10);
      const matches =
        wrapperNumericId === numericVariantId ||
        String(wrapperVariantId) === String(variantId);

      if (!matches) return;

      const quantityControls = wrapper.querySelector(
        ".hdt-card-product__quantity-controls",
      );
      const qtyDisplay = wrapper.querySelector(".hdt-quantity-control-qty");
      const addToCartBtn = wrapper.querySelector(".hdt-add-to-cart-btn");
      const tooltipWrapper = addToCartBtn
        ? addToCartBtn.closest("hdt-tooltip")
        : null;
      const minusBtn = wrapper.querySelector(
        ".hdt-quantity-control-btn--minus",
      );
      const plusBtn = wrapper.querySelector(".hdt-quantity-control-btn--plus");

      if (!quantityControls || !qtyDisplay) return;

      const wrapperMax = getMaxAddToCartQty(wrapper);
      const displayQty = Math.min(newQuantity, wrapperMax);

      if (displayQty > 0) {
        // Show quantity controls
        if (tooltipWrapper) tooltipWrapper.style.display = "none";
        if (addToCartBtn) addToCartBtn.style.display = "none";
        quantityControls.style.display = "flex";
        qtyDisplay.textContent = displayQty;

        // Store quantity on wrapper for reference
        wrapper.dataset.currentQuantity = displayQty;

        // Update button states (preserve in-flight lock on the clicked control only)
        const updatingAction = wrapper.dataset.qtyUpdating;
        if (minusBtn) {
          minusBtn.disabled = displayQty <= 0 || updatingAction === "minus";
          minusBtn.classList.toggle(
            "disabled",
            displayQty <= 0 || updatingAction === "minus",
          );
        }
        if (plusBtn) {
          plusBtn.disabled = updatingAction === "plus" || displayQty >= wrapperMax;
          plusBtn.classList.toggle(
            "disabled",
            updatingAction === "plus" || displayQty >= wrapperMax,
          );
        }
      } else {
        // Hide quantity controls and show add to cart button
        if (tooltipWrapper) tooltipWrapper.style.display = "";
        if (addToCartBtn) addToCartBtn.style.display = "";
        quantityControls.style.display = "none";
        if (qtyDisplay) qtyDisplay.textContent = "1";
        wrapper.dataset.currentQuantity = "0";
      }
    });

    // Fetch actual cart and dispatch cart:change to update sticky cart and cart count
    getCart(true)
      .then((cart) => {
        if (cart && typeof cart === "object" && cart.item_count !== undefined) {
          document.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: { baseEvent: "kwikcart-sync", cart: cart },
            }),
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching cart after kwikcart sync:", err);
      });
  }

  // Listen for kwikcart quantity increase event
  window.addEventListener("message", function (e) {
    if (e.data?.name === "quantity_increase_sc" && e.data?.body) {
      const { id: variantId, quantity } = e.data.body;
      if (variantId && quantity !== undefined) {
        syncCardQuantityFromKwikcart(variantId, quantity);
      }
    }
  });

  // Listen for kwikcart quantity reduce event
  window.addEventListener("message", function (e) {
    if (e.data?.name === "quantity_reduce_sc" && e.data?.body) {
      const { id: variantId, quantity } = e.data.body;
      if (variantId && quantity !== undefined) {
        syncCardQuantityFromKwikcart(variantId, quantity);
      }
    }
  });

  // Expose globally for manual initialization if needed
  window.initProductQuantityControls = initAllQuantityControls;
})();


//  Souldout popup script
document.addEventListener("click", function (e) {
  // Check if click is on or inside the notify button - traverse up manually
  let btn = e.target;
  let found = false;
  
  // Traverse up to find the notify button (max 5 levels)
  for (let i = 0; i < 5 && btn; i++) {
    if (btn.classList && (btn.classList.contains('hdt-add-to-cart-noyify-btn') || btn.classList.contains('hdt-sticky-atc__submit--notifyme'))) {
      found = true;
      break;
    }
    btn = btn.parentElement;
  }
  
  if (!found) return;

  e.preventDefault();
  e.stopPropagation();

  // Remove existing popup
  const oldPopup = document.getElementById("notifyPopup");
  if (oldPopup) oldPopup.remove();

  // Lock body scroll
  document.body.classList.add("notify-open");

   // Get product data from notify button
  const productId = btn.getAttribute("cardselectedprodid") || "";
  const productTitle = btn.getAttribute("cardselectedprodname") || "";
  const sku = btn.getAttribute("cardselectsku") || "";
  const productUrl =
    btn.getAttribute("cardproducturl") ||
    btn.closest("hdt-card-product, .hdt-card-product, .st-product-card")?.querySelector('a[href*="/products/"]')?.href ||
    (window.location.pathname.includes("/products/") ? window.location.href.split("?")[0] : "");
  const oldProductId =
    (typeof window.getOldProductId === "function" && window.getOldProductId(btn, productId)) ||
    btn.getAttribute("cardoldproductid") ||
    (productId && window.__oldProductIdByProductId && window.__oldProductIdByProductId[String(productId)]) ||
    "";

  // Create popup
  const popup = document.createElement("div");
  popup.id = "notifyPopup";
  popup.innerHTML = `
    <div class="notify-overlay">
      <div class="notify-box">
      <form id="NotifyMeForm">
      <input type="hidden" name="form_type" value="Product Soldout notify me">
      <input type="hidden" name="utf8" value="✓">
        <span class="notify-close">
          <img src="https://cdn.shopify.com/s/files/1/0721/7558/3279/files/Group_1000007171.png?v=1775506220">
        </span>

        <div class="hdt-ntme-icon">
          <img src="https://cdn.shopify.com/s/files/1/0721/7558/3279/files/bell_icon_3bd43763-fe0e-4524-85ac-0497029b4677.png">
        </div>

        <div class="hdt-ntme-head">
          <h3 class="hdt-h5">Don’t miss the glow</h3>
        </div>

        <div class="hdt-ntme-desc">
          <p>Enter your details and we’ll notify you when it’s back in stock.</p>
        </div>

        <div class="hdt-ntme-form">
          <input type="email" placeholder="Enter your e-mail" />
          <input type="tel" placeholder="Enter mobile number" />
        </div>

        <div class="hdt-ntme-btn">
          <button type="button" class="notify-submit">Submit</button>
        </div>
        </form>

        <div data-shopify-form-id="1016810"></div>
      </div>
    </div>
  `;

  document.body.appendChild(popup);

  // Close function
  const closePopup = () => {
    popup.remove();
    document.body.classList.remove("notify-open");
  };

  // Close button
  popup.querySelector(".notify-close").onclick = closePopup;

  // Outside click
  popup.querySelector(".notify-overlay").onclick = (event) => {
    if (event.target.classList.contains("notify-overlay")) {
      closePopup();
    }
  };
  popup.querySelector(".notify-submit").onclick = (event) => {
    event.preventDefault();

    const email =
      popup.querySelector('#NotifyMeForm input[type="email"]')?.value?.trim() || "";
    const phone =
      popup.querySelector('#NotifyMeForm input[type="tel"]')?.value?.trim() || "";

    const eventPayload = {
      email: email,
      phone: phone,
      title: productTitle,
      sku: sku,
      old_product_id: oldProductId || productId,
      product_url: productUrl,
    };

    try {
      if (typeof window.trackME === "function") {
        window.trackME("notifyme", eventPayload);
      } else if (
        window.Moengage &&
        typeof window.Moengage.track_event === "function"
      ) {
        window.Moengage.track_event("notifyme", eventPayload);
      }
    } catch (err) {
      console.warn("MoEngage tracking failed", err);
    }

    closePopup();
  };

});

  (function () {
    var TIMER_SELECTOR =
      '.sec_lightingsale, .tag.lightingsale, .sale-timer, .variant-sale-timer';

    function parseSaleTimestampMs(raw) {
      if (raw == null || raw === '') return NaN;
      var trimmed = String(raw).trim();
      if (/^\d+$/.test(trimmed)) {
        var num = parseInt(trimmed, 10);
        return trimmed.length <= 10 ? num * 1000 : num;
      }
      var parsed = Date.parse(trimmed);
      return isNaN(parsed) ? NaN : parsed;
    }

    function getSaleTimestampMs(root) {
      if (root.hasAttribute('data-sale-timestamp')) {
        return parseSaleTimestampMs(root.getAttribute('data-sale-timestamp'));
      }
      if (root.hasAttribute('saletimerdata')) {
        return parseSaleTimestampMs(root.getAttribute('saletimerdata'));
      }
      var span = root.querySelector('[data-sale-timestamp]');
      return span ? parseSaleTimestampMs(span.getAttribute('data-sale-timestamp')) : NaN;
    }

    function getDisplayElements(root) {
      if (root.classList.contains('sale-timer') || root.classList.contains('variant-sale-timer')) {
        var stamp = root.querySelector('[data-sale-timestamp]');
        return stamp ? [stamp] : [];
      }
      var timers = root.querySelectorAll('.lightingsaletimer');
      if (timers.length) return Array.from(timers);
      var fallback = root.querySelector('[data-sale-timestamp]');
      return fallback ? [fallback] : [];
    }

    function resolveTimerFormat(root, displayEl) {
      var format = root.getAttribute('data-timer-format');
      if (format) return format;
      var sample = displayEl && displayEl.textContent ? displayEl.textContent : '';
      if (sample.indexOf('h :') !== -1) return 'spaced-colon';
      if (sample.indexOf('h:') !== -1) return 'colon';
      return 'spaced';
    }

    function formatSaleTime(hours, minutes, seconds, format) {
      if (format === 'colon') {
        return hours + 'h:' + minutes + 'm:' + seconds + 's';
      }
      if (format === 'spaced-colon') {
        return hours + 'h : ' + minutes + 'm : ' + seconds + 's';
      }
      return hours + 'h ' + minutes + 'm ' + seconds + 's';
    }

    function hideExpiredTimer(root) {
      if (root.classList.contains('sec_lightingsale') || root.classList.contains('lightingsale')) {
        var labelWrap = root.closest('.lightingsaletag_labels');
        (labelWrap || root).style.display = 'none';
        return;
      }

      var lightningBanner = root.closest('.lightning-timer-banner');
      if (lightningBanner) {
        lightningBanner.style.display = 'none';
        return;
      }

      root.style.display = 'none';

      var variantContents = root.closest('.variant-contents');
      if (variantContents) {
        var stockDiv = variantContents.querySelector('.variant-avalability:not(.sale-timer)');
        if (stockDiv) stockDiv.style.display = 'block';
      }
    }

    function initTimerRoot(root) {
      if (
        root.getAttribute('data-timer-initialized') === 'true' ||
        root.dataset.timerActive === 'true'
      ) {
        return;
      }

      var saleTimestampMs = getSaleTimestampMs(root);
      if (isNaN(saleTimestampMs) || saleTimestampMs <= 0) return;

      var displayEls = getDisplayElements(root);
      if (!displayEls.length) return;

      var format = resolveTimerFormat(root, displayEls[0]);

      root.setAttribute('data-timer-initialized', 'true');
      root.dataset.timerActive = 'true';

      function updateTimer() {
        var distance = saleTimestampMs - Date.now();
        if (distance <= 0) {
          hideExpiredTimer(root);
          root.dataset.timerActive = 'false';
          return false;
        }

        var hours = Math.floor(distance / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        var timeString = formatSaleTime(hours, minutes, seconds, format);

        displayEls.forEach(function (el) {
          el.textContent = timeString;
        });
        return true;
      }

      if (!updateTimer()) return;

      var interval = setInterval(function () {
        if (!updateTimer()) clearInterval(interval);
      }, 1000);
    }

    window.initSaleTimers = function () {
      document.querySelectorAll(TIMER_SELECTOR).forEach(initTimerRoot);
    };

    var STRAPPY_TIMER_SELECTOR = '[data-strappy-timer]';

    function getStrappyEndTimeMs(timer) {
      var ts = parseSaleTimestampMs(timer.getAttribute('data-end-timestamp'));
      if (!isNaN(ts) && ts > 0) return ts;
      return parseSaleTimestampMs(timer.getAttribute('data-end-date'));
    }

    function initStrappyTimerRoot(timer) {
      if (timer.getAttribute('data-strappy-timer-ready') === 'true') return;

      var endTime = getStrappyEndTimeMs(timer);
      if (isNaN(endTime) || endTime <= 0) return;

      timer.setAttribute('data-strappy-timer-ready', 'true');

      var circumference = parseFloat(timer.getAttribute('data-ring-circumference')) || 213.6;
      var daysEl = timer.querySelector('[data-days]');
      var hoursEl = timer.querySelector('[data-hours]');
      var minutesEl = timer.querySelector('[data-minutes]');
      var secondsEl = timer.querySelector('[data-seconds]');
      var dayRing = timer.querySelector('[data-ring-progress="days"]');
      var hourRing = timer.querySelector('[data-ring-progress="hours"]');
      var minuteRing = timer.querySelector('[data-ring-progress="minutes"]');
      var secondRing = timer.querySelector('[data-ring-progress="seconds"]');
      var dayDot = timer.querySelector('[data-ring-dot="days"]');
      var hourDot = timer.querySelector('[data-ring-dot="hours"]');
      var minuteDot = timer.querySelector('[data-ring-dot="minutes"]');
      var secondDot = timer.querySelector('[data-ring-dot="seconds"]');
      var timerRoot = timer.closest('.collection-banner-strappy-timer, .collection-banner-desktop-timer');
      var heading = timerRoot && timerRoot.querySelector('.collection-banner-strappy-timer__heading, .collection-banner-desktop-timer__heading');

      function setRingProgress(ring, progress, dotArm) {
        if (!ring) return;
        var clamped = Math.max(0, Math.min(1, progress));
        ring.style.strokeDashoffset = String(circumference * (1 - clamped));
        if (dotArm) {
          dotArm.style.transform = 'rotate(' + clamped * 360 + 'deg)';
        }
      }

      function pad2(num) {
        return num < 10 ? '0' + num : String(num);
      }

      function setValue(el, value) {
        if (!el || el.textContent === value) return;
        el.textContent = value;
      }

      function updateTimer() {
        var distance = endTime - Date.now();

        if (distance <= 0) {
          setValue(daysEl, '00');
          setValue(hoursEl, '00');
          setValue(minutesEl, '00');
          setValue(secondsEl, '00');
          setRingProgress(dayRing, 0, dayDot);
          setRingProgress(hourRing, 0, hourDot);
          setRingProgress(minuteRing, 0, minuteDot);
          setRingProgress(secondRing, 0, secondDot);
          if (heading) heading.textContent = 'Offer has expired';
          return false;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        var dayProgress = ((days % 30) + hours / 24) / 30;
        var hourProgress = (hours + minutes / 60 + seconds / 3600) / 24;
        var minuteProgress = (minutes + seconds / 60) / 60;
        var secondProgress = seconds / 60;

        setValue(daysEl, pad2(days));
        setValue(hoursEl, pad2(hours));
        setValue(minutesEl, pad2(minutes));
        setValue(secondsEl, pad2(seconds));
        setRingProgress(dayRing, dayProgress, dayDot);
        setRingProgress(hourRing, hourProgress, hourDot);
        setRingProgress(minuteRing, minuteProgress, minuteDot);
        setRingProgress(secondRing, secondProgress, secondDot);
        return true;
      }

      if (!updateTimer()) return;

      var interval = setInterval(function () {
        if (!updateTimer()) clearInterval(interval);
      }, 1000);
    }

    window.initStrappyTimers = function (root) {
      var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
      scope.querySelectorAll(STRAPPY_TIMER_SELECTOR).forEach(initStrappyTimerRoot);
    };

    window.variantSaleTimerInit = window.initSaleTimers;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        window.initSaleTimers();
        window.initStrappyTimers();
      });
    } else {
      window.initSaleTimers();
      window.initStrappyTimers();
    }

    if (typeof window.saleTimerObserver === 'undefined') {
      window.saleTimerObserver = new MutationObserver(function (mutations) {
        var hasNewTimers = false;

        mutations.forEach(function (mutation) {
          if (mutation.type !== 'childList' || !mutation.addedNodes.length) return;

          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            if (
              (node.matches && node.matches(TIMER_SELECTOR)) ||
              (node.querySelector && node.querySelector(TIMER_SELECTOR)) ||
              (node.matches && node.matches(STRAPPY_TIMER_SELECTOR)) ||
              (node.querySelector && node.querySelector(STRAPPY_TIMER_SELECTOR))
            ) {
              hasNewTimers = true;
            }
          });
        });

        if (hasNewTimers) {
          window.initSaleTimers();
          window.initStrappyTimers();
        }
      });

      window.saleTimerObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    document.addEventListener('products:update', function () {
      window.initSaleTimers();
    });
    document.addEventListener('theme:loading:done', function () {
      window.initSaleTimers();
    });
    document.addEventListener('products:update', function () {
      window.initStrappyTimers();
    });
    document.addEventListener('theme:loading:done', function () {
      window.initStrappyTimers();
    });
    document.addEventListener('shopify:section:load', function (event) {
      window.initStrappyTimers(event.target);
    });
  })();

  /** Standard PDP mobile — Meta PDP–style carousel scroll segments */
  (function initStdPdpMediaScrollIndicator() {
    const BAR_CLASS = "std-pdp-scroll-progress-bar";
    const INDICATOR_CLASS = "std-pdp-scroll-progress-indicator";
    const ATTR = "data-std-pdp-media-scroll";
    const EMBLA_EVENTS = ["init", "reInit", "select", "scroll", "resize"];

    function getSlides(track) {
      return track.querySelectorAll(".hdt-slider__slide:not([hidden])");
    }

    function setIndicatorPosition(barsEl, fractionalIndex) {
      const bars = barsEl.querySelectorAll("." + BAR_CLASS);
      const indicator = barsEl.querySelector("." + INDICATOR_CLASS);
      if (!bars.length || !indicator) return;

      const maxIndex = bars.length - 1;
      const scrollIndex = Math.max(0, Math.min(fractionalIndex, maxIndex));
      const low = Math.floor(scrollIndex);
      const high = Math.min(Math.ceil(scrollIndex), maxIndex);
      const t = scrollIndex - low;
      const x =
        bars[low].offsetLeft + (bars[high].offsetLeft - bars[low].offsetLeft) * t;
      indicator.style.transform = "translate3d(" + x + "px, 0, 0)";
    }

    function getFractionalIndexFromRects(track, slides) {
      if (slides.length <= 1) return 0;
      const trackRect = track.getBoundingClientRect();
      const viewportCenter = trackRect.left + trackRect.width / 2;

      for (let i = 0; i < slides.length - 1; i++) {
        const r1 = slides[i].getBoundingClientRect();
        const r2 = slides[i + 1].getBoundingClientRect();
        const c1 = r1.left + r1.width / 2;
        const c2 = r2.left + r2.width / 2;
        if (viewportCenter <= c1) return i;
        if (viewportCenter <= c2) {
          const span = c2 - c1;
          return span > 0 ? i + (viewportCenter - c1) / span : i;
        }
      }
      return slides.length - 1;
    }

    function buildBars(barsEl, track) {
      const slides = getSlides(track);
      const wrap = barsEl.closest(".std-pdp-media-scroll-progress");
      barsEl.innerHTML = "";
      if (slides.length <= 1) {
        if (wrap) wrap.classList.add("hdt-hidden");
        return;
      }
      if (wrap) wrap.classList.remove("hdt-hidden");
      slides.forEach(() => {
        const bar = document.createElement("div");
        bar.className = BAR_CLASS;
        barsEl.appendChild(bar);
      });
      const indicator = document.createElement("div");
      indicator.className = INDICATOR_CLASS;
      barsEl.appendChild(indicator);
    }

    function bindOne(barsEl) {
      if (barsEl.dataset.stdPdpScrollBound === "true") return;
      const viewportId = barsEl.getAttribute("data-viewport-id");
      const track = viewportId ? document.getElementById(viewportId) : null;
      if (!track) return;
      barsEl.dataset.stdPdpScrollBound = "true";

      let emblaApi = null;
      let rafId = null;

      const updateIndicator = () => {
        const bars = barsEl.querySelectorAll("." + BAR_CLASS);
        if (!bars.length) return;

        if (emblaApi) {
          try {
            if (emblaApi.internalEngine().options.active) {
              const snapCount = emblaApi.scrollSnapList().length;
              if (snapCount > 1) {
                setIndicatorPosition(
                  barsEl,
                  emblaApi.scrollProgress() * (snapCount - 1),
                );
                return;
              }
            }
          } catch (e) {
            /* Embla not ready */
          }
        }

        const slides = getSlides(track);
        if (!slides.length) return;
        setIndicatorPosition(barsEl, getFractionalIndexFromRects(track, slides));
      };

      const scheduleUpdate = () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          updateIndicator();
        });
      };

      let tracking = false;
      let trackingRaf = null;

      const trackLoop = () => {
        updateIndicator();
        if (tracking) trackingRaf = requestAnimationFrame(trackLoop);
      };

      const startTracking = () => {
        if (tracking) return;
        tracking = true;
        trackLoop();
      };

      const stopTracking = () => {
        tracking = false;
        if (trackingRaf) {
          cancelAnimationFrame(trackingRaf);
          trackingRaf = null;
        }
        scheduleUpdate();
      };

      const attachEmbla = (api) => {
        if (!api || emblaApi === api) return;
        if (emblaApi) {
          EMBLA_EVENTS.forEach((evt) => emblaApi.off(evt, scheduleUpdate));
        }
        emblaApi = api;
        EMBLA_EVENTS.forEach((evt) => api.on(evt, scheduleUpdate));
        scheduleUpdate();
      };

      const sync = () => {
        const prevCount = barsEl.querySelectorAll("." + BAR_CLASS).length;
        const nextCount = getSlides(track).length;
        if (prevCount !== nextCount) buildBars(barsEl, track);
        scheduleUpdate();
      };

      buildBars(barsEl, track);

      const sliderRoot = track.closest("hdt-slider");
      if (sliderRoot) {
        if (sliderRoot._sliderEmblaApi) attachEmbla(sliderRoot._sliderEmblaApi);
        ["init:slide", "select:slide"].forEach((evt) => {
          sliderRoot.addEventListener(evt, (e) => {
            if (e.detail && e.detail.sliderApi) attachEmbla(e.detail.sliderApi);
            scheduleUpdate();
          });
        });
      }

      track.addEventListener("touchstart", startTracking, { passive: true });
      track.addEventListener("touchend", () => setTimeout(stopTracking, 500), {
        passive: true,
      });
      track.addEventListener("touchcancel", stopTracking, { passive: true });

      scheduleUpdate();

      if (window.ResizeObserver) {
        const ro = new ResizeObserver(sync);
        ro.observe(track);
      }

      const container = track.querySelector(".hdt-slider__container");
      if (container && window.MutationObserver) {
        const mo = new MutationObserver(sync);
        mo.observe(container, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ["hidden", "class"],
        });
      }
    }

    function scan(root) {
      (root || document).querySelectorAll("[" + ATTR + "]").forEach(bindOne);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => scan(document));
    } else {
      scan(document);
    }

    document.addEventListener("shopify:section:load", (e) => {
      if (e.target && typeof e.target.querySelectorAll === "function") {
        scan(e.target);
      }
    });
  })();

  (function initPdpMediaReelPreview() {
    const DISMISS_PREFIX = "pdp-reel-preview-dismissed-v2-";

    function dismissKey(productId) {
      return DISMISS_PREFIX + productId;
    }

    function normalizeMediaUrl(url) {
      if (typeof url !== "string") return "";
      const trimmed = url.trim();
      if (!trimmed) return "";
      if (/^https?:\/\//i.test(trimmed)) return trimmed;
      if (trimmed.indexOf("//") === 0) return "https:" + trimmed;
      return "";
    }

    function getCreatorReelMedia() {
      const container = document.querySelector(
        '.creator-reels-wrapper .creator-reels__video-wrapper[data-reel-index="0"] .creator-reels__video-container',
      );
      if (!container) return null;
      const carouselVideo = container.querySelector(".creator-reels__video");
      const url = normalizeMediaUrl(
        container.getAttribute("data-video-url") ||
          carouselVideo?.getAttribute("src") ||
          "",
      );
      const thumbnail = normalizeMediaUrl(
        container.getAttribute("data-video-thumbnail") ||
          carouselVideo?.getAttribute("poster") ||
          "",
      );
      return { url, thumbnail };
    }

    function applyReelMediaToVideo(video, el) {
      const fromSection = getCreatorReelMedia();
      const dataUrl = normalizeMediaUrl(el.getAttribute("data-reel-url") || "");
      const dataThumb = normalizeMediaUrl(el.getAttribute("data-reel-thumbnail") || "");
      const url = fromSection?.url || dataUrl;
      const thumb = fromSection?.thumbnail || dataThumb;

      if (url && video.getAttribute("src") !== url) {
        video.setAttribute("src", url);
      }
      if (thumb) {
        video.setAttribute("poster", thumb);
      }
      return Boolean(url);
    }

    function tryPlayPreview(video) {
      if (!video || window.matchMedia("(min-width: 768px)").matches) return;
      if (video.dataset.frameReady !== "true") return;
      if (video.paused) video.play().catch(function () {});
    }

    function primeVideoFirstFrame(video, el) {
      if (!video || video.dataset.framePrimed === "true") return;

      const hasSrc = applyReelMediaToVideo(video, el);
      if (!hasSrc) return;

      video.dataset.framePrimed = "true";

      const media = video.closest(".pdp-media-reel-preview__media");
      let markedReady = false;

      function markFrameReady() {
        if (markedReady) return;
        markedReady = true;
        video.dataset.frameReady = "true";
        if (media) media.classList.add("is-frame-ready");
        tryPlayPreview(video);
      }

      if (video.getAttribute("poster")) {
        markFrameReady();
      }

      function seekToFirstFrame() {
        try {
          if (video.readyState >= 2) {
            const target = video.duration > 0 ? Math.min(0.05, video.duration * 0.01) : 0.001;
            if (Math.abs(video.currentTime - target) > 0.0005) {
              video.currentTime = target;
              return;
            }
          }
        } catch (err) {
          /* ignore seek errors */
        }
        markFrameReady();
      }

      video.addEventListener("loadeddata", seekToFirstFrame, { once: true });
      video.addEventListener("seeked", markFrameReady, { once: true });

      video.load();
    }

    function retryPrimePreview(el) {
      const video = el.querySelector(".pdp-media-reel-preview__video");
      if (!video) return;
      video.dataset.framePrimed = "false";
      primeVideoFirstFrame(video, el);
    }

    function bindPreview(el) {
      if (!el || el.dataset.pdpReelPreviewBound === "true") return;
      el.dataset.pdpReelPreviewBound = "true";

      const productId = el.getAttribute("data-product-id");
      if (productId && sessionStorage.getItem(dismissKey(productId)) === "1") {
        el.classList.add("is-dismissed");
        return;
      }

      const video = el.querySelector(".pdp-media-reel-preview__video");
      const closeBtn = el.querySelector("[data-pdp-media-reel-preview-close]");

      if (video) {
        primeVideoFirstFrame(video, el);
        if (!video.getAttribute("src")) {
          let attempts = 0;
          const retryTimer = setInterval(function () {
            attempts += 1;
            retryPrimePreview(el);
            if (video.getAttribute("src") || attempts >= 15) {
              clearInterval(retryTimer);
            }
          }, 200);
        }
      }

      if (closeBtn) {
        closeBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (video) video.pause();
          el.classList.add("is-dismissed");
          if (productId) sessionStorage.setItem(dismissKey(productId), "1");
        });
      }

      function openReelPopup() {
        if (typeof window.openCreatorReelsPopup === "function") {
          window.openCreatorReelsPopup(0);
          return;
        }
        const wrapper = document.querySelector(
          ".creator-reels-wrapper .creator-reels__video-wrapper[data-reel-index='0'] .creator-reels__video-container",
        );
        if (wrapper) wrapper.click();
      }

      el.addEventListener("click", function () {
        openReelPopup();
      });

      el.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openReelPopup();
        }
      });

      const main = el.closest(".hdt-product-media__main");
      if (main && window.IntersectionObserver) {
        const io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!video) return;
              if (entry.isIntersecting) {
                tryPlayPreview(video);
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.25 },
        );
        io.observe(main);
      } else {
        tryPlayPreview(video);
      }
    }

    function scan(root) {
      (root || document)
        .querySelectorAll("[data-pdp-media-reel-preview]")
        .forEach(bindPreview);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        scan(document);
      });
    } else {
      scan(document);
    }

    document.addEventListener("shopify:section:load", function (e) {
      if (e.target && typeof e.target.querySelectorAll === "function") {
        scan(e.target);
      }
    });
  })();

  /** Mobile product gallery: wheel / trackpad horizontal scroll advances Embla slides */
  (function initProductMediaMobileWheelScroll() {
    function activeSlideIndex(viewport) {
      const slides = viewport.querySelectorAll(
        ".hdt-slider__slide:not([hidden])",
      );
      if (!slides.length) return 0;
      const vr = viewport.getBoundingClientRect();
      let best = 0;
      let bestScore = -1;
      slides.forEach((slide, i) => {
        const r = slide.getBoundingClientRect();
        const overlap = Math.min(r.right, vr.right) - Math.max(r.left, vr.left);
        const score = overlap / Math.max(r.width, 1);
        if (score > bestScore) {
          bestScore = score;
          best = i;
        }
      });
      return best;
    }

    function bindViewport(viewport) {
      if (!viewport || viewport.dataset.pdpWheelNav === "true") return;
      const slider = viewport.closest("hdt-slider");
      if (!slider || typeof slider.goToIndex !== "function") return;

      viewport.dataset.pdpWheelNav = "true";

      viewport.addEventListener(
        "wheel",
        (e) => {
          if (!window.matchMedia("(max-width: 767px)").matches) return;

          const dx = e.deltaX;
          const dy = e.deltaY;
          const dominantX =
            Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 0.5;
          const shiftVertical =
            e.shiftKey &&
            Math.abs(dy) > Math.abs(dx) &&
            Math.abs(dy) > 0.5;
          if (!dominantX && !shiftVertical) return;

          if (typeof slider.isActive === "boolean" && !slider.isActive) return;

          const slides = viewport.querySelectorAll(
            ".hdt-slider__slide:not([hidden])",
          );
          if (slides.length <= 1) return;

          const delta = dominantX ? dx : dy;
          if (Math.abs(delta) < 0.5) return;

          e.preventDefault();

          const idx = activeSlideIndex(viewport);
          const last = slides.length - 1;
          const next =
            delta > 0 ? Math.min(idx + 1, last) : Math.max(idx - 1, 0);
          if (next !== idx) slider.goToIndex(next);
        },
        { passive: false },
      );
    }

    function scan(root) {
      const el = root && root.querySelectorAll ? root : document;
      el.querySelectorAll(
        ".product-media-mobile .hdt-product-media__main .hdt-slider__viewport",
      ).forEach(bindViewport);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => scan(document));
    } else {
      scan(document);
    }

    document.addEventListener("shopify:section:load", (e) => {
      if (e.target && e.target.querySelectorAll) scan(e.target);
    });
  })();

  /** Quick view: carousel images open PDP instead of the media lightbox */
  document.addEventListener(
    "click",
    function (ev) {
      const quickView = ev.target.closest(".hdt-main-product-quick-view");
      if (!quickView) return;

      const mediaItem = ev.target.closest(
        '.hdt-product-media__main [data-media-type="image"]',
      );
      if (!mediaItem) return;

      if (
        ev.target.closest(
          ".hdt-slider__button, hdt-video-player, .hdt-pdp-media-reel-preview, [data-pdp-media-reel-preview]",
        )
      ) {
        return;
      }

      const url = quickView.getAttribute("data-product-url");
      if (!url) return;

      ev.preventDefault();
      ev.stopImmediatePropagation();
      window.location.assign(url);
    },
    true,
  );

  /** Quick view: max add-to-cart qty (same rule as PDP sticky ATC / ProductForm) */
  (function initQuickViewAtcQtyLimit() {
    let quickViewAtcBypass = false;

    async function syncQuickViewAtcLimit(quickViewRoot) {
      if (!quickViewRoot) return;

      const form = quickViewRoot.querySelector("form");
      const addBtn = quickViewRoot.querySelector('button[name="add"]');
      if (!form || !addBtn || addBtn.classList.contains("hdt-add-to-cart-noyify-btn")) {
        return;
      }

      const variantInput = form.querySelector('input[name="id"]');
      const variantId = variantInput?.value;
      if (!variantId) return;

      const qtyInput = form.querySelector('input[name="quantity"]');
      const requestQty = parseInt(qtyInput?.value || "1", 10) || 1;

      if (typeof Shopify.validateAddToCartQty !== "function") return;

      const validation = await Shopify.validateAddToCartQty(
        variantId,
        requestQty,
        form,
      );
      const atMax = !validation.allowed;

      if (atMax) {
        addBtn.disabled = true;
        addBtn.dataset.atMaxDisabled = "true";
      } else if (addBtn.dataset.atMaxDisabled) {
        addBtn.disabled = false;
        delete addBtn.dataset.atMaxDisabled;
      }
    }

    function bindQuickViewModal() {
      const modal = document.getElementById("hdt-quick-view-modal");
      if (!modal || modal.dataset.atcLimitBound === "true") return;
      modal.dataset.atcLimitBound = "true";

      modal.addEventListener("dialog:afterOpen", () => {
        const quickView = modal.querySelector(".hdt-main-product-quick-view");
        syncQuickViewAtcLimit(quickView);
      });
    }

    document.addEventListener("submit", async function (ev) {
      const form = ev.target;
      if (!form || form.tagName !== "FORM") return;

      const quickView = form.closest(".hdt-main-product-quick-view");
      if (!quickView) return;

      if (quickViewAtcBypass) {
        quickViewAtcBypass = false;
        return;
      }

      const submitter = ev.submitter;
      if (
        submitter &&
        (submitter.classList.contains("hdt-add-to-cart-noyify-btn") ||
          submitter.classList.contains("hdt-sticky-atc__submit--notifyme"))
      ) {
        return;
      }

      ev.preventDefault();
      ev.stopImmediatePropagation();

      const formData = new FormData(form);
      const variantId = formData.get("id");
      const requestQty = parseInt(formData.get("quantity") || "1", 10) || 1;

      if (!variantId || typeof Shopify.validateAddToCartQty !== "function") {
        quickViewAtcBypass = true;
        form.requestSubmit(submitter || undefined);
        return;
      }

      const validation = await Shopify.validateAddToCartQty(
        variantId,
        requestQty,
        form,
      );
      if (!validation.allowed) {
        if (typeof Shopify.cartNotification === "function") {
          Shopify.cartNotification(validation.message, true);
        }
        await syncQuickViewAtcLimit(quickView);
        return;
      }

      quickViewAtcBypass = true;
      form.requestSubmit(submitter || undefined);
    }, true);

    document.addEventListener("cart:change", () => {
      const quickView = document.querySelector(
        "#hdt-quick-view-modal .hdt-main-product-quick-view",
      );
      syncQuickViewAtcLimit(quickView);
    });

    document.addEventListener("variant:change", () => {
      const quickView = document.querySelector(
        "#hdt-quick-view-modal .hdt-main-product-quick-view",
      );
      syncQuickViewAtcLimit(quickView);
    });

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bindQuickViewModal);
    } else {
      bindQuickViewModal();
    }
  })();

  /** PDP header back: delegated click (avoids inline onclick / column width 0 eating taps). */
  document.addEventListener("click", function (ev) {
    const btn = ev.target.closest("[data-pdp-header-back]");
    if (!btn) return;
    ev.preventDefault();
    const wrap = btn.closest("[data-pdp-header-with-back]");
    const fallback =
      (wrap && wrap.getAttribute("data-pdp-header-fallback")) || "/";
    try {
      const ref = document.referrer;
      if (ref) {
        const u = new URL(ref, window.location.href);
        if (
          u.origin === window.location.origin &&
          u.href !== window.location.href
        ) {
          window.history.back();
          return;
        }
      }
    } catch (_) {}
    try {
      if (window.history.length > 1) {
        window.history.back();
        return;
      }
    } catch (_) {}
    window.location.assign(fallback);
  });

  /** PDP web-to-app: device-specific app store link */
  (function initWebToAppPdpWidget() {
    const cta = document.querySelector("[data-web-to-app-pdp-cta]");
    if (!cta) return;
    const ios = cta.getAttribute("data-ios-link");
    const android = cta.getAttribute("data-android-link");
    const ua = navigator.userAgent || navigator.vendor || window.opera || "";
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream && ios) {
      cta.setAttribute("href", ios);
    } else if (/android/i.test(ua) && android) {
      cta.setAttribute("href", android);
    }
    cta.addEventListener("click", function () {
      if (typeof window.dataLayer !== "undefined") {
        window.dataLayer.push({
          event: "pdp_app_install_cta_click",
          page_type: "product",
        });
      }
    });
  })();

  /** Scroll linked-variant carousel so the selected item is visible in its natural order. */
  (function initProductVariantScroll() {
    function scrollItemInHorizontalContainer(scrollEl, selected, pad) {
      if (!scrollEl || !selected) return;
      const padding = pad != null ? pad : 8;
      const containerRect = scrollEl.getBoundingClientRect();
      const itemRect = selected.getBoundingClientRect();
      if (itemRect.width === 0 && itemRect.height === 0) return;

      if (itemRect.left < containerRect.left + padding) {
        scrollEl.scrollLeft += itemRect.left - containerRect.left - padding;
      } else if (itemRect.right > containerRect.right - padding) {
        scrollEl.scrollLeft += itemRect.right - containerRect.right + padding;
      }
    }

    function getVariantContainers(root) {
      if (!root) return Array.from(document.querySelectorAll(".product-variant-container"));
      if (root.classList && root.classList.contains("product-variant-container")) {
        return [root];
      }
      return Array.from(root.querySelectorAll(".product-variant-container"));
    }

    function getReelVariantPickers(root) {
      if (!root) return Array.from(document.querySelectorAll(".reel-variant-picker"));
      if (root.classList && root.classList.contains("reel-variant-picker")) {
        return [root];
      }
      return Array.from(root.querySelectorAll(".reel-variant-picker"));
    }

    function scrollSelectedProductVariantIntoView(root) {
      getVariantContainers(root).forEach(function (container) {
        scrollItemInHorizontalContainer(
          container.querySelector(".hdt-product-form__values"),
          container.querySelector(".hdt-product-form_wrap-link-item.is-selected"),
        );
      });
    }

    function scrollSelectedReelVariantIntoView(root) {
      getReelVariantPickers(root).forEach(function (picker) {
        scrollItemInHorizontalContainer(
          picker.querySelector(".reel-variant-picker__scroll"),
          picker.querySelector(".reel-v-wrap.is-selected"),
        );
      });
    }

    function scheduleScroll(root) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scrollSelectedProductVariantIntoView(root);
          scrollSelectedReelVariantIntoView(root);
        });
      });
    }

    function onReady() {
      scheduleScroll();
    }

    window.scrollSelectedProductVariantIntoView = scrollSelectedProductVariantIntoView;
    window.scrollSelectedReelVariantIntoView = scrollSelectedReelVariantIntoView;

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", onReady);
    } else {
      onReady();
    }

    if (typeof MutationObserver !== "undefined") {
      const observer = new MutationObserver(function (mutations) {
        for (let i = 0; i < mutations.length; i++) {
          const mutation = mutations[i];
          for (let j = 0; j < mutation.addedNodes.length; j++) {
            const node = mutation.addedNodes[j];
            if (node.nodeType !== 1) continue;
            if (
              (node.classList && node.classList.contains("product-variant-container")) ||
              (node.querySelector && node.querySelector(".product-variant-container")) ||
              (node.classList && node.classList.contains("reel-variant-picker")) ||
              (node.querySelector && node.querySelector(".reel-variant-picker"))
            ) {
              setTimeout(function () {
                scheduleScroll(node);
              }, 50);
              return;
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();

  /** Featured collection / carousel video — one active stream at a time */
  (function () {
    const VIDEO_SELECTOR =
      ".hdt-featured-video, .hdt-ccmp-fetured-video video, .hdt-featured-video-wrap video";
    const MIN_VISIBLE_RATIO = 0.4;
    const OBSERVER_OPTIONS = {
      threshold: [0, 0.25, 0.5, 0.75, 1],
      rootMargin: "0px",
    };

    let activeVideo = null;
    let evaluateTimer = null;

    const sharedObserver = new IntersectionObserver(() => {
      scheduleEvaluate();
    }, OBSERVER_OPTIONS);

    function getVideoWrap(video) {
      return video.closest(
        ".hdt-ccmp-fetured-video, .hdt-featured-video-wrap, hdt-video-player",
      );
    }

    function isInActiveTab(video) {
      const tab = video.closest("[tab-item]");
      return !tab || tab.hasAttribute("tab-selected");
    }

    function isVideoVisible(video) {
      if (!video?.isConnected) return false;
      if (!isInActiveTab(video)) return false;
      const rect = video.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return false;
      let node = video;
      while (node && node !== document.documentElement) {
        const style = window.getComputedStyle(node);
        if (
          style.display === "none" ||
          style.visibility === "hidden" ||
          Number(style.opacity) === 0
        ) {
          return false;
        }
        node = node.parentElement;
      }
      return true;
    }

    function getLazyVideoUrl(video) {
      const source = video.querySelector("source");
      if (!source) return "";
      return source.dataset.src || source.getAttribute("data-src") || source.src || "";
    }

    function getVisibilityScore(video) {
      const rect = video.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight || 0;
      const visibleHeight =
        Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
      if (visibleHeight <= 0 || rect.height <= 0) return 0;
      return visibleHeight / rect.height;
    }

    function markVideoLoaded(wrap) {
      if (wrap) wrap.classList.add("is-video-loaded");
    }

    function ensureVideoSource(video) {
      const source = video.querySelector("source");
      const url = getLazyVideoUrl(video);
      if (!source || !url) return false;
      if (!source.dataset.src) {
        source.dataset.src = url;
      }
      if (!source.src) {
        source.src = url;
      }
      if (video.dataset.videoLoadRequested !== url && video.readyState === 0) {
        video.dataset.videoLoadRequested = url;
        video.load();
      }
      return true;
    }

    function isProductVideo(video) {
      return !!video?.closest(".hdt-product-video");
    }

    function pauseOtherVideos(keepVideo) {
      document.querySelectorAll(VIDEO_SELECTOR).forEach((video) => {
        if (video === keepVideo || isProductVideo(video)) return;
        if (!video.paused) {
          video.pause();
        }
      });
    }

    function activateVideo(video) {
      if (!video || !isVideoVisible(video)) return;
      if (activeVideo === video && !video.paused && video.readyState >= 2) {
        return;
      }

      pauseOtherVideos(video);
      activeVideo = video;

      const wrap = getVideoWrap(video);
      if (!ensureVideoSource(video)) return;

      const playWhenReady = () => {
        if (activeVideo !== video || !isVideoVisible(video)) return;
        if (video.readyState < 2) return;
        markVideoLoaded(wrap);
        if (video.paused) {
          video.play().catch(() => {});
        }
      };

      if (video.readyState >= 2) {
        playWhenReady();
        return;
      }

      if (video.dataset.playReadyBound !== "true") {
        video.dataset.playReadyBound = "true";
        video.addEventListener("canplay", playWhenReady);
        video.addEventListener("loadeddata", playWhenReady);
        video.addEventListener("playing", () => markVideoLoaded(wrap));
      }

      video.play().catch(() => {});
    }

    function scheduleEvaluate(delay) {
      clearTimeout(evaluateTimer);
      evaluateTimer = setTimeout(evaluateActiveVideo, delay || 80);
    }

    function evaluateActiveVideo() {
      const candidates = Array.from(document.querySelectorAll(VIDEO_SELECTOR))
        .filter(
          (video) =>
            video.dataset.featuredVideoObserved === "true" &&
            !isProductVideo(video) &&
            isVideoVisible(video),
        )
        .map((video) => ({ video, score: getVisibilityScore(video) }))
        .filter((item) => item.score >= MIN_VISIBLE_RATIO)
        .sort((a, b) => b.score - a.score);

      if (!candidates.length) {
        document.querySelectorAll(VIDEO_SELECTOR).forEach((video) => {
          if (isProductVideo(video)) return;
          if (!video.paused) video.pause();
        });
        activeVideo = null;
        return;
      }

      activateVideo(candidates[0].video);
    }

    function bindFeaturedVideo(video) {
      const wrap = getVideoWrap(video);
      if (!wrap || video.dataset.featuredVideoObserved === "true") return;
      video.dataset.featuredVideoObserved = "true";
      sharedObserver.observe(video);
    }

    function bindVideoPlayer(player) {
      if (player.dataset.shimmerObserved === "true") return;
      player.dataset.shimmerObserved = "true";

      const tryBind = () => {
        const video = player.querySelector("video");
        if (video) bindFeaturedVideo(video);
      };

      tryBind();
      const observer = new MutationObserver(tryBind);
      observer.observe(player, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["loaded"],
      });
      setTimeout(() => observer.disconnect(), 15000);
    }

    function bindTabPanels(scope) {
      scope.querySelectorAll("[tab-item]").forEach((tab) => {
        if (tab.dataset.videoTabBound === "true") return;
        tab.dataset.videoTabBound = "true";
        new MutationObserver(() => {
          tab.querySelectorAll(VIDEO_SELECTOR).forEach((video) => {
            if (!tab.hasAttribute("tab-selected") && !video.paused) {
              video.pause();
            }
          });
          scheduleEvaluate(120);
        }).observe(tab, { attributes: true, attributeFilter: ["tab-selected"] });
      });
    }

    function bindCarousels(scope) {
      scope.querySelectorAll("hdt-slider").forEach((slider) => {
        if (slider.dataset.videoSlideBound === "true") return;
        if (!slider.querySelector(VIDEO_SELECTOR)) return;
        slider.dataset.videoSlideBound = "true";
        slider.addEventListener("select:slide", () => {
          scheduleEvaluate(120);
        });
      });
    }

    function scan(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll(VIDEO_SELECTOR).forEach(bindFeaturedVideo);
      scope
        .querySelectorAll("hdt-video-player.hdt-featured-video-wrap")
        .forEach(bindVideoPlayer);
      bindTabPanels(scope);
      bindCarousels(scope);
      scheduleEvaluate(120);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => scan(document));
    } else {
      scan(document);
    }

    document.addEventListener("shopify:section:load", (e) => {
      if (e.target) scan(e.target);
    });

    document.addEventListener("tabcontent:loaded", (e) => {
      scan(e.detail?.target || e.target || document);
    });

    document.addEventListener("lazyload:section-loaded", (e) => {
      scan(e.detail?.slot || e.detail?.sectionEl || document);
    });

    document.addEventListener("click", (e) => {
      if (!e.target.closest("button.hdt-tabs-item-title, hdt-tab button")) return;
      scheduleEvaluate(200);
    });
  })();


  /** Cart quantity reconciliation: clamp stale quantities to latest max limits. */
  (function initCartQuantityReconciliation() {
    let isReconciling = false;
    let reconcileTimer = null;

    function getCartLineQtyInputs() {
      return Array.from(
        document.querySelectorAll('input[name="updates[]"][data-index][max]'),
      );
    }

    function collectOverLimitLines() {
      const updates = [];
      getCartLineQtyInputs().forEach((input) => {
        const line = parseInt(input.getAttribute("data-index"), 10);
        const max = parseInt(input.getAttribute("max"), 10);
        const qty = parseInt(input.value, 10);
        if (
          Number.isInteger(line) &&
          Number.isInteger(max) &&
          Number.isInteger(qty) &&
          max >= 0 &&
          qty > max
        ) {
          updates.push({
            line,
            fromQty: qty,
            toQty: max,
            title: input.getAttribute("aria-label") || "item",
          });
        }
      });
      return updates;
    }

    async function clampLineQuantity(line, quantity) {
      const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ line, quantity }),
      });
      if (!response.ok) {
        throw new Error(`Failed to clamp line ${line}`);
      }
      return response.json();
    }

    function notifyQtyLimitChange(changes) {
      if (!changes.length) return;
      const summary =
        changes.length === 1
          ? `Purchase limit updated. Quantity adjusted from ${changes[0].fromQty} to ${changes[0].toQty}.`
          : `Purchase limits updated. ${changes.length} items were adjusted to allowed quantities.`;
      if (typeof Shopify.cartNotification === "function") {
        Shopify.cartNotification(summary, true);
      }
    }

    async function reconcileCartQuantities() {
      if (isReconciling) return;
      const updates = collectOverLimitLines();
      if (!updates.length) return;
      isReconciling = true;
      try {
        let cart = null;
        for (const update of updates) {
          cart = await clampLineQuantity(update.line, update.toQty);
        }
        notifyQtyLimitChange(updates);
        if (!cart || !Array.isArray(cart.items)) {
          cart =
            typeof createCartPromise === "function"
              ? await createCartPromise()
              : null;
        }
        if (cart && Array.isArray(cart.items)) {
          document.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: { cart, baseEvent: "qty-limit:reconcile" },
            }),
          );
          document.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: { cart, baseEvent: "qty-limit:reconcile" },
            }),
          );
        }
      } catch (error) {
        console.error("Cart quantity reconciliation failed:", error);
      } finally {
        isReconciling = false;
      }
    }

    function scheduleReconcile() {
      if (reconcileTimer) clearTimeout(reconcileTimer);
      reconcileTimer = setTimeout(reconcileCartQuantities, 150);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", scheduleReconcile);
    } else {
      scheduleReconcile();
    }
    document.addEventListener("cart:change", scheduleReconcile);
    document.addEventListener("cart:refresh", scheduleReconcile);
    document.addEventListener("lazyhtml:added", scheduleReconcile);
  })();

// Mobile cart button: keep default bg, briefly flash dark green on every successful ATC.
(function initMobileCartAtcFlash() {
  const FLASH_CLASS = "hdt-cart-atc-flash";
  const FLASH_MS = 1000;
  const flashTimers = new WeakMap();
  let lastItemCount = null;

  function getCartButtons() {
    return document.querySelectorAll(".hdt-section-toolbar-mobile-cart");
  }

  function readBadgeItemCount() {
    const countEl = document.querySelector(
      ".hdt-section-toolbar-mobile-cart hdt-cart-count",
    );
    if (!countEl) return null;
    const parsed = parseInt(String(countEl.textContent || "").trim(), 10);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function syncMobileCartToolbarUI(itemCount) {
    const count = itemCount != null ? itemCount : 0;
    const hasItems = count > 0;
    getCartButtons().forEach((cartEl) => {
      // Color is no longer tied to these classes; keep them cleared so legacy CSS stays inert.
      cartEl.classList.remove("hdt-cart-count-one", "hdt-cart-count-many");

      const activeIcon = cartEl.querySelector(".cart-active-state-icon");
      const normalIcon = cartEl.querySelector(".cart-normal-state-icon");
      const countEl = cartEl.querySelector("hdt-cart-count");

      if (activeIcon) {
        activeIcon.classList.toggle("show-active-icon", hasItems);
        activeIcon.classList.toggle("hide-active-icon", !hasItems);
      }
      if (normalIcon) {
        normalIcon.classList.toggle("hide-active-icon", hasItems);
        normalIcon.classList.toggle("show-active-icon", !hasItems);
      }
      if (countEl) {
        countEl.classList.toggle("hide-cart-counter", !hasItems);
      }
    });
  }

  function flashMobileCartButtons() {
    getCartButtons().forEach((cartEl) => {
      cartEl.classList.remove(FLASH_CLASS);
      // Restart CSS animation when ATC fires again while a flash is mid-flight.
      void cartEl.offsetWidth;
      cartEl.classList.add(FLASH_CLASS);

      const prevTimer = flashTimers.get(cartEl);
      if (prevTimer) clearTimeout(prevTimer);
      flashTimers.set(
        cartEl,
        setTimeout(() => {
          cartEl.classList.remove(FLASH_CLASS);
          flashTimers.delete(cartEl);
        }, FLASH_MS),
      );
    });
  }

  function onCartChange(event) {
    const cart = event?.detail?.cart;
    if (!cart || cart.item_count == null) return;

    const count = cart.item_count;
    const baseEvent = event.detail?.baseEvent;
    const increased = lastItemCount != null && count > lastItemCount;
    // Product form ATC sets baseEvent; custom ATC paths (reels/try-on) often omit it.
    const shouldFlash =
      baseEvent === "variant:add" || (!baseEvent && increased);

    syncMobileCartToolbarUI(count);
    if (shouldFlash) flashMobileCartButtons();
    lastItemCount = count;
  }

  function seedItemCount() {
    if (lastItemCount != null) return;
    lastItemCount = readBadgeItemCount();
  }

  window.syncMobileCartToolbarUI = syncMobileCartToolbarUI;
  window.flashMobileCartButtons = flashMobileCartButtons;

  document.addEventListener("cart:change", onCartChange);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      seedItemCount();
      syncMobileCartToolbarUI(lastItemCount || 0);
    });
  } else {
    seedItemCount();
    syncMobileCartToolbarUI(lastItemCount || 0);
  }
})();

/** Update carousel heading / background from active product metafields */
(function () {
  const SECTION_SEL = "[data-carousel-theme-sync]";

  function parseColors(raw) {
    if (!raw) return null;
    const value = String(raw).trim();
    if (!value) return null;
    if (value.startsWith("{")) {
      try {
        const json = JSON.parse(value);
        return {
          top: json.top || json.bg_color_top || "",
          bottom: json.bottom || json.bg_color_bottom || json.top || "",
        };
      } catch (_) {}
    }
    const parts = value.split(",").map((part) => part.trim()).filter(Boolean);
    if (!parts.length) return null;
    return { top: parts[0], bottom: parts[1] || parts[0] };
  }

  function setImageSrc(img, url) {
    if (!img) return;
    if (!url) {
      img.hidden = true;
      img.removeAttribute("src");
      img.removeAttribute("srcset");
      return;
    }
    img.hidden = false;
    img.src = url;
    img.removeAttribute("srcset");
  }

  function normalizeRichtextHtml(html) {
    if (!html) return "";
    const value = String(html).trim();
    if (!value) return "";
    // Guard against raw richtext AST dumps if an old card is still cached
    if (value.startsWith('{"type"') || value.startsWith('{"Type"')) return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = value;
    const wrap = tmp.querySelector(".metafield-rich_text_field");
    return wrap ? wrap.innerHTML : value;
  }

  function applyTheme(section, data) {
    const heading = section.querySelector(".hdt-sec-heading");
    const subheading = section.querySelector(".hdt-sec-subheading");
    const sectionHead = section.querySelector(".hdt-section-head");
    const bgWrap = section.querySelector(".hdt-section-bg-img");
    const bgDesktop = bgWrap?.querySelector(".hdt-section_bg_image_desktop");
    const bgMobile = bgWrap?.querySelector(".hdt-section_bg_image_mobile");

    if (heading && data.heading != null) {
      let html = normalizeRichtextHtml(data.heading);
      if (!html) {
        html = normalizeRichtextHtml(section.dataset.defaultHeading || "");
      }
      heading.innerHTML = html;
      heading.hidden = !html;
    }
    if (subheading && data.subheading != null) {
      let html = normalizeRichtextHtml(data.subheading);
      if (!html) {
        html = normalizeRichtextHtml(section.dataset.defaultSubheading || "");
      }
      subheading.innerHTML = html;
      subheading.hidden = !html;
    }

    const accentColor =
      data.headingTextColor || section.dataset.defaultHeadingTextColor || "";

    const setTextColor = (el) => {
      if (!el) return;
      if (accentColor) {
        el.style.color = accentColor;
      } else {
        el.style.removeProperty("color");
      }
    };

    setTextColor(heading);
    setTextColor(subheading);
    section
      .querySelectorAll(".view-all-right-title, .view-all-right-arrow")
      .forEach(setTextColor);

    const viewAllBtn = section.querySelector(".hdt-view-all-btn");
    setTextColor(viewAllBtn);

    const bar = section.querySelector(".hdt-slider__bar");
    const barFill = section.querySelector(".hdt-slider__bar .gJAulb");
    if (bar) {
      if (accentColor) {
        bar.style.background = `color-mix(in srgb, ${accentColor} 18%, transparent)`;
      } else {
        bar.style.removeProperty("background");
      }
    }
    if (barFill) {
      if (accentColor) {
        barFill.style.background = accentColor;
      } else {
        barFill.style.removeProperty("background");
      }
    }

    if (sectionHead) {
      const mobileHeaderBg =
        data.bgHeaderImage || data.bgHeaderImageDesktop || "";
      const desktopHeaderBg =
        data.bgHeaderImageDesktop || data.bgHeaderImage || "";
      if (mobileHeaderBg || desktopHeaderBg) {
        sectionHead.style.setProperty(
          "--mobile_bg_image",
          mobileHeaderBg ? `'${mobileHeaderBg}'` : "",
        );
        sectionHead.style.setProperty(
          "--desktop_bg_image",
          desktopHeaderBg ? `'${desktopHeaderBg}'` : "",
        );
        sectionHead.style.backgroundImage = `url(${desktopHeaderBg || mobileHeaderBg})`;
      } else if (data.resetHeaderBg) {
        const defMobile = section.dataset.defaultBgHeaderImage || "";
        const defDesktop =
          section.dataset.defaultBgHeaderImageDesktop || defMobile;
        if (defMobile || defDesktop) {
          sectionHead.style.setProperty(
            "--mobile_bg_image",
            defMobile ? `'${defMobile}'` : "",
          );
          sectionHead.style.setProperty(
            "--desktop_bg_image",
            defDesktop ? `'${defDesktop}'` : "",
          );
          sectionHead.style.backgroundImage = `url(${defDesktop || defMobile})`;
        } else {
          sectionHead.style.removeProperty("--mobile_bg_image");
          sectionHead.style.removeProperty("--desktop_bg_image");
          sectionHead.style.backgroundImage = "";
        }
      }
    }

    if (bgWrap) {
      const desktopUrl = data.bgImage || "";
      const mobileUrl = data.bgImageMobile || data.bgImage || "";
      const hasImage = !!(desktopUrl || mobileUrl);
      setImageSrc(bgDesktop, desktopUrl);
      setImageSrc(bgMobile, mobileUrl || desktopUrl);
      bgWrap.hidden = !hasImage && !data.colors;
      section.classList.toggle("hdt-has-bg-img", hasImage);
    }

    if (data.colors) {
      if (data.colors.top) {
        section.style.setProperty("--bg_color_top", data.colors.top);
      }
      if (data.colors.bottom) {
        section.style.setProperty("--bg_color_bottom", data.colors.bottom);
      }
    }
  }

  function getDefaults(section) {
    return {
      heading: section.dataset.defaultHeading || "",
      subheading: section.dataset.defaultSubheading || "",
      headingTextColor: section.dataset.defaultHeadingTextColor || "",
      bgHeaderImage: section.dataset.defaultBgHeaderImage || "",
      bgHeaderImageDesktop: section.dataset.defaultBgHeaderImageDesktop || "",
      bgImage: section.dataset.defaultBgImage || "",
      bgImageMobile: section.dataset.defaultBgImageMobile || "",
      colors: parseColors(section.dataset.defaultBgColors || ""),
      resetHeaderBg: true,
    };
  }

  function getCardTheme(card) {
    if (!card) return null;
    const heading = card.getAttribute("data-carousel-heading");
    const subheading = card.getAttribute("data-carousel-subheading");
    const headingTextColor = card.getAttribute(
      "data-carousel-heading-text-color",
    );
    const bgHeaderImage = card.getAttribute("data-carousel-bg-header-image");
    const bgImage = card.getAttribute("data-carousel-bg-image");
    const colorsRaw = card.getAttribute("data-carousel-bg-colors");
    if (
      heading == null &&
      subheading == null &&
      headingTextColor == null &&
      bgHeaderImage == null &&
      bgImage == null &&
      colorsRaw == null
    ) {
      return null;
    }
    return {
      heading: heading != null ? heading : undefined,
      subheading: subheading != null ? subheading : undefined,
      headingTextColor:
        headingTextColor != null ? headingTextColor : undefined,
      bgHeaderImage: bgHeaderImage || "",
      bgHeaderImageDesktop: bgHeaderImage || "",
      bgImage: bgImage || "",
      bgImageMobile: bgImage || "",
      colors: parseColors(colorsRaw || ""),
      resetHeaderBg: !bgHeaderImage,
    };
  }

  function mergeTheme(defaults, override) {
    if (!override) return defaults;
    return {
      heading:
        override.heading !== undefined ? override.heading : defaults.heading,
      subheading:
        override.subheading !== undefined
          ? override.subheading
          : defaults.subheading,
      headingTextColor:
        override.headingTextColor !== undefined
          ? override.headingTextColor
          : defaults.headingTextColor,
      bgHeaderImage: override.bgHeaderImage || defaults.bgHeaderImage,
      bgHeaderImageDesktop:
        override.bgHeaderImageDesktop || defaults.bgHeaderImageDesktop,
      bgImage: override.bgImage || defaults.bgImage,
      bgImageMobile: override.bgImageMobile || defaults.bgImageMobile,
      colors: override.colors || defaults.colors,
      resetHeaderBg: override.resetHeaderBg,
    };
  }

  function getActiveCard(slider) {
    const api = slider._sliderEmblaApi;
    if (api) {
      const index = api.selectedScrollSnap();
      const slides = api.slideNodes();
      const slide = slides[index];
      if (slide) {
        return slide.matches?.("hdt-card-product")
          ? slide
          : slide.querySelector("hdt-card-product");
      }
    }
    return (
      slider.querySelector(".hdt-slider__slide.is-in-view hdt-card-product") ||
      slider.querySelector("hdt-card-product.is-in-view") ||
      slider.querySelector("hdt-card-product")
    );
  }

  function syncSection(section) {
    const slider = section.querySelector("hdt-slider");
    if (!slider) return;
    const defaults = getDefaults(section);
    const card = getActiveCard(slider);
    applyTheme(section, mergeTheme(defaults, getCardTheme(card)));
  }

  function bindSection(section) {
    if (!section || section.dataset.carouselThemeBound === "true") return;
    const slider = section.querySelector("hdt-slider");
    if (!slider) return;
    section.dataset.carouselThemeBound = "true";

    const onSlide = () => syncSection(section);
    slider.addEventListener("init:slide", onSlide);
    slider.addEventListener("select:slide", onSlide);

    customElements.whenDefined("hdt-slider").then(() => {
      requestAnimationFrame(onSlide);
      const retry = setInterval(() => {
        if (slider._sliderEmblaApi) {
          onSlide();
          clearInterval(retry);
        }
      }, 100);
      setTimeout(() => clearInterval(retry), 4000);
    });
  }

  function scan(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SECTION_SEL).forEach(bindSection);
    if (scope.matches?.(SECTION_SEL)) bindSection(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan(document));
  } else {
    scan(document);
  }

  document.addEventListener("shopify:section:load", (e) => {
    if (e.target) scan(e.target);
  });

  document.addEventListener("lazyload:section-loaded", (e) => {
    scan(e.detail?.slot || e.detail?.sectionEl || document);
  });

  document.addEventListener("tabcontent:loaded", (e) => {
    scan(e.detail?.target || e.target || document);
  });
})();

